/*
 * GoQuadros · página de produto (sections/gq-pdp.liquid). Porte do comportamento da PDP D
 * do site atual (goquadros/themes/app/v3/components/pdp-d.php + _frete.php): configurador,
 * simulador por móvel, mockups por combinação com reflexo do vidro, medidas e escala em 3D
 * (gq-3d.js), frete, avaliações, vídeos e barra fixa. O que mudou para a Shopify:
 *   - dados: JSON #gqPdpData impresso pela seção (variantes, metafield goquadros.pdp);
 *   - carrinho: a variante da combinação vai para /cart/add.js e a página segue para /cart;
 *   - frete: tarifas da Shopify para o CEP (cotadas com a peça no carrinho, que volta como estava),
 *     só num clique, em Calcular ou "ver valor do frete" (cada cotação conta como AddToCart nos
 *     pixels); com o CEP salvo (goq_cep), a página abre com o prazo da região e o botão "Remover";
 *   - "salvar minha parede": favoritos do tema neste navegador;
 *   - resumo da escolha (27/10/2026, auditoria do time de desempenho): o que chega, a parede, o acabamento,
 *     a cor, a entrega e a escada de preço (total → com o cupom → com o cupom no Pix), também na barra fixa,
 *     que no computador aparece desde a 1ª tela; as opções mostram a diferença de preço, não o preço cheio.
 */

/* ===== motor de tela do frete (_frete.php) ===== */
(function () {
  if (window.GoQFrete) return;

  // [Shopify] Regra de frete grátis nas configurações da seção; mínimo 0 = sem régua
  // (só mostre a régua quando a mesma regra estiver ativa no frete da Shopify).
  var CFG = {};
  try { CFG = (JSON.parse(document.getElementById("gqPdpData").textContent) || {}).frete || {}; } catch (e) {}
  var MIN      = Number(CFG.min) || 0;
  var AREA_MAX = Number(CFG.area) || 5400;
  var REGIOES  = (CFG.regioes || "Centro-Oeste,Sul,Sudeste").split(",").map(function (r) { return r.trim(); });

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }
  function brl(v) {
    return Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // "18,39" (como vem do backend) -> 18.39
  function num(txt) {
    var n = parseFloat(String(txt == null ? "" : txt).replace(/\./g, "").replace(",", "."));
    return isNaN(n) ? 0 : n;
  }
  function area(size) {
    var p = String(size || "").toLowerCase().replace(/\s/g, "").split("x");
    if (p.length !== 2) return 0;
    var a = parseFloat(p[0]), b = parseFloat(p[1]);
    return (isNaN(a) || isNaN(b)) ? 0 : a * b;
  }

  /* Cartões de opção de envio.
     selectable=true (carrinho): cada cartão é um <label> com o radio que o
     carrinho já escuta (.checkbox-option, id ship_<id>, data-price) — a troca
     de visual NÃO mexe no fluxo que grava a modalidade na venda. */
  function optionsHTML(list, opts) {
    opts = opts || {};
    var selectable = !!opts.selectable;
    var checkedId = opts.checkedId;

    if (!list || !list.length) return "";

    var achou = false;
    if (checkedId != null) {
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(checkedId)) { achou = true; break; }
      }
    }

    return list.map(function (s, i) {
      var free  = String(s.id) === "free";
      var nome  = free ? "FRETE GRÁTIS" : (s.description || "Envio");
      var valor = free ? "R$ 0,00" : ("R$ " + s.value);
      var prazo = (Number(s.time) > 0)
        ? '<span class="goqf-t">Entrega em aproximadamente ' + Number(s.time) + ' dias úteis</span>' : "";
      var corpo = '<span class="goqf-n">' + esc(nome) + prazo + '</span>'
                + '<span class="goqf-v">' + esc(valor) + '</span>';

      if (!selectable) {
        return '<div class="goqf-shp' + (free ? " free" : "") + '">' + corpo + '</div>';
      }

      var marcado = achou ? (String(checkedId) === String(s.id)) : (i === 0);
      return '<label class="goqf-shp' + (free ? " free" : "") + (marcado ? " sel" : "") + '" for="ship_' + esc(s.id) + '">'
           +   '<input type="radio" class="checkbox-option" name="ship" id="ship_' + esc(s.id) + '"'
           +     ' value="' + esc(s.id) + '" data-price="' + esc(s.value) + '"' + (marcado ? " checked" : "") + '>'
           +   corpo
           + '</label>';
    }).join("");
  }

  /* [ago/2026 — layout A] Resumo da cotação.
     A cotação devolve UMA opção (economic ou free) em todos os ramos do cálculo:
     o cliente nunca escolheu nada, e mesmo assim o carrinho desenhava um cartão
     com cara de seleção. Com uma opção só o prazo vira manchete e o valor vai
     para a direita. Com duas ou mais (se um dia existir modalidade expressa) cai
     nos cartões selecionáveis de sempre — por isso optionsHTML continua vivo.
     `selectable` mantém o radio que o carrinho escuta, agora invisível. */
  function resumoHTML(list, opts) {
    opts = opts || {};
    if (!list || !list.length) return "";
    if (list.length > 1) {
      return '<div class="goqf-quote">' + optionsHTML(list, opts) + '</div>';
    }

    var s = list[0];
    var free = String(s.id) === "free";
    var temPrazo = Number(s.time) > 0;
    var prazo = temPrazo
      ? 'Chega em aproximadamente <b>' + Number(s.time) + ' dias úteis</b>'
      : 'Prazo confirmado no checkout';
    // sem prazo na cotação a linha de apoio não faz sentido ("contados após..." do quê?)
    var sub = temPrazo ? '<small>contados após a produção (até 48h úteis)</small>' : "";

    var radio = "";
    if (opts.selectable) {
      radio = '<input type="radio" class="checkbox-option" name="ship" id="ship_' + esc(s.id) + '"'
            + ' value="' + esc(s.id) + '" data-price="' + esc(s.value) + '" checked>';
    }

    return '<div class="goqf-quote">'
         +   '<div class="goqf-head">'
         +     radio
         +     '<div class="goqf-when">' + prazo + sub + '</div>'
         +     '<div class="goqf-cost">'
         +       '<span class="v' + (free ? " free" : "") + '">' + (free ? "Grátis" : "R$ " + esc(s.value)) + '</span>'
         +       '<span class="l">' + esc(free ? "FRETE GRÁTIS" : (s.description || "ENVIO").toUpperCase()) + '</span>'
         +     '</div>'
         +   '</div>'
         + '</div>';
  }

  function loadingHTML(txt) {
    return '<div class="goqf-shp"><span class="goqf-n">' + esc(txt || "Calculando frete…") + '</span></div>';
  }

  /* Régua de frete grátis. `size` é o tamanho da peça ("60x90"): peça com área
     maior que a permitida não entra no grátis — mesma trava do backend. */
  function railHTML(total, opts) {
    opts = opts || {};
    total = Number(total || 0);
    var regioes = REGIOES.join(", ").replace(/, ([^,]*)$/, " e $1");

    if (opts.size && area(opts.size) > AREA_MAX) {
      return 'Peças maiores que 60×90 não entram no frete grátis — o valor sai do cálculo por CEP acima.';
    }
    if (total >= MIN) {
      return '<span class="goqf-ok">Frete grátis garantido para ' + esc(regioes) + ' 😍</span>';
    }
    var falta = MIN - total;
    var pct = Math.max(2, Math.min(100, (total / MIN) * 100));
    return 'Faltam <b>R$ ' + brl(falta) + '</b> para o frete sair de graça'
         + '<span class="goqf-bar"><i style="width:' + pct.toFixed(1) + '%"></i></span>';
  }

  function maskCep(input) {
    if (!input || input.__goqfMask) return;
    input.__goqfMask = true;
    input.setAttribute("inputmode", "numeric");
    input.addEventListener("input", function () {
      var d = (input.value || "").replace(/\D/g, "").slice(0, 8);
      input.value = d.length > 5 ? d.slice(0, 5) + "-" + d.slice(5) : d;
    });
  }

  function bindEnter(input, fn) {
    if (!input) return;
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.keyCode === 13) { e.preventDefault(); fn(); }
    });
  }

  /* CEP lembrado entre as telas: quem já calculou na PDP não redigita no carrinho. */
  function lembrar(cep) {
    try { localStorage.setItem("goq_cep", String(cep || "").replace(/\D/g, "")); } catch (e) {}
  }
  /* "Remover" no campo do CEP (27/10/2026): a PDP e a /cart deixam de usar o CEP. */
  function esquecer() {
    try { localStorage.removeItem("goq_cep"); } catch (e) {}
  }
  function lembrado() {
    try {
      var c = (localStorage.getItem("goq_cep") || "").replace(/\D/g, "");
      return c.length === 8 ? c : "";
    } catch (e) { return ""; }
  }
  function formataCep(cep) {
    var d = String(cep || "").replace(/\D/g, "");
    return d.length === 8 ? d.slice(0, 5) + "-" + d.slice(5) : d;
  }

  /* Destaque do cartão escolhido (o :has() cobre navegador novo; isto cobre o resto). */
  function marcarSelecao(raiz) {
    (raiz || document).querySelectorAll(".goqf-shp").forEach(function (el) {
      var input = el.querySelector(".checkbox-option");
      el.classList.toggle("sel", !!(input && input.checked));
    });
  }

  /* Contador do corte de produção.
     Os segundos vêm do SERVIDOR (data-segundos), não do relógio do aparelho —
     é o relógio do servidor que decide o que entra na produção do dia. Ao zerar,
     a frase troca sozinha para não continuar prometendo "produção de hoje". */
  function two(n) { return (n < 10 ? "0" : "") + n; }

  /* [Shopify] Janela de produção (seg a sex até 18h, horário de São Paulo), antes
     calculada no servidor (goq_frete_corte_estado). Preenche o texto das duas versões:
     contador no computador e frase simples no celular. Desde 23/10/2026 a PDP 5d usa só o
     contador, nas duas larguras, logo acima do botão de compra (.pd-corte). */
  var DIAS = [1, 2, 3, 4, 5], CORTE = (function () {
    var el = document.getElementById("goqfrete-pdpc"), n = el ? Number(el.getAttribute("data-corte")) : 0;
    return n > 0 && n <= 24 ? n : 18;
  })();
  var NOMES = ["", "segunda", "terça", "quarta", "quinta", "sexta", "sábado", "domingo"];
  function corteEstado() {
    var p = {};
    new Intl.DateTimeFormat("en-US", { timeZone: "America/Sao_Paulo", weekday: "short", hour: "numeric", minute: "numeric", second: "numeric", hourCycle: "h23" })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var dia = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[p.weekday] || 1;
    var h = Number(p.hour), m = Number(p.minute), s = Number(p.second);
    if (DIAS.indexOf(dia) >= 0 && h < CORTE) return { aberto: true, segundos: (CORTE - h) * 3600 - m * 60 - s, quando: "hoje" };
    var prox = dia % 7 + 1, passos = 1;
    while (DIAS.indexOf(prox) < 0) { prox = prox % 7 + 1; passos++; }
    return { aberto: false, segundos: 0, quando: passos === 1 ? "amanhã" : NOMES[prox] };
  }
  function montaCorte() {
    var e = corteEstado();
    document.querySelectorAll("[data-goqf-corte]").forEach(function (caixa) {
      caixa.setAttribute("data-segundos", e.segundos);
      var tx = caixa.querySelector(".goqf-corte-tx");
      if (tx) tx.innerHTML = e.aberto
        ? 'Peça em <b data-goqf-cutoff>--:--:--</b> e seu quadro entra na <strong>produção de hoje</strong>'
        : 'Pedidos feitos agora entram na <strong>produção de ' + e.quando + '</strong>';
    });
    document.querySelectorAll("[data-goqf-info]").forEach(function (el) {
      el.innerHTML = e.aberto
        ? 'Peça hoje e seu quadro entra na <strong>produção de hoje</strong>'
        : 'Pedidos feitos agora entram na <strong>produção de ' + e.quando + '</strong>';
    });
  }
  function tickCutoff() {
    var caixas = document.querySelectorAll("[data-goqf-corte]");
    if (!caixas.length) return;

    caixas.forEach(function (caixa) {
      var restante = parseInt(caixa.getAttribute("data-segundos"), 10);
      if (isNaN(restante) || restante <= 0) return; // já está fora da janela

      restante -= 1;
      caixa.setAttribute("data-segundos", restante);

      var alvo = caixa.querySelector("[data-goqf-cutoff]");
      if (restante <= 0) {
        var tx = caixa.querySelector(".goqf-corte-tx");
        if (tx) tx.innerHTML = "Pedidos feitos agora entram na <strong>produção de amanhã</strong>";
        return;
      }
      if (alvo) {
        alvo.textContent = two(Math.floor(restante / 3600)) + ":"
                         + two(Math.floor((restante % 3600) / 60)) + ":"
                         + two(restante % 60);
      }
    });
  }
  // primeira pintura imediata (o servidor já mandou o total, só falta formatar)
  function pintaCutoff() {
    document.querySelectorAll("[data-goqf-corte]").forEach(function (caixa) {
      var s = parseInt(caixa.getAttribute("data-segundos"), 10);
      var alvo = caixa.querySelector("[data-goqf-cutoff]");
      if (alvo && s > 0) {
        alvo.textContent = two(Math.floor(s / 3600)) + ":" + two(Math.floor((s % 3600) / 60)) + ":" + two(s % 60);
      }
    });
  }
  function inicia() { montaCorte(); pintaCutoff(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", inicia); else inicia();
  setInterval(tickCutoff, 1000);

  window.GoQFrete = {
    MIN: MIN, AREA_MAX: AREA_MAX, REGIOES: REGIOES,
    esc: esc, brl: brl, num: num, area: area,
    optionsHTML: optionsHTML, resumoHTML: resumoHTML, loadingHTML: loadingHTML, railHTML: railHTML,
    maskCep: maskCep, bindEnter: bindEnter,
    lembrar: lembrar, lembrado: lembrado, esquecer: esquecer, formataCep: formataCep, corte: corteEstado,
    marcarSelecao: marcarSelecao
  };
})();

/* ===== PDP ===== */

(function(){
"use strict";

// Uma instância por página. Ao trocar o produto, remove eventos e tarefas da
// instância anterior antes de montar a próxima (sem duplicar cliques/carrinho).
var pdpRoot = document.getElementById('pdp-c');
var disposed = false, pdpCleanups = [], pdpTimers = new Set(), pdpFrames = new Set();
function pdpOn(target, type, callback, options){
  target.addEventListener(type, callback, options);
  pdpCleanups.push(function(){ target.removeEventListener(type, callback, options); });
}
function pdpLegacyMedia(target, callback){
  target.addListener(callback);
  pdpCleanups.push(function(){ target.removeListener(callback); });
}
function setTimeout(callback, delay){
  var id = window.setTimeout(function(){ pdpTimers.delete(id); if(!disposed) callback(); },delay);
  pdpTimers.add(id); return id;
}
function requestAnimationFrame(callback){
  var id = window.requestAnimationFrame(function(time){ pdpFrames.delete(id); if(!disposed) callback(time); });
  pdpFrames.add(id); return id;
}
if(window.GoQPdpD) window.GoQPdpD.destroy();
window.GoQPdpD = {
  root:pdpRoot,
  isBusy:function(){ return cartBusy; },
  destroy:function(){
    disposed = true;
    pdpCleanups.forEach(function(cleanup){ cleanup(); });
    pdpTimers.forEach(window.clearTimeout.bind(window));
    pdpFrames.forEach(window.cancelAnimationFrame.bind(window));
  }
};

/* ═══════════ DADOS MEDIDOS ═══════════
   [Shopify] O que a PDP D recebia do PHP vem do JSON impresso pela seção (#gqPdpData):
   variantes (preço e id por tamanho × moldura × vidro × cor), receita dos mockups e artes
   (metafield goquadros.pdp), avaliações e reflexo do vidro. As tabelas abaixo são montadas
   no mesmo formato da PDP D, para o resto do código seguir igual. */
var DATA = JSON.parse(document.getElementById('gqPdpData').textContent);
var RECIPE = DATA.recipe || {};
function normTxt(s){ return String(s == null ? '' : s).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim(); }
function variantFinish(moldura){
  var n = normTxt(moldura), glass = n.indexOf('com vidro') >= 0 ? 1 : 0;
  if(n.indexOf('sem moldura') === 0 || n.indexOf('placa') >= 0) return {fin:'mdf', glass:0};
  if(n.indexOf('canvas') >= 0 || n.indexOf('flutuante') >= 0) return {fin:'canvas', glass:0};
  /* [23/10/2026] Moldura padrão (a Chanfrada do ERP): só os produtos da categoria "Quadros até R$ 399"
     têm essas variantes; nos outros produtos nada muda */
  if(n.indexOf('padrao') === 0) return {fin:'padrao', glass:glass};
  if(n.indexOf('filete') === 0) return {fin:'filete', glass:glass};
  if(n.indexOf('caixa') === 0) return {fin:'caixa', glass:glass};
  return null;
}
function variantColor(cor){ var n = normTxt(cor); return (n === '' || n.indexOf('nao se aplica') === 0) ? '' : n; }
var PRICE = {}, PRICE_GLASS = {}, VARIANTS = {}, VARIANT_FALLBACK = {}, sizePriced = {}, SOLD_COLORS = {};
/* [5d] preço "de" (compare_at_price) por variante e o menor por acabamento × tamanho × vidro */
var CMP = {}, CMPMIN = {};
(DATA.variants || []).forEach(function(v){
  var f = variantFinish(v[2]); if(!f) return;
  var size = String(v[1] || '').toLowerCase().replace(/[×\s]/g,'').replace('×','x');
  var color = variantColor(v[3]), price = Number(v[4]) / 100;
  if(color) SOLD_COLORS[color] = true;
  if(f.glass){
    PRICE_GLASS[f.fin] = PRICE_GLASS[f.fin] || {};
    if(PRICE_GLASS[f.fin][size] == null || price < PRICE_GLASS[f.fin][size]) PRICE_GLASS[f.fin][size] = price;
  } else {
    PRICE[f.fin] = PRICE[f.fin] || {};
    if(!PRICE[f.fin][size] || price < PRICE[f.fin][size][0]) PRICE[f.fin][size] = [price, 1];
    sizePriced[size] = true;
  }
  VARIANTS[f.fin+'|'+size+'|'+f.glass+'|'+color] = v[0];
  var cmp = Number(v[6]) / 100;
  if(cmp > price){
    CMP[f.fin+'|'+size+'|'+f.glass+'|'+color] = cmp;
    var cmpKey = f.fin+'|'+size+'|'+f.glass;
    if(CMPMIN[cmpKey] == null || cmp < CMPMIN[cmpKey]) CMPMIN[cmpKey] = cmp;
  }
  if(!VARIANT_FALLBACK[f.fin+'|'+size+'|'+f.glass]) VARIANT_FALLBACK[f.fin+'|'+size+'|'+f.glass] = v[0];
});
/* tamanho: chave do cadastro ("120x80") e dimensões ANUNCIADAS (menor×maior); 20x30 não é ofertado */
var SIZES = Object.keys(sizePriced).map(function(k){
  var m = k.match(/^(\d+)x(\d+)$/); if(!m) return null;
  var a = Number(m[1]), b = Number(m[2]);
  return {k:k, w:Math.min(a,b), h:Math.max(a,b)};
}).filter(Boolean);
var SIZES_SHOWN = SIZES.filter(function(s){ return s.k !== '20x30'; });
if(SIZES_SHOWN.length) SIZES = SIZES_SHOWN;
SIZES.sort(function(a,b){ return a.w*a.h - b.w*b.h; });
var MAXW = SIZES.length ? Math.max.apply(null, SIZES.map(function(s){ return s.w; })) : 1;
/* [mkp] {tamanho: url} das fotos de ambiente, vindo das linhas product_image ads = 2
   (o mesmo $mkp_map_c que a secao das 3 paredes usa). A pagina SABE o que existe —
   tamanho sem linha simplesmente nao troca a foto, em vez de pedir uma URL e tomar 404. */
var MKP = {};
(function buildMockups(m){
  if(!m || !m.c) return;
  var fins = ['placa'];
  ['filete','caixa','flutuante'].forEach(function(f){ ['preta','branca','tabaco','freijo','crua'].forEach(function(c){ fins.push(f+'-'+c); }); });
  m.c.forEach(function(scene){ m.z.forEach(function(size){ fins.forEach(function(fin){
    var key = scene+'-'+size+'-'+fin;
    MKP[key] = (fin === 'placa' ? m.p : m.b) + m.s + key + '.webp';
  }); }); });
  Object.keys(m.x || {}).forEach(function(key){ if(m.x[key]) MKP[key] = m.x[key]; else delete MKP[key]; });
})(RECIPE.m);
var CATALOG_FIRST_PILOT = !!DATA.hero;
var CONFIG_MKP_ACTIVE = !CATALOG_FIRST_PILOT;
/* Quadro sem mockups (cadastros a partir de 30/09/2026): abre na foto de ambiente do produto
   e, na primeira escolha de tamanho/moldura/cor, a galeria passa para o quadro em 3D, que
   segue as escolhas como os mockups seguiriam (celular e computador). */
var HAS_MKP = Object.keys(MKP).length > 0;
var NO_MKP_3D_SHOWN = false;
function activateConfigMockups(){
  if(!HAS_MKP && !NO_MKP_3D_SHOWN && VIEW3D.available && GAL_SLIDE === 'ambiente'){
    NO_MKP_3D_SHOWN = true;
    setGalSlide('3d');
  }
  CONFIG_MKP_ACTIVE = true;
  document.getElementById('pdp-c').classList.remove('is-catalog-preview');
}
/* Artes de impressão (uma por peça): as fotos "arte da peça" do produto, na CDN da Shopify;
   sem elas, as da receita (CDN da Vuzi). */
var ARTS = ((DATA.arts && DATA.arts.length ? DATA.arts : RECIPE.a) || []).slice(0, 8);
/* Fotos de referência dos acabamentos: molduras recebem a cor selecionada. */
var FRAME_CLOSE_BASE = 'https://cdn.02.vuzi.com.br/goquadros/pdp-mkp/molduras-close/';
var FINISH_PHOTOS = {
  mdf: 'https://cdn.02.vuzi.com.br/goquadros/pdp-mkp/placa-mdf-detalhe-v1.webp',
  filete: {
    preta: FRAME_CLOSE_BASE + 'filete-preta.webp',
    branca: FRAME_CLOSE_BASE + 'filete-branca.webp',
    tabaco: FRAME_CLOSE_BASE + 'filete-tabaco.webp',
    freijo: FRAME_CLOSE_BASE + 'filete-freijo.webp',
    crua: FRAME_CLOSE_BASE + 'filete-crua.webp'
  },
  caixa: {
    preta: FRAME_CLOSE_BASE + 'caixa-preta.webp',
    branca: FRAME_CLOSE_BASE + 'caixa-branca-v2.webp',
    tabaco: FRAME_CLOSE_BASE + 'caixa-tabaco.webp',
    freijo: FRAME_CLOSE_BASE + 'caixa-freijo.webp',
    crua: FRAME_CLOSE_BASE + 'caixa-crua.webp'
  },
  canvas: {
    preta: FRAME_CLOSE_BASE + 'canvas-preta.webp',
    branca: FRAME_CLOSE_BASE + 'canvas-branca.webp',
    tabaco: FRAME_CLOSE_BASE + 'canvas-tabaco.webp',
    freijo: FRAME_CLOSE_BASE + 'canvas-freijo.webp',
    crua: FRAME_CLOSE_BASE + 'canvas-crua.webp'
  }
};
function finishPhoto(fin,color){
  /* [22/10/2026] amostras leves do tema (DATA.swatches: o recorte do canto em 180×180, ~3 KB); a foto
     da Vuzi (50–170 KB) só se faltar alguma */
  var light = DATA.swatches && DATA.swatches[finVisual(fin) + '-' + color];
  if(light) return light;
  var photo = FINISH_PHOTOS[finVisual(fin)] || FINISH_PHOTOS.mdf;
  if(typeof photo === 'string') return photo;
  return photo[color] || photo.preta || FINISH_PHOTOS.mdf;
}
var FINISH_META = {
  mdf: 'sem moldura · a placa vai direto na parede · linha de entrada',
  canvas: '1 cm de frente · 3,8 cm de profundidade · a moldura esconde a caixa de energia',
  caixa: '2 cm de frente · 3 cm de profundidade · presença maior na parede',
  filete: '0,8 cm de frente · 2 cm de profundidade · a moldura mais discreta',
  padrao: '1,5 cm de frente · 1 cm de altura · a moldura padrão'
};
/* [22/10/2026] A linha embaixo das molduras (#finSpec) fica numa linha só (pedido do Renan): frente,
   profundidade e característica, na versão curta. A FINISH_META, longa, segue nos outros lugares. */
var FINISH_LINE = {
  mdf: 'Sem moldura · direto na parede · linha de entrada',
  canvas: 'Frente 1 cm · Prof. 3,8 cm · esconde caixa de energia',
  caixa: 'Frente 2 cm · Prof. 3 cm · mais presença na parede',
  filete: 'Frente 0,8 cm · Prof. 2 cm · a mais discreta',
  padrao: 'Frente 1,5 cm · Altura 1 cm · moldura padrão'
};
/* [23/10/2026] A moldura padrão ainda não tem montagens nas paredes nem amostras de cor próprias: usa as
   do Filete, a moldura mais parecida (só a imagem; nome, medida e preço são os dela) */
function finVisual(fin){ return fin === 'padrao' ? 'filete' : fin; }
/* [23/10/2026] No 3D (galeria e visualizador) a padrão tem medida própria quando o arquivo do 3D avisa que
   a conhece (padrao: true no window.GQ3DGaleria / GQ3DViewer, remendo à mão até entrar no código-fonte).
   Um 3D gerado de novo sem ela volta ao Filete em vez de quebrar. */
function fin3D(api){
  if(S.fin === 'mdf') return 'placa';
  if(S.fin === 'padrao' && api && api.padrao) return 'padrao';
  return finVisual(S.fin);
}
var FINS = [
  {k:'mdf',    nome:'Sem moldura (placa)', desc:'a “Placa MDF” do site',           mat:'Papel fotográfico fosco'},
  {k:'filete', nome:'Filete',              desc:'0,8 cm frontal · 2 cm de profund.', mat:'Papel fotográfico fosco'},
  {k:'padrao', nome:'Padrão',              desc:'1,5 cm frontal · 1 cm de altura',   mat:'Papel fotográfico fosco'},
  {k:'caixa',  nome:'Caixa',               desc:'2 cm frontal · 3 cm de profund.', mat:'Papel fotográfico fosco'},
  {k:'canvas', nome:'Canvas / Flutuante',  desc:'1 cm frontal · 3,8 cm · esconde caixa de energia', mat:'Canvas'}
];
/* preço = trio completo. true = medido clicando na página em 31/08/2026 */
/* PRICE / PRICE_GLASS: montados acima a partir das variantes da Shopify. */
var PRODUCT_HANDLE = DATA.product.handle;
var PDP_HERO_ABOVE_IMAGE = true;
var PDP_COLLAPSE = /[?&]collapse=1(&|$)/.test(window.location.search);
/* Modo categoria (PDP D com $pdp_inline_c): a categoria interativa monta esta PDP dentro da página
   (assets/gq-interativa.js) e marca o #pdp-c com is-category-embed antes de rodar este arquivo. Na
   página de produto a classe não existe e nada muda. */
var PDP_CATEGORY_EMBED = pdpRoot.classList.contains('is-category-embed');
var PRODUCT_PAGE_PATH = DATA.product.url;
var WHATSAPP = DATA.whatsapp || '5517996737140';
var PIX_OFF = Number(DATA.pix) || 0;
// Na PDP D a categoria usava os controles mobile em todas as larguras. Aqui não: o gq-pdp5d.css
// redesenhou os controles com outros degraus (749/767px), e o mobile no computador misturava os dois
// layouts (22/10/2026). A categoria interativa usa o layout de cada largura, como a página de produto.
function usesMobileControls(){
  return window.matchMedia('(max-width: 768px)').matches;
}
var PRODUCT_TRACK = {name:DATA.product.title, id:DATA.product.codgen || String(DATA.product.id), category:DATA.product.category || ''};
var AVULSO = 99.90;                 /* medido na categoria /quadros: "a partir de R$ 99,90" */
var PIECES = Math.max(1, Number(RECIPE.n) || ARTS.length || 1); /* [decisão 01/09] nº real de peças (artes ads=0) */
var PRODUCT_ORIENTATION = RECIPE.o || 'retrato';
var CONJ = PIECES===3?'Trio':(PIECES===2?'Duo':(PIECES>3?PIECES+' peças':'Quadro'));
var GAP = 4;                        /* cm entre peças — FAQ da loja recomenda 3 a 5 */
/* Fichas técnicas do designer. A chave usa o tamanho do ERP (120x80/150x100),
   que é também o nome dos arquivos, mesmo quando a peça está em retrato na parede. */
var TECH_SHEET_BASE = 'https://cdn.02.vuzi.com.br/goquadros/pdp-mkp/ficha-tecnica/';
var TECH_SHEET_TYPE = {1:['avulso','av'],2:['duo','duo'],3:['trio','trio']};
var TECH_SHEET_FIN = {mdf:'sm',filete:'filet',caixa:'cx',canvas:'flut'};
/* Conferência de 04/09: esses dois JPGs chegaram com cotas incompatíveis. Não são
   exibidos até o arquivo do designer ser substituído no mesmo endereço. */
var TECH_SHEET_PENDING = {'trio|30x45|canvas':true,'trio|120x80|canvas':true};
var SCALE_HUMAN_GAP = 55;           /* cm entre a pessoa e a lateral do conjunto */
var SCALE_RULER_GAP = 18;           /* cm de respiro entre a régua e a modelo */
var SCALE_WALL_HEIGHT = 260;        /* parede de referência, explicitamente rotulada */
var SCALE_ART_CENTER = 145;         /* centro das peças a 1,45 m do piso */
var SCALE_PERSON_RATIO = 454/1416;  /* proporção do recorte hospedado na CDN */
var COLORS = [
  {k:'preta', nome:'Preta',   c:'#221F1D'},
  {k:'branca',nome:'Branca',  c:'#F3F1EC'},
  {k:'tabaco',nome:'Tabaco',  c:'#876444'},
  {k:'freijo',nome:'Freijó',  c:'#B24A25'},
  {k:'crua',  nome:'Crua',    c:'#DDD0BB'}
];
/* Só as cores que o produto vende: a moldura padrão não tem Freijó (23/10/2026). Sem isso, a cor
   escolhida caía em outra variante na sacola (VARIANT_FALLBACK) */
var COLORS_SOLD = COLORS.filter(function(c){ return SOLD_COLORS[c.k]; });
if(COLORS_SOLD.length) COLORS = COLORS_SOLD;
/* Recomendações proporcionais para cada ambiente disponível no lote do produto. */
var SIM = {
  'aparador|90':'30x45','aparador|120':'30x45','aparador|160':'40x60',
  'buffet|180':'50x70','buffet|200':'50x70',
  'cama|casal':'30x45','cama|queen':'40x60','cama|king':'50x70',
  'hack|160':'40x60','hack|200':'50x70','hack|240':'60x90',
  'mesaesc|120':'30x45','mesaesc|160':'40x60',
  'mesajantar|160':'40x60','mesajantar|180':'50x70',
  'sofa|160':'40x60','sofa|200':'50x70','sofa|240':'60x90'
};
var LARG = {
  aparador: [{k:'90',l:'90 cm',w:90},{k:'120',l:'120 cm',w:120},{k:'160',l:'160 cm',w:160}],
  buffet:   [{k:'180',l:'180 cm',w:180},{k:'200',l:'200 cm',w:200}],
  cama:     [{k:'casal',l:'Casal',w:138},{k:'queen',l:'Queen',w:158},{k:'king',l:'King',w:193}],
  hack:     [{k:'160',l:'160 cm',w:160},{k:'200',l:'200 cm',w:200},{k:'240',l:'240 cm',w:240}],
  mesaesc:  [{k:'120',l:'120 cm',w:120},{k:'160',l:'160 cm',w:160}],
  mesajantar:[{k:'160',l:'160 cm',w:160},{k:'180',l:'180 cm',w:180}],
  sofa:     [{k:'160',l:'160 cm',w:160},{k:'200',l:'200 cm',w:200},{k:'240',l:'240 cm',w:240}]
};
var MKP_LARG = {};
((RECIPE.m && RECIPE.m.c) || []).forEach(function(scene){
  var m = scene.match(/^(aparador|buffet|cama|hack|mesaesc|mesajantar|sofa)(.+)$/); if(!m) return;
  (MKP_LARG[m[1]] = MKP_LARG[m[1]] || []).push(m[2]);
});
/* Larguras do "Me ajude a escolher": na galeria antiga, só as que têm foto de mockup do produto. Com a
   galeria 3D, todas (os ambientes do 3D têm sofá e cama em todas as medidas); antes, um duo sem foto de
   cama king não oferecia a king. */
if(!(DATA.galeriaAssets && (DATA.arts3d || []).length)) Object.keys(LARG).forEach(function(mov){
  var available = MKP_LARG[mov] || [];
  LARG[mov] = LARG[mov].filter(function(item){ return available.indexOf(item.k) !== -1; });
  if(!LARG[mov].length) delete LARG[mov];
});
var REVIEWS = DATA.reviews || []; /* [01/09] Google real; campos já escapados */

/* Palcos do 3D (medidas e escala): na PDP D cada include de product-3d.php chamava
   GoQ3D.init logo depois da marcação; aqui a seção só imprime a marcação. */
if(window.GoQ3D){
  GoQ3D.init({id:'specmain', domId:'goq3d-specmain', scope:'#galSpecAttrs', attrGroup:PRODUCT_ORIENTATION, fitMargin:0.96, maxScale:2.6});
  GoQ3D.init({id:'scalemain', domId:'goq3d-scalemain', scope:'#galSpecAttrs', attrGroup:PRODUCT_ORIENTATION, fitMargin:1, maxScale:1});
}

/* "Acabamentos em ambientes reais": três cenas fixas; quando o produto não tem a cena
   (kits que não cabem na cama ou no aparador, quadrados sem 50×70), usa outro ambiente
   do mesmo tamanho e, sem ele, outro tamanho — a mesma regra da PDP D, que montava estes
   cards no servidor. */
(function drawFinishEnvironments(){
  /* [5d] Os cards vêm dos blocos da seção gq-pdp5d-ambientes (data-mkp-key = cena-tamanho-moldura-cor).
     Sem a cena exata, usa outro ambiente do mesmo tamanho e acabamento e, sem ele, outro tamanho —
     a mesma regra da PDP D. Sem foto nenhuma, o card some; sem card, a seção some. */
  var section = document.querySelector('[data-gq5-ambientes]'); if(!section) return;
  var names = {aparador:'Hall · aparador', buffet:'Sala · buffet', cama:'Quarto · cama', hack:'Sala · rack', mesaesc:'Escritório · mesa', mesajantar:'Sala de jantar · mesa', sofa:'Sala · sofá'};
  var keys = Object.keys(MKP).sort(), shown = 0;
  var esc = function(v){ return String(v || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
  function sceneLabel(k){
    var m = k.match(/^(aparador|buffet|cama|hack|mesaesc|mesajantar|sofa)([a-z0-9]+)-(\d+)x(\d+)-/);
    if(!m) return '';
    return names[m[1]] + (/^\d+$/.test(m[2]) ? ' de ' + (Number(m[2]) / 100).toFixed(2).replace('.', ',') + ' m' : ' ' + m[2]) + ' · ' + CONJ.toLowerCase() + ' ' + m[3] + '×' + m[4];
  }
  [].slice.call(section.querySelectorAll('[data-mkp-key]')).forEach(function(card){
    var key = String(card.getAttribute('data-mkp-key') || '').trim().toLowerCase(), src = MKP[key] || '', used = src ? key : '';
    if(!src && key){
      var parts = key.split('-');
      [ '-' + parts.slice(1).join('-'), '-' + parts.slice(2).join('-') ].some(function(suffix){
        return keys.some(function(k){
          if(k.slice(-suffix.length) !== suffix) return false;
          src = MKP[k]; used = k; return true;
        });
      });
    }
    if(!src){ card.hidden = true; return; }
    var slot = card.querySelector('[data-mkp-slot]'), meta = card.querySelector('[data-mkp-meta]');
    var title = (card.querySelector('strong') || {}).textContent || '';
    if(slot) slot.innerHTML = '<img src="'+esc(src)+'" alt="'+esc(CONJ+' · '+title)+'" loading="lazy" decoding="async" onerror="this.closest(\'[data-mkp-key]\').hidden=true">';
    if(meta && !meta.textContent.trim()) meta.textContent = sceneLabel(used);
    shown++;
  });
  if(!shown) section.hidden = true;
})();

/* ═══════════ ESTADO ═══════════ */
/* [5d] A página abre numa combinação vendida de verdade: pedidos pagos do site antigo de
   09/10/2025 a 09/10/2026, sem os personalizados (data/transform/pedidos/orders.jsonl).
   - Tamanho: 50×70 nos retangulares desde 22/10/2026 (pedido do time). O 60×90 é o mais vendido
     (≈40% em avulso, duo e trio), mas abria em R$ 649,90 no duo enquanto a categoria anuncia
     "a partir de R$ 149,90"; o 50×70 é o degrau de baixo. Nos quadrados, 30×30 no avulso (31%)
     e 60×60 no duo (33%).
   - Acabamento: filete com vidro (30% no avulso, 35% no duo, 58% no trio).
   - Cor: preta no avulso (37%) e no trio (58%); no duo, a antiga "Frejó", hoje Crua (32%).
   Sem a medida no produto, o mais perto dela; sem vidro nessa medida, sem vidro. Links
   compartilhados (?variant=, gq_*) continuam valendo, logo abaixo. */
var SQUARE_PRODUCT = SIZES.length > 0 && SIZES.every(function(sz){ return sz.w === sz.h; });
var BEST = PIECES >= 3 ? {r:[50,70], q:[60,60], color:'preta'} : (PIECES === 2 ? {r:[50,70], q:[60,60], color:'crua'} : {r:[50,70], q:[30,30], color:'preta'});
function nearestSize(w, h, list){
  var best = null, gap = Infinity;
  (list || SIZES).forEach(function(sz){
    var d = Math.abs(sz.w * sz.h - w * h) + (sz.w === w && sz.h === h ? -1 : 0);
    if(d < gap){ gap = d; best = sz; }
  });
  return best;
}
var BEST_DIM = SQUARE_PRODUCT ? BEST.q : BEST.r;
var BEST_SIZE = nearestSize(BEST_DIM[0], BEST_DIM[1], SIZES_SHOWN.length ? SIZES_SHOWN : SIZES);
var DEFAULT_SIZE = BEST_SIZE ? BEST_SIZE.k : (SIZES[0] ? SIZES[0].k : '');
var S = { size:DEFAULT_SIZE, fin:'filete', color:BEST.color, glass:1, comp:1, mov:null, larg:null };
/* Sem a cor preferida à venda (ex.: a Preta escondida nos quadros até R$ 399, 04/11/2026), abre na cor
   da 1ª variante do produto: a ordem das cores na Shopify decide. Antes caía sempre na Preta. */
if(!COLORS.some(function(c){ return c.k === S.color; })){
  var firstColor = '';
  (DATA.variants || []).some(function(v){
    var c = variantColor(v[3]);
    if(c && COLORS.some(function(x){ return x.k === c; })){ firstColor = c; return true; }
    return false;
  });
  S.color = firstColor || (COLORS[0] ? COLORS[0].k : 'preta');
}
/* Acabamentos à venda (configuração do tema "Acabamentos à venda": filete, filete_vidro, canvas, caixa,
   caixa_vidro, placa): os outros somem da página, mesmo existindo como variante do produto */
var FIN_ON_SALE = (DATA.finishes || []).map(function(s){ return String(s).trim(); }).filter(Boolean);
function finAllowed(fin, glass){
  /* a moldura padrão só existe nos produtos da categoria até R$ 399, e lá é a única */
  if(fin === 'padrao') return true;
  if(!FIN_ON_SALE.length) return true;
  return FIN_ON_SALE.indexOf((fin === 'mdf' ? 'placa' : fin) + (glass ? '_vidro' : '')) >= 0;
}
FINS = FINS.filter(function(f){ return PRICE[f.k] && (finAllowed(f.k,0) || finAllowed(f.k,1)); });
if (SIZES.length && !SIZES.some(function(sz){ return sz.k===S.size; })) S.size = SIZES[0].k;
if (FINS.length && !PRICE[S.fin]) S.fin = FINS[0].k;
/* Sem vidro nessa medida (ou num acabamento que não leva vidro): sem vidro */
if (S.glass && !(glassOK(S.fin) && PRICE_GLASS[S.fin] && PRICE_GLASS[S.fin][S.size] != null)) S.glass = 0;
var lastPaperFin = S.fin === 'canvas' ? 'filete' : S.fin;
/* Link compartilhado: só aceita valores que existem neste produto. Assim uma URL
   antiga ou alterada não deixa o seletor num estado que não possa ser comprado. */
(function hydrateSharedState(){
  var q = new URLSearchParams(window.location.search), value;
  value = q.get('variant');
  if(value && !q.get('gq_fin')){
    var hit = (DATA.variants || []).filter(function(v){ return String(v[0]) === value; })[0];
    var hf = hit && variantFinish(hit[2]);
    if(hf && FINS.some(function(f){ return f.k === hf.fin; })){
      S.fin = hf.fin; S.glass = hf.glass;
      var hs = String(hit[1] || '').toLowerCase().replace(/[×\s]/g,'');
      if(SIZES.some(function(sz){ return sz.k === hs; })) S.size = hs;
      var hc = variantColor(hit[3]);
      if(hc && COLORS.some(function(c){ return c.k === hc; })) S.color = hc;
    }
  }
  value = q.get('gq_fin');
  if(value && FINS.some(function(f){ return f.k === value; })) S.fin = value;
  value = q.get('gq_size');
  if(value && SIZES.some(function(sz){ return sz.k === value; }) && PRICE[S.fin] && PRICE[S.fin][value]) S.size = value;
  value = q.get('gq_cor');
  if(value && COLORS.some(function(c){ return c.k === value; })) S.color = value;
  if(q.has('gq_vidro')) S.glass = q.get('gq_vidro') === '1' ? 1 : 0;
  value = q.get('gq_movel');
  if(value && LARG[value]){
    S.mov = value;
    var larg = q.get('gq_larg');
    if(larg && LARG[value].some(function(item){ return item.k === larg; })) S.larg = larg;
  }
})();
/* Acabamento ou vidro fora de venda (link antigo ou o padrão): o outro vidro do mesmo acabamento,
   senão o primeiro acabamento à venda */
if(!finAllowed(S.fin, S.glass)){
  if(finAllowed(S.fin, S.glass ? 0 : 1)) S.glass = S.glass ? 0 : 1;
  else if(FINS.length){ S.fin = FINS[0].k; S.glass = finAllowed(S.fin, 0) ? 0 : 1; }
}

/* ═══════════ UTIL ═══════════ */
function brl(v){ return 'R$ ' + v.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.'); }
function sizeObj(k){ for(var i=0;i<SIZES.length;i++){ if(SIZES[i].k===k) return SIZES[i]; } return SIZES[0]; }
function finObj(k){ for(var i=0;i<FINS.length;i++){ if(FINS[i].k===k) return FINS[i]; } return FINS[0]; }
function orientationKind(){
  var n = String(PRODUCT_ORIENTATION || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  return n.indexOf('quadrad') >= 0 ? 'quadrado' : (n.indexOf('paisag') >= 0 ? 'paisagem' : 'retrato');
}
/* O ERP anuncia sempre menor×maior. Para paisagem, a dimensão física na parede é
   maior×menor; quadrados e retratos mantêm a ordem. */
function physicalSize(o){ return orientationKind()==='paisagem' ? {w:o.h,h:o.w} : {w:o.w,h:o.h}; }
/* A ficha mede a peça já acabada. Filete = 0,8 cm por lado, caixa = 1,5 cm e
   flutuante = 1 cm; a placa mantém a dimensão anunciada. */
function finishEdge(fin){ return {mdf:0,filete:1.6,padrao:3,caixa:3,canvas:2}[fin] || 0; }
function mountedDimensions(sizeK,extra){
  var o = physicalSize(sizeObj(sizeK)), n = PIECES + extra, edge = finishEdge(S.fin);
  var extraWidth = PIECES===1 ? o.w : 30;
  return {w:PIECES*(o.w+edge) + extra*(extraWidth+edge) + Math.max(0,n-1)*GAP,h:o.h+edge};
}
function techSheetUrl(){
  var type = TECH_SHEET_TYPE[PIECES], fin = TECH_SHEET_FIN[S.fin], key;
  if(!type || !fin) return '';
  key = type[0]+'|'+S.size+'|'+S.fin;
  if(TECH_SHEET_PENDING[key]) return '';
  return TECH_SHEET_BASE+type[0]+'/'+type[1]+'_'+S.size+'_'+fin+'.webp';
}
function base(fin,size){ var r = PRICE[fin] && PRICE[fin][size]; return r ? r[0] : null; }
function priceForMode(fin,size,glass){
  var p = base(fin,size);
  if(p==null) return null;
  if(glass && glassOK(fin)){
    var g = PRICE_GLASS[fin] && PRICE_GLASS[fin][size];
    return g==null ? null : g;
  }
  return p;
}
function priceFor(fin,size){ return priceForMode(fin,size,S.glass); }
function isMeasured(fin,size){ return PRICE[fin][size][1]===1; }
function glassOK(fin){ return fin==='caixa' || fin==='filete' || fin==='padrao'; }
function colorOK(fin){ return fin!=='mdf'; }
function unitPrice(){ var p = priceFor(S.fin,S.size); return p == null ? 0 : p; }
function extraPieces(){ return S.comp===1?0:(S.comp===2?2:4); }
function total(){ return unitPrice() + extraPieces()*AVULSO; }
function montado(sizeK,extra){
  return mountedDimensions(sizeK,extra).w;
}
function fmtCm(v){ var n = Math.round(v*10)/10; return (n%1 ? n.toFixed(1).replace('.',',') : String(n)) + ' cm'; }
function fmtWall(v){ return v>=100 ? (v/100).toFixed(2).replace('.',',')+' m' : fmtCm(v); }
function shareConfigLabel(){
  /* [5d] o mesmo nome dos cards (ex.: "filete com vidro", "canvas flutuante") */
  var o = sizeObj(S.size), labels = [CONJ.toLowerCase()+' '+o.w+'×'+o.h, finLabel(S.fin,S.glass).toLowerCase()];
  if(colorOK(S.fin)) labels.push(colName(S.color).toLowerCase());
  if(PIECES + extraPieces() > 1) labels.push((PIECES + extraPieces())+' peças');
  return labels.join(' · ');
}
function sharedPdpUrl(){
  var u = new URL(PDP_CATEGORY_EMBED ? PRODUCT_PAGE_PATH : window.location.href, window.location.href), q = u.searchParams;
  q.delete('embed');
  if(PDP_COLLAPSE) q.set('collapse','1'); else q.delete('collapse');
  q.set('gq_size',S.size);
  q.set('gq_fin',S.fin);
  q.set('gq_cor',S.color);
  q.set('gq_vidro',S.glass ? '1' : '0');
  q.delete('gq_comp');
  if(S.mov) q.set('gq_movel',S.mov); else q.delete('gq_movel');
  if(S.larg) q.set('gq_larg',S.larg); else q.delete('gq_larg');
  /* [29/10/2026] A variante vai no próprio link: o render5d monta o do WhatsApp antes de gravar o
     ?variant= novo na barra de endereço, e o link saía com o id da escolha anterior */
  var vid = shippingCombination();
  if(vid) q.set('variant',vid); else q.delete('variant');
  return u.toString();
}
function shareOnWhatsApp(){
  var text = 'Olha como ficou essa composição da Go Quadros: '+shareConfigLabel()+'.\n\n'+sharedPdpUrl();
  window.open('https://wa.me/?text='+encodeURIComponent(text),'_blank','noopener');
}
function savedComposition(){
  return {
    version: 1,
    url: sharedPdpUrl(),
    label: shareConfigLabel(),
    size: S.size,
    finish: S.fin,
    color: colorOK(S.fin) ? S.color : null,
    glass: !!S.glass,
    composition: S.comp,
    furniture: S.mov,
    furniture_size: S.larg
  };
}
function saveComposition(){
  var button = document.getElementById('saveComposition');
  if(!button || button.disabled) return;
  // [Shopify] Sem a lista de desejos do site antigo: a composição fica neste navegador
  // (gq-paredes) e o quadro entra nos favoritos do tema (gq-favoritos, contador do topo).
  try {
    var walls = JSON.parse(localStorage.getItem('gq-paredes') || '[]');
    if(!Array.isArray(walls)) walls = [];
    var item = savedComposition(); item.handle = PRODUCT_HANDLE; item.title = PRODUCT_TRACK.name; item.saved_at = new Date().toISOString();
    walls = walls.filter(function(w){ return w && w.url !== item.url; });
    walls.unshift(item);
    localStorage.setItem('gq-paredes', JSON.stringify(walls.slice(0, 50)));
    var favs = JSON.parse(localStorage.getItem('gq-favoritos') || '[]');
    if(!Array.isArray(favs)) favs = [];
    if(favs.indexOf(PRODUCT_HANDLE) < 0){ favs.push(PRODUCT_HANDLE); localStorage.setItem('gq-favoritos', JSON.stringify(favs)); }
    document.dispatchEvent(new CustomEvent('gq:favorites-change', {detail:{favorites:favs}}));
    button.disabled = true;
    button.textContent = '✓ Parede salva neste navegador';
  } catch(e) {
    alert('Não foi possível salvar sua parede agora.');
  }
}

/* ═══════════ RENDER: SELETOR DE TAMANHO ═══════════ */
function figFor(o){
  o = physicalSize(o);
  var maxH = 22, k = maxH / Math.max(o.h,o.w) ;
  var hh = Math.max(6, Math.round(o.h*k)), ww = Math.max(4, Math.round(o.w*k*0.5));
  var s='';
  for(var i=0;i<PIECES;i++){ s += '<i style="width:'+ww+'px;height:'+hh+'px"></i>'; }
  s += '<u style="height:'+Math.round(maxH*0.85)+'px"></u>';
  return s;
}
function mobileSizeAdvice(){
  if(!usesMobileControls() || !S.mov || !S.larg) return {};
  var recommended = SIM[S.mov+'|'+S.larg];
  var available = SIZES.filter(function(o){ return priceFor(S.fin,o.k) != null; });
  var index = available.findIndex(function(o){ return o.k === recommended; });
  if(index < 0) return {};
  var start = Math.max(0,Math.min(index-1,available.length-3)), advice = {};
  available.slice(start,start+3).forEach(function(o,i){
    var distance = start+i-index;
    advice[o.k] = distance === 0 ? 'Ideal' : (distance < 0 ? (distance === -1 ? 'Discreto' : 'Mais discreto') : (distance === 1 ? 'Mais presença' : 'Maior'));
  });
  return advice;
}
/* [5d] Acabamento em cards (o vidro faz parte do card), tamanho em grade com o preço "por"
   e cor em círculos. Os cliques continuam nos mesmos atributos (data-f/data-g, data-s, data-c). */
var FIN_CARDS = [
  {f:'padrao', g:0, n:'Padrão', sub:'sem vidro'},
  {f:'padrao', g:1, n:'Padrão', sub:'com vidro'},
  {f:'filete', g:0, n:'Filete', sub:'sem vidro'},
  {f:'filete', g:1, n:'Filete', sub:'com vidro'},
  {f:'canvas', g:0, n:'Canvas flutuante', sub:''},
  {f:'caixa',  g:0, n:'Caixa', sub:'sem vidro'},
  {f:'caixa',  g:1, n:'Caixa', sub:'com vidro'},
  {f:'mdf',    g:0, n:'Sem moldura', sub:'placa'}
].filter(function(c){ return finAllowed(c.f, c.g); });
function finLabel(fin,glass){
  var g = glass && glassOK(fin) ? 1 : 0;
  for(var i=0;i<FIN_CARDS.length;i++){
    var c = FIN_CARDS[i];
    if(c.f===fin && c.g===g) return c.n + ((fin==='filete' || fin==='caixa' || fin==='padrao') ? ' ' + c.sub : '');
  }
  return finObj(fin).nome;
}
/* Preço "de": só com "Mostrar preço de/por" ligado na seção (DATA.showDe; desligado desde 15/10, a
   pedido do usuário). Aí vale o compare_at da variante; sem ele, a página não mostra de/por, "-X%"
   nem "economize". A regra de demonstração do protótipo 5d (+35%, terminando em ,90) vale SÓ fora do
   tema publicado (DATA.demoDe = theme.role != 'main'). */
function deOf(p){ return Math.ceil(p*1.35/10)*10 - 0.1; }
function compareFor(fin,size,glass,color){
  if(!DATA.showDe) return null;
  var g = glass && glassOK(fin) ? 1 : 0, c = colorOK(fin) ? color : '';
  var exact = CMP[fin+'|'+size+'|'+g+'|'+c];
  if(exact != null) return exact;
  var min = CMPMIN[fin+'|'+size+'|'+g];
  if(min != null) return min;
  if(!DATA.demoDe) return null;
  var p = priceForMode(fin,size,g);
  return p == null ? null : deOf(p);
}
function colorHex(k){ for(var i=0;i<COLORS.length;i++){ if(COLORS[i].k===k) return COLORS[i].c; } return COLORS[0].c; }
function miniFrame(fin,glass){
  var art = String(ARTS[0] || '').replace('width=1500','width=240');
  var esc = function(v){ return String(v || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;'); };
  /* [23/10/2026] a moldura segue o formato do quadro (pd-mini--quadrado, --paisagem ou --retrato): antes
     era sempre retrato 2:3 e cortava a arte dos quadrados e das paisagens */
  return '<span class="pd-mini pd-mini--'+fin+' pd-mini--'+orientationKind()+(glass?' is-glass':'')+'" style="--fc:'+(colorOK(fin) ? colorHex(S.color) : 'transparent')+'">'+
    /* lazy (22/10/2026): no celular o cartão esconde a miniatura (.pd-fin-ph), e assim ela nem baixa */
    (art ? '<img src="'+esc(art)+'" alt="" loading="lazy" decoding="async" referrerpolicy="no-referrer">' : '')+'</span>';
}
/* [27/10/2026] Preço de cada opção = a diferença para a escolha atual ("+ R$ 30,00", "− R$ 150,00"), e não o
   preço cheio (auditoria do time de desempenho: "valores por opção geram ambiguidade"). O total fica num lugar
   só: o resumo e a barra de baixo. É a mesma lógica do "+ R$ X neste tamanho" do vidro. */
function deltaLabel(p, cur, on){
  if(p == null) return 'indisponível';
  if(on) return 'escolhido';
  var d = Math.round((p - cur) * 100) / 100;
  if(!d) return 'mesmo preço';
  return (d > 0 ? '+ ' : '− ') + brl(Math.abs(d));
}
function drawSizes(){
  var h = '', track = document.getElementById('selSize'), cur = unitPrice();
  SIZES.forEach(function(o){
    var p = priceFor(S.fin,o.k), on = S.size===o.k;
    h += '<button type="button" class="size pd-size" role="radio" aria-checked="'+on+'" aria-pressed="'+on+'" data-s="'+o.k+'"'+(p==null?' disabled':'')+'>'+
         '<b>'+o.w+'×'+o.h+'</b><em>'+deltaLabel(p,cur,on)+'</em></button>';
  });
  track.innerHTML = h;
  /* [22/10/2026] celular: os tamanhos são uma linha que rola de lado; o escolhido fica à vista (rola só a
     linha, nunca a página) */
  if(isPhone()){
    /* no quadro seguinte (rAF), com o layout já calculado: medir logo depois do innerHTML forçava o cálculo */
    requestAnimationFrame(function(){
      var chosen = track.querySelector('[aria-checked="true"]');
      if(!chosen) return;
      var tr = track.getBoundingClientRect(), cr = chosen.getBoundingClientRect();
      if(cr.left < tr.left || cr.right > tr.right) track.scrollLeft += cr.left - tr.left - (tr.width - cr.width) / 2;
    });
  }
}
function drawFins(){
  var h = '', track = document.getElementById('selFin'), cur = unitPrice();
  FIN_CARDS.forEach(function(c){
    if(!FINS.some(function(f){ return f.k===c.f; })) return;
    if(c.g && !(PRICE_GLASS[c.f] && Object.keys(PRICE_GLASS[c.f]).length)) return;
    /* o "de" fica só no resumo e na barra fixa: aqui, a diferença para a escolha atual (deltaLabel) */
    var p = priceForMode(c.f,S.size,c.g);
    var on = S.fin===c.f && Number(S.glass && glassOK(S.fin) ? 1 : 0)===c.g;
    h += '<button type="button" class="fin pd-fin" role="radio" aria-checked="'+on+'" aria-pressed="'+on+'" data-f="'+c.f+'" data-g="'+c.g+'"'+(p==null?' disabled':'')+'>'+
         '<span class="pd-fin-ph">'+miniFrame(c.f,c.g)+'</span>'+
         /* "com vidro" vem em destaque (pílula verde), a pedido do usuário em 15/10 */
         '<span class="pd-fin-tx"><b>'+c.n+'</b>'+(c.sub ? '<span class="pd-fin-sub'+(c.g ? ' pd-fin-sub--vidro' : '')+'">'+c.sub+'</span>' : '')+'</span>'+
         '<span class="pd-fin-pr"><em>'+deltaLabel(p,cur,on)+'</em></span>'+
         '</button>';
  });
  track.innerHTML = h;
}
function drawColors(){
  var h = '', track = document.getElementById('selColor');
  COLORS.forEach(function(c){
    var on = S.color===c.k;
    /* foto do canto da moldura (a mesma da PDP antiga), no acabamento escolhido, com o nome embaixo; a cor chapada fica por baixo enquanto carrega */
    var photo = finishPhoto(colorOK(S.fin) ? S.fin : 'filete', c.k);
    h += '<button type="button" class="pd-sw" role="radio" aria-checked="'+on+'" aria-pressed="'+on+'" data-c="'+c.k+'" style="--swatch:'+c.c+';--swatch-image:url('+photo+')" aria-label="Moldura '+c.nome+'"><i aria-hidden="true"></i><span aria-hidden="true">'+c.nome+'</span></button>';
  });
  track.innerHTML = h;
}
/* [5d] Preço de/por, resumo, barra fixa, WhatsApp com a variante, ?variant= na URL e
   os eventos gq:variant e variant:change (o visualizador 3D e outros blocos podem ouvir). */
/* [5d] Tabela "Qual acabamento escolher" (seção gq-pdp5d-medidas): preço no tamanho escolhido,
   impressão (FINS[].mat), linha escolhida e linhas que o produto não vende */
function drawMedidas(o){
  var rows = document.querySelectorAll('[data-gq5-med]'); if(!rows.length) return;
  var sel = S.fin + '|' + (S.glass && glassOK(S.fin) ? 1 : 0);
  [].slice.call(document.querySelectorAll('.gq5-fx [data-med-size]')).forEach(function(el){ el.textContent = 'No ' + o.w + '×' + o.h; });
  [].slice.call(rows).forEach(function(row){
    var fin = row.getAttribute('data-fin'), g = Number(row.getAttribute('data-g')) || 0;
    var f = FINS.filter(function(x){ return x.k === fin; })[0];
    var p = f ? priceForMode(fin, S.size, g) : null;
    var chosen = fin + '|' + g === sel;
    row.hidden = !(f && (!g || (PRICE_GLASS[fin] && Object.keys(PRICE_GLASS[fin]).length)));
    row.classList.toggle('is-on', chosen);
    row.setAttribute('aria-pressed', chosen);
    row.disabled = p == null;
    var pr = row.querySelector('[data-med-price]'), act = row.querySelector('[data-med-act]');
    if(pr) pr.innerHTML = p == null ? 'indisponível neste tamanho' : '<strong>' + brl(p) + '</strong>';
    [].slice.call(row.querySelectorAll('[data-med-mat]')).forEach(function(el){ el.textContent = f ? (f.mat || '') : ''; });
    if(act) act.textContent = chosen ? 'Escolhido' : (p == null ? '' : 'Escolher');
  });
  /* [23/10/2026] Nenhuma linha à venda (os produtos da moldura padrão, que só têm ela): a tabela some */
  var sec = rows[0].closest('.gq5s');
  if(sec) sec.style.display = [].some.call(rows, function(r){ return !r.hidden; }) ? '' : 'none';
}
function render5d(o){
  drawMedidas(o);
  /* o "de" é por peça; na composição com peças extras ele acompanha o total sem o desconto do kit */
  var up = compTotal(), unit = unitPrice(), cmpUnit = compareFor(S.fin,S.size,S.glass,S.color);
  var cmp = cmpUnit == null || !unit ? null : cmpUnit * compGross() / unit;
  var hasCmp = cmp != null && cmp > up + 0.004;
  var el = function(id){ return document.getElementById(id); };
  /* [23/10/2026] De/por com um sinal de desconto só (mentoria/marketing): o "de" riscado e o "economize R$ X".
     O "-X%" saiu: em quadro acima de R$ 100, o valor em reais pesa mais que o percentual. */
  if(el('pdWas')) el('pdWas').hidden = !hasCmp;
  if(hasCmp) el('pdFrom').textContent = brl(cmp);
  if(el('pdSave')){ el('pdSave').hidden = !hasCmp; el('pdSave').textContent = hasCmp ? 'economize '+brl(cmp-up) : ''; }
  if(el('stkWas')){ el('stkWas').hidden = !hasCmp; el('stkWas').textContent = hasCmp ? brl(cmp) : ''; }
  /* [22/10/2026] Barra de baixo: a oferta escolhida em Configurações do tema › GoQuadros, numa linha
     embaixo do preço. "todas", "faixa" e "nenhuma": no celular, sem a linha (fica a da configuração).
     27/10/2026: no computador a linha é o melhor degrau da escada do resumo (com o cupom no Pix, com o cupom
     ou no Pix). No celular fica o texto curto de antes (.pd-stk-o-s): o longo não cabe ao lado do botão em
     375px, e o resumo inteiro está logo acima do botão principal. */
  var offerKind = DATA.oferta || 'todas', lad = priceLadder(up), offerLong = '', offerShort = '';
  if(lad.coupon != null && lad.pix != null) offerLong = brl(lad.pix) + ' com cupom e Pix';
  else if(lad.coupon != null) offerLong = brl(lad.coupon) + ' com o cupom ' + couponCode();
  else if(lad.pix != null) offerLong = brl(lad.pix) + ' no Pix';
  if(offerKind === 'cupom' && lad.coupon != null){
    offerShort = String(couponPct()).replace('.', ',') + '% off: ' + couponCode();
  } else if(offerKind === 'pix' && lad.pix != null){
    offerShort = brl(lad.pix) + ' no Pix';
  } else if(offerKind === 'de_por' && hasCmp){
    /* [23/10/2026] o mesmo "economize" do bloco de preço, sem centavos quando o valor é redondo: com o "de"
       junto (ou com os ",00"), cortava em 360px */
    offerShort = 'economize ' + brl(cmp-up).replace(/,00$/, '');
  }
  if(!offerLong) offerLong = offerShort;
  var stkOffer = el('stkOffer');
  if(stkOffer){
    stkOffer.textContent = '';
    [['pd-stk-o-l', offerLong], ['pd-stk-o-s', offerShort]].forEach(function(x){
      var s = document.createElement('span'); s.className = x[0]; s.textContent = x[1]; stkOffer.appendChild(s);
    });
    stkOffer.hidden = !offerLong;
    stkOffer.setAttribute('data-kind', offerKind);
    stkOffer.setAttribute('data-short', offerShort ? '1' : '0');
  }
  var finName = finLabel(S.fin,S.glass);
  var summary = CONJ+' '+o.w+'×'+o.h+' · '+finName.toLowerCase()+(colorOK(S.fin) ? ' · '+colName(S.color).toLowerCase() : '');
  el('ctaSub').textContent = summary;
  el('stkCfg').textContent = o.w+'×'+o.h+' · '+finName+(colorOK(S.fin) ? ' · '+colName(S.color).toLowerCase() : '');
  drawResumo(o, lad);
  if(el('labSize')) el('labSize').textContent = o.w+'×'+o.h+' cm';
  if(el('labColor')) el('labColor').textContent = colorOK(S.fin) ? colName(S.color) : '';
  if(el('ctaWhats')) el('ctaWhats').href = 'https://wa.me/'+WHATSAPP+'?text='+encodeURIComponent('Olá! Quero ajuda com o '+PRODUCT_TRACK.name+' ('+summary+'): '+sharedPdpUrl());
  var id = shippingCombination();
  /* No modo categoria a URL é a da categoria interativa: o ?variant= ficaria nela */
  if(id && !PDP_CATEGORY_EMBED){
    try {
      var u = new URL(window.location.href);
      if(u.searchParams.get('variant') !== String(id)){ u.searchParams.set('variant', id); history.replaceState(history.state, '', u.toString()); }
    } catch(e) {}
  }
  var detail = {id:id, size:S.size, finish:S.fin, glass:!!(S.glass && glassOK(S.fin)), color:colorOK(S.fin) ? S.color : ''};
  document.dispatchEvent(new CustomEvent('gq:variant', {detail:detail}));
  document.dispatchEvent(new CustomEvent('variant:change', {detail:detail}));
}

/* [27/10/2026] Resumo da escolha (auditoria do time de desempenho): o que chega, a parede ocupada, o acabamento,
   a cor, a entrega e o preço numa escada só: total → com o cupom → com o cupom no Pix. O cupom e o Pix somam no
   checkout (confirmado pelo Renan), por isso o Pix é calculado sobre o valor já com o cupom. Cada degrau só
   aparece com a oferta escolhida em Configurações do tema › GoQuadros: o cupom só existe no HTML com "todas" ou
   "cupom", e o Pix (PIX_OFF) só vem com "todas" ou "pix". A mesma conta escreve a linha de oferta da barra. */
function couponBox(){ return document.querySelector('#pdp-c .pd-coupon'); }
function couponPct(){
  var box = couponBox(), pct = box ? parseFloat(box.getAttribute('data-coupon-pct')) : 0;
  return pct > 0 && pct < 100 ? pct : 0;
}
function couponCode(){ var b = document.querySelector('#pdp-c [data-apply-coupon]'); return b ? b.getAttribute('data-apply-coupon') : ''; }
function cents(v){ return Math.round(v * 100) / 100; }
function priceLadder(up){
  var pct = couponPct(), coupon = pct ? cents(up * (1 - pct / 100)) : null;
  var pix = PIX_OFF ? cents((coupon != null ? coupon : up) * (1 - PIX_OFF / 100)) : null;
  return {total:up, coupon:coupon, pix:pix};
}
/* medida sem o " cm" (para "104 × 71,6 cm") */
function cmNum(v){ return fmtCm(v).replace(/ cm$/, ''); }
function drawResumo(o, lad){
  var el = function(id){ return document.getElementById(id); };
  if(!el('rsPecas')) return;
  var f = finObj(S.fin), po = physicalSize(o), mounted = mountedDimensions(S.size, extraPieces());
  el('rsPecas').textContent = PIECES + (PIECES > 1 ? ' quadros de ' : ' quadro de ') + po.w + ' × ' + po.h + ' cm · ' + String(f.mat || '').toLowerCase();
  el('rsParede').textContent = cmNum(mounted.w) + ' × ' + cmNum(mounted.h) + ' cm' + (PIECES > 1 ? ', com ' + GAP + ' cm entre as peças' : '');
  el('rsAcab').textContent = finLabel(S.fin, S.glass);
  var corRow = el('rsCorRow');
  if(corRow) corRow.hidden = !colorOK(S.fin);
  el('rsCor').textContent = colorOK(S.fin) ? 'Moldura ' + colName(S.color).toLowerCase() : '';
  drawResumoEntrega();
  var cupom = el('rsCupom');
  if(cupom) cupom.textContent = lad.coupon != null ? brl(lad.coupon) : '';
  el('pParc').innerHTML = lad.pix != null
    ? '<span class="pd-resumo__k">' + (lad.coupon != null ? 'Com o cupom, no Pix' : 'No Pix') + '</span><b class="pix">' + brl(lad.pix) + '</b>'
    : '';
  drawBarSummary();
}
/* Entrega do resumo e da barra: o mesmo prazo do cartão do CEP (o da região, ou o da tarifa depois de cotar).
   O resumo nunca cota sozinho: cotar põe a peça no carrinho e conta como AddToCart (ver requoteIfNeeded). */
var RESUMO_SHIP = null;
function resumoShip(cep, days){
  RESUMO_SHIP = cep && days && days[1] ? {cep:cep, min:days[0] || days[1], max:days[1]} : null;
  drawResumoEntrega();
  drawBarSummary();
}
function drawResumoEntrega(){
  var dd = document.getElementById('rsEntrega'); if(!dd) return;
  dd.innerHTML = RESUMO_SHIP
    ? placeHTML(RESUMO_SHIP.cep) + whenHTML(RESUMO_SHIP.min, RESUMO_SHIP.max)
    : 'Sai da fábrica em até 48h úteis · <button type="button" class="pd-resumo__lk" data-resumo-cep>calcular o prazo</button>';
}
/* Barra de baixo no computador: o resumo inteiro numa linha (o CSS o esconde no celular) */
function drawBarSummary(){
  var out = document.getElementById('stkSum'); if(!out) return;
  var o = sizeObj(S.size), po = physicalSize(o), mounted = mountedDimensions(S.size, extraPieces());
  var parts = [po.w + '×' + po.h + ' cm' + (PIECES > 1 ? ' cada' : ''), cmNum(mounted.w) + ' × ' + cmNum(mounted.h) + ' cm na parede', finLabel(S.fin, S.glass)];
  if(colorOK(S.fin)) parts.push('moldura ' + colName(S.color).toLowerCase());
  if(RESUMO_SHIP){ var r = deliveryRange(RESUMO_SHIP.min, RESUMO_SHIP.max); parts.push('chega até ' + dayLabel(r.to)); }
  else parts.push('sai da fábrica em 48h úteis');
  out.textContent = parts.join(' · ');
}

/* [22/10/2026] No 5d as setas dos seletores (.variant-nav) ficam sempre escondidas (gq-pdp5d.css): não há o
   que atualizar. Medir o trilho aqui forçava um cálculo de layout no carregamento e a cada redimensionamento. */
function updateVariantNav(){}

document.querySelectorAll('#pdp-c .variant-carousel').forEach(function(shell){
  var track = shell.querySelector('.sizes,.finishes,.sw,.pills');
  shell.addEventListener('click',function(e){
    var nav = e.target.closest('[data-variant-track]');
    if(!nav || nav.disabled || !track) return;
    var direction = parseInt(nav.getAttribute('data-direction'),10) || 1;
    var step = track.clientWidth + 7;
    if(track.id === 'selSize' && track.children.length > 1){
      // Uma opção por clique, incluindo o espaçamento real entre os tamanhos.
      step = track.children[1].getBoundingClientRect().left - track.children[0].getBoundingClientRect().left;
    }
    track.scrollBy({left:direction*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
});

(function initGalleryZoom(){
  var main = document.getElementById('galMain');
  var zoomIn = document.getElementById('galZoomIn');
  var zoomOut = document.getElementById('galZoomOut');
  if(!main || !zoomIn || !zoomOut) return;
  var levels = [1,2], level = 0;
  function sync(){
    main.style.setProperty('--gal-zoom',levels[level]);
    main.setAttribute('data-zoom',Math.round(levels[level]*100));
    zoomOut.disabled = level===0;
    zoomIn.disabled = level===levels.length-1;
  }
  zoomIn.addEventListener('click',function(){
    if(level<levels.length-1){ level++; sync(); }
  });
  zoomOut.addEventListener('click',function(){
    if(level>0){ level--; sync(); }
  });
  pdpOn(document,'pdpc:size-change',function(){
    if(level!==0){ level = 0; sync(); }
  });
  sync();
})();

/* ═══════════ RENDER: ESCADA DE COMPOSIÇÃO ═══════════ */
function drawComp(){
  if(!document.getElementById('compSteps')) return;
  var defs = [
    {n:1, peças:PIECES,   extra:0, tit:PIECES===1?'Só esta peça':'Só este '+CONJ.toLowerCase(), why:PIECES+' peça'+(PIECES>1?'s':'')+' · '+fmtWall(montado(S.size,0))+' de parede', tag:''},
    {n:2, peças:PIECES+2, extra:2, tit:PIECES===1?'Trio da mesma linha':(PIECES+2)+' peças na mesma linha', why:(PIECES+2)+' peças · '+fmtWall(montado(S.size,2))+' de parede · −10%', tag:'MAIS ESCOLHIDO'},
    {n:3, peças:PIECES+4, extra:4, tit:'Parede inteira', why:(PIECES+4)+' peças · '+fmtWall(montado(S.size,4))+' de parede · −15%', tag:''}
  ];
  var h='';
  defs.forEach(function(d){
    var v = PIECES===1 ? unitPrice()*d.peças : unitPrice() + d.extra*AVULSO;
    var desc = d.n===1?0:(d.n===2?0.10:0.15);
    var vf = v*(1-desc);
    var w = montado(S.size, d.extra);
    var mini='';
    for(var i=0;i<d.peças;i++){
      var isSide = (d.n>1) && (i<d.extra/2 || i>=PIECES+d.extra/2);
      mini += '<i class="'+(isSide?'sm':'')+'" style="height:'+(isSide?18:28)+'px"></i>';
    }
    h += '<button class="step" data-c="'+d.n+'" aria-pressed="'+(S.comp===d.n?'true':'false')+'">'+
         (d.tag?'<span class="tag">'+d.tag+'</span>':'')+
         '<span class="mini">'+mini+'</span>'+
         '<span class="bd"><b>'+d.tit+'</b><s>'+d.why+'</s><u>parede ocupada: '+fmtCm(w)+'</u></span>'+
         '<span class="pr"><em>'+brl(vf)+'</em>'+(desc?'<s>−'+(desc*100)+'% proposto</s>':'')+'</span>'+
         '</button>';
  });
  document.getElementById('compSteps').innerHTML = h;
}
function compGross(){ return PIECES===1 ? unitPrice()*(PIECES+extraPieces()) : unitPrice() + extraPieces()*AVULSO; }
function compTotal(){
  var desc = S.comp===1?0:(S.comp===2?0.10:0.15);
  return compGross()*(1-desc);
}

/* ═══════════ FOTO DE AMBIENTE ═══════════
   Chave: {movel}{largura}-{tamanho}-{moldura}[-{cor}] — a mesma que o nome do arquivo
   carrega e que a API devolve em image2.ambiente.

   O TAMANHO usa o anunciado (o.w x o.h), NAO o o.k: nos dois maiores o k vem invertido
   do ERP (120x80 / 150x100) enquanto a loja anuncia 80x120 / 100x150. Usar o k erraria
   a chave so nos dois maiores — o tipo de bug que passa num teste rapido.

   O TAMANHO e sempre EXATO. Nunca mostramos outro tamanho: ele governa preco e a regra
   de "conjunto montado", entao uma foto de tamanho diferente mentiria. O que cede e o
   ambiente, nesta ordem:
     1. cena exata          — movel + largura + tamanho do cliente
     2. mesmo movel         — outra largura, tamanho exato (mantem o contexto escolhido)
     3. qualquer ambiente   — tamanho exato
   Sem nada, devolve '' e a galeria volta ao placeholder. */
var MKP_FIN = { mdf: 'placa', canvas: 'flutuante', padrao: 'filete' };  /* padrão: sem montagem própria ainda */   /* o resto do FINS ja casa */
var mkpNivel = '';                                     /* p/ conferencia: qual regra pegou */
var GAL_SLIDE = 'medidas'; /* [5d] abre na vista de frente */
/* [22/10/2026] Celular: a vitrine abre nas fotos do produto (vista "fotos", aba "quadro" da barrinha
   #galBar).
   [23/10/2026] Computador e tablet também: a 1ª imagem é a foto principal (o quadro no ambiente), não o
   3D, que fica na miniatura "3D" e na 1ª escolha. Lá só a 1ª foto aparece, com a miniatura "Foto". */
var PHONE = window.matchMedia('(max-width: 749px)');
function isPhone(){ return PHONE.matches; }
var FOTOS_TRACK = document.getElementById('galFotosTrack');
var FOTOS_N = FOTOS_TRACK ? FOTOS_TRACK.querySelectorAll('img').length : 0;
function fotosOK(){ return FOTOS_N > 0; }
var FOTOS_LEFT = false; /* a 1ª escolha já tirou a vitrine das fotos */

function mkpSufixo(o){
  var fin = MKP_FIN[S.fin] || S.fin;
  return '-' + o.w + 'x' + o.h + '-' + fin + (colorOK(S.fin) ? '-' + S.color : '');
}
function mkpUrl(o){
  var suf = mkpSufixo(o), amb = (S.mov || '') + (S.larg || ''), k;

  if (amb && MKP[amb + suf]) { mkpNivel = 'exata'; return MKP[amb + suf]; }

  if (S.mov) {
    for (k in MKP) {
      if (k.indexOf(S.mov) === 0 && k.length > suf.length && k.indexOf(suf) === k.length - suf.length) {
        mkpNivel = 'mesmo movel'; return MKP[k];
      }
    }
  }
  for (k in MKP) {
    if (k.length > suf.length && k.indexOf(suf) === k.length - suf.length) {
      mkpNivel = 'outro ambiente'; return MKP[k];
    }
  }
  mkpNivel = 'sem imagem';
  return '';
}
/* Variação responsiva: todo arquivo do lote v2 tem um correspondente de 720 px.
   O src continua sendo o 1200 px (fallback/Retina); sizes deixa o navegador escolher
   o menor arquivo quando ele já cobre a largura física necessária. */
function mkp720Url(url){
  var value = String(url || '');
  // Os lotes v5/v6/v7/v8 usam fotos 4:3 com detalhes finos. Em telas mobile, o arquivo
  // de 720 px perdia definicao ao ser ampliado pelo navegador; usamos o 1200 px.
  if(/\/pdp-mkp\/v(?:5|6|7|8|9)\//.test(value)) return '';
  var marker = value.match(/\/pdp-mkp\/v\d+\//);
  return marker ? value.replace(marker[0], marker[0] + '720/') : '';
}
function setMkpImgSource(el,url){
  if(!el) return;
  var small = mkp720Url(url);
  if(small){
    el.setAttribute('srcset', small + ' 720w, ' + url + ' 1200w');
    el.setAttribute('sizes', '(max-width:1023px) calc((100vw - 34px) * 1.25), 60vw');
  } else {
    el.removeAttribute('srcset');
    el.removeAttribute('sizes');
  }
  el.src = url;
}
function clearMkpImgSource(el){
  if(!el) return;
  el.removeAttribute('src');
  el.removeAttribute('srcset');
  el.removeAttribute('sizes');
}
function setMkpSceneLabel(url){
  var label = document.getElementById('galScene');
  if(!label) return;
  label.hidden = true;
  label.textContent = '';
  if(!url || mkpNivel === 'sem imagem') return;
  var m = String(url).match(/(?:^|[-_])(aparador|buffet|cama|hack|mesaesc|mesajantar|sofa)(\d+|casal|queen|king)-/i);
  if(!m){
    label.textContent = 'Imagem ilustrativa · ambiente de referência';
    label.hidden = false;
    return;
  }
  var kind = m[1].toLowerCase(), size = m[2].toLowerCase(), scene;
  // Alguns mockups antigos chegam como fallback (ex.: `sofa360`), mas a cena não
  // pertence às medidas que a pessoa pode escolher no simulador. Não atribuímos
  // a ela um móvel/medida inexistente — a foto segue útil como referência visual.
  var isSelectableScene = (LARG[kind] || []).some(function(option){
    return String(option.k).toLowerCase() === size;
  });
  if(!isSelectableScene){
    label.textContent = 'Imagem ilustrativa · ambiente de referência';
    label.hidden = false;
    return;
  }
  if(kind === 'cama') scene = 'cama ' + size;
  else {
    var metres = (parseInt(size, 10) / 100).toFixed(2).replace('.', ',');
    var sceneNames = {aparador:'aparador',buffet:'buffet',hack:'hack',mesaesc:'mesa de escritório',mesajantar:'mesa de jantar',sofa:'sofá'};
    scene = sceneNames[kind] + ' de ' + metres + ' m';
  }
  label.textContent = 'Imagem ilustrativa · ' + scene;
  label.hidden = false;
}
/* Gerado dos mesmos quadriláteros internos usados para compor os mockups.
   Filete/caixa e suas cores compartilham o vão da arte, não a borda externa.
   Só envia a família e orientação deste produto; não depende de outra requisição. */
var GLASS_LAYOUTS = DATA.glass || {};
var GLASS_FAMILY = {1:'v6',2:'v7',3:'v8'}[PIECES] || '';
function galleryGlassQuads(url){
  // Os sublotes (v7/v2, v7/v4, etc.) usam os mesmos templates geométricos.
  var match = String(url || '').match(/\/pdp-mkp\/(v\d+)\/(?:v\d+\/)*\d+-(\d)p-([a-z0-9]+)-(\d+)x(\d+)-(filete|caixa)-[^/]+\.webp(?:[?#]|$)/i);
  if(!match || match[1] !== GLASS_FAMILY || Number(match[2]) !== PIECES) return null;
  var a = Number(match[4]), b = Number(match[5]);
  var quads = GLASS_LAYOUTS[match[3].toLowerCase()+'-'+Math.min(a,b)+'x'+Math.max(a,b)];
  return quads && quads.length === PIECES ? quads : null;
}
function drawGalleryGlass(url){
  var glass = document.querySelector('#galMain .gal-glass');
  if(!glass) return false;
  glass.innerHTML = '';
  var quads = galleryGlassQuads(url);
  if(!quads) return false; // Não inventar posição para uma família desconhecida.
  quads.forEach(function(quad){
    var xs = quad.map(function(p){return p[0];}), ys = quad.map(function(p){return p[1];});
    var left = Math.min.apply(null,xs), top = Math.min.apply(null,ys);
    var w = Math.max.apply(null,xs)-left, h = Math.max.apply(null,ys)-top;
    var pane = document.createElement('i');
    pane.className = 'gal-glass-pane';
    pane.style.left = left+'%';
    pane.style.top = top+'%';
    pane.style.width = w+'%';
    pane.style.height = h+'%';
    // Preserva também a leve perspectiva dos templates. Recuo de 1 px na
    // resolução original evita cobrir a borda antialias da moldura.
    var sx = Math.max(0,1-2/(w*12)), sy = Math.max(0,1-2/(h*8.96));
    pane.style.clipPath = 'polygon('+quad.map(function(p){
      return (50+((p[0]-left)/w*100-50)*sx)+'% '+(50+((p[1]-top)/h*100-50)*sy)+'%';
    }).join(',')+')';
    glass.appendChild(pane);
  });
  return true;
}
/* Atalho permanente de retorno ao mockup no mobile. Ele aparece sempre que existe
   uma foto ambientada pronta e a galeria já saiu da tela. */
function hideMkpJump(){
  var jump = document.getElementById('mkpJump'); if(!jump) return;
  jump.classList.remove('on');
  jump.hidden = true;
}
function showMkpJump(){
  var jump = document.getElementById('mkpJump');
  if(!jump) return;
  jump.hidden = false;
  requestAnimationFrame(function(){ jump.classList.add('on'); });
}
function updateMkpJump(){
  var box = document.getElementById('galMain');
  var hasMkp = box && (box.hasAttribute('data-mkp-visible') || box.hasAttribute('data-mkp-pending'));
  if(!box || !window.matchMedia('(max-width:1023px)').matches || !hasMkp || box.getBoundingClientRect().bottom > 0){
    hideMkpJump();
    return;
  }
  showMkpJump();
}
function pulseMkp(box){
  if(!box) return;
  box.classList.remove('mkp-attention');
  void box.offsetWidth;
  box.classList.add('mkp-attention');
  setTimeout(function(){ box.classList.remove('mkp-attention'); }, 980);
}
var mkpJumpButton = document.getElementById('mkpJump');
if(mkpJumpButton) mkpJumpButton.addEventListener('click', function(){
  var box = document.getElementById('galMain'); if(!box) return;
  var target = box.closest('.galsticky') || box;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  hideMkpJump();
  target.scrollIntoView({behavior:reduceMotion ? 'auto' : 'smooth', block:'start'});
  setTimeout(function(){ pulseMkp(box); }, reduceMotion ? 0 : 560);
});
pdpOn(window,'resize', updateMkpJump, {passive:true});
pdpOn(window,'scroll', updateMkpJump, {passive:true});
function setMkp(o){
  var bdg = document.getElementById('galBadge');
  if(bdg) bdg.textContent = PIECES + ' peça' + (PIECES>1?'s':'') + ' · arte ' + o.w + ' × ' + o.h + ' cm' + (PIECES>1?' cada':'');
  var img = document.getElementById('galImg'), next = document.getElementById('galImgNext'), thumb = document.getElementById('galThumbImg'), box = document.getElementById('galMain'), ph = document.getElementById('galPh');
  if(!img || !next || !box) return;
  // No piloto, o carregamento inicial preserva a primeira ambientada ads=1.
  // A primeira escolha do cliente libera as imagens configuráveis ads=2.
  // Sem mockups, a foto de ambiente do produto fica (o 3D faz o papel do mockup).
  if(!CONFIG_MKP_ACTIVE || (!HAS_MKP && DATA.hero)){
    img.hidden = false;
    if(thumb) thumb.hidden = false;
    box.classList.add('has-mkp');
    box.setAttribute('data-mkp-visible','catalogo-ads1');
    if(ph) ph.style.display = 'none';
    return;
  }
  box.classList.remove('is-large-mkp');
  var request = (parseInt(box.getAttribute('data-mkp-request') || '0', 10) || 0) + 1;
  box.setAttribute('data-mkp-request', request);
  var current = function(){ return !disposed && String(box.getAttribute('data-mkp-request')) === String(request); };
  var useGlass = S.glass && glassOK(S.fin);
  var glassReady = false;
  var syncGlass = function(isVisible){ box.classList.toggle('has-glass', !!isVisible && useGlass && glassReady); };
  var clearNext = function(){ next.classList.remove('is-incoming'); next.hidden = true; clearMkpImgSource(next); };
  var placeholder = function(){
    clearNext();
    img.hidden = true;
    if(thumb){ thumb.hidden = true; thumb.removeAttribute('src'); }
    box.classList.remove('has-mkp');
    box.removeAttribute('data-mkp-visible');
    box.removeAttribute('data-mkp-pending');
    syncGlass(false);
    hideMkpJump();
    if(ph) ph.style.display = '';
  };
  var u = mkpUrl(o);
  // Os mockups configuraveis sao fotografias 4:3. Esta classe corrige o palco
  // mobile sem alterar a primeira imagem quadrada ads=1 do carregamento inicial.
  box.classList.toggle('is-large-mkp', /\/pdp-mkp\/v\d+\//.test(String(u || '')));
  // Não reposicionar o reflexo enquanto a foto anterior ainda está visível.
  syncGlass(false);
  // Toda cena explicita o móvel de referência; assim a escala não depende só do olhar.
  setMkpSceneLabel(u);
  box.setAttribute('data-mkp', mkpNivel + (u ? ' · ' + u.split('/').pop() : ''));
  if(u) box.setAttribute('data-mkp-pending','');
  else box.removeAttribute('data-mkp-pending');
  // sem combinacao no banco: nem pede a URL — evita um 404 a cada troca de opcao
  if(!u){ clearMkpImgSource(img); placeholder(); return; }
  var reveal = function(){
    if(!current()) return;
    glassReady = drawGalleryGlass(u);
    img.hidden = false;
    if(thumb){ thumb.src = mkp720Url(u) || u; thumb.hidden = false; }
    box.classList.add('has-mkp');
    syncGlass(true);
    if(ph) ph.style.display = 'none';
    box.setAttribute('data-mkp-visible', absolute);
    box.removeAttribute('data-mkp-pending');
    updateMkpJump();
  };
  var absolute = new URL(u, window.location.href).href;
  var hasCurrent = !img.hidden && box.classList.contains('has-mkp') && !!img.getAttribute('src');
  if(hasCurrent && img.src === absolute){ clearNext(); reveal(); return; }

  // No primeiro carregamento não há cena anterior para preservar. Nas trocas,
  // o segundo <img> pré-carrega e só cobre o atual depois de decodificado.
  if(!hasCurrent){
    clearNext();
    img.onload = function(){ reveal(); };
    img.onerror = function(){ if(current()) placeholder(); };
    setMkpImgSource(img,u);
    return;
  }

  next.onload = function(){
    if(!current()) return;
    next.hidden = false;
    requestAnimationFrame(function(){ if(current()) next.classList.add('is-incoming'); });
    setTimeout(function(){
      if(!current()) return;
      img.onload = null;
      img.onerror = null;
      setMkpImgSource(img,u);
      var promote = function(){
        if(!current()) return;
        reveal();
        clearNext();
      };
      if(img.decode) img.decode().then(promote, promote); else promote();
    }, 190);
  };
  // Se a nova URL falhar, mantém a foto válida atual — sem voltar a um vazio.
  next.onerror = function(){ if(current()){ box.removeAttribute('data-mkp-pending'); clearNext(); updateMkpJump(); } };
  clearNext();
  setMkpImgSource(next,u);
}

/* Cartão 2 da galeria: usa o GoQ3D oficial em visão frontal. A ficha continua
   sendo a confirmação de peças e cotas, mas agora nunca perde a moldura ativa. */
function syncGalSpecAttrs(){
  var attrs = document.getElementById('galSpecAttrs'); if(!attrs) return;
  var frame = {mdf:'sem moldura', filete:'filete', padrao:'filete', caixa:'caixa', canvas:'flutuante'}[S.fin] || 'sem moldura';
  var color = S.color === 'freijo' ? 'freijó' : S.color;
  function choose(group, value){
    var input = attrs.querySelector('[data-attributegroup="'+group+'"][data-value="'+value+'"]');
    if(input) input.checked = true;
  }
  choose('MOLDURA', frame);
  choose('COR DA MOLDURA', color);
  choose('ACABAMENTO', S.glass ? 'com vidro' : 'sem vidro');
}
function drawGalSpec3D(o){
  if(!window.GoQ3D) return false;
  syncGalSpecAttrs();
  var count = PIECES === 1 ? 'one_image' : (PIECES === 2 ? 'two_images' : (PIECES === 3 ? 'three_images' : 'four_images'));
  var kind = orientationKind();
  var orient = kind === 'quadrado' ? 'quadrados' : (kind === 'paisagem' ? 'paisagens' : 'retangulares');
  var orientClass = orient === 'quadrados' ? 'Quadrados' : (orient === 'paisagens' ? 'Paisagem' : '');
  var esc = function(v){ return String(v || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
  var pieces = [];
  for(var i=0;i<PIECES;i++){
    var src = ARTS[i] || ARTS[ARTS.length-1] || '';
    if(!src) continue;
    pieces.push('<div class="product-3D wide semmoldura product-3D__'+(i+1)+' '+count+' '+orientClass+'">'+
      '<img class="product-image product-3D__image '+orientClass+'" width="100%" src="'+esc(src)+'" alt="Peça '+(i+1)+' · '+o.w+'×'+o.h+' cm" referrerpolicy="no-referrer">'+
      '<img class="product-3D__component" width="100%" height="100%" src="" alt="" style="display:none"></div>');
  }
  var inst = GoQ3D.get('specmain'); if(!inst || !inst.mount) return false;
  var move = inst.mount.querySelector('.move'); if(!move) return false;
  move.className = 'move '+count;
  move.innerHTML = pieces.join('');
  inst.attributeName = orient;
  inst.mount.classList.add('is-open');
  inst.update(true);
  requestAnimationFrame(function(){ inst.fit(); });
  [].slice.call(move.querySelectorAll('.product-3D__image')).forEach(function(image){
    if(!image.complete) image.addEventListener('load', function(){ inst.fit(); }, {once:true});
  });
  /* Miniatura é navegação: mostra as peças e a cota sem comprimir a moldura.
     A confirmação visual do acabamento vive no card seguinte, em close real. */
  var mini = document.getElementById('specArts');
  if(mini){
    var psMini = physicalSize(o), ratio = (psMini.w / psMini.h).toFixed(4), miniHtml = '';
    for(var mi=0;mi<PIECES;mi++){
      var miniSrc = ARTS[mi] || '';
      miniHtml += miniSrc ? '<img class="spec-art" style="--art-ratio:'+ratio+'" src="'+esc(miniSrc)+'" alt="Peça '+(mi+1)+' · '+o.w+'×'+o.h+' cm" loading="lazy" referrerpolicy="no-referrer">' : '<i class="spec-art" style="--art-ratio:'+ratio+'"></i>';
    }
    mini.innerHTML = miniHtml;
  }
  return pieces.length > 0;
}
function drawGalSpec(o){
  /* Com a galeria 3D, a vista Frente sai: não desenha (nem baixa a arte grande) */
  if(G3.available) return;
  var sheetUrl = ''; /* [5d] a vista Frente mostra sempre o quadro na moldura escolhida, sem a ficha técnica */
  var sheetAlt = 'Ficha técnica: '+CONJ+' '+o.w+'×'+o.h+' · '+finObj(S.fin).nome;
  [document.getElementById('techSheetMain'),document.getElementById('techSheetThumb')].forEach(function(sheet){
    if(!sheet) return;
    sheet.hidden = !sheetUrl;
    if(!sheetUrl) return;
    sheet.alt = sheetAlt;
    if(sheet.getAttribute('src') !== sheetUrl) sheet.setAttribute('src',sheetUrl);
    sheet.onerror = function(){ this.hidden = true; };
  });
  /* Os dois arquivos pendentes do designer voltam ao desenho já existente, com a
     cota correta calculada abaixo, em vez de mostrar uma medida visualmente errada. */
  if(sheetUrl) return;
  var targets = [document.getElementById('specArts'), document.getElementById('specArtsMain')];
  if(!targets[0] && !targets[1]) return;
  if(!drawGalSpec3D(o)){
    var ps = physicalSize(o), ratio = (ps.w / ps.h).toFixed(4);
    var h = '';
    for(var i=0;i<PIECES;i++){
      var src = ARTS[i] || '';
      h += src ? '<img class="spec-art" style="--art-ratio:'+ratio+'" src="'+src+'" alt="Peça '+(i+1)+' · '+o.w+'×'+o.h+' cm" loading="lazy" referrerpolicy="no-referrer">' : '<i class="spec-art" style="--art-ratio:'+ratio+'"></i>';
    }
    targets.forEach(function(arts){ if(arts) arts.innerHTML = h; });
  }
  ['','Main'].forEach(function(suffix){
    var total = document.getElementById('specTotal'+suffix);
    var detail = document.getElementById('specDetail'+suffix);
    var mounted = mountedDimensions(S.size,0);
    if(total) total.textContent = fmtCm(mounted.w) + ' no total';
    if(detail) detail.textContent = o.w+'×'+o.h+' cada · '+fmtCm(mounted.h)+' de altura · vão '+GAP+' cm';
  });
}
/* Cartão de escala humana: 50% da altura útil do palco = 170 cm. O quadro recebe
   dimensões em pixels a partir da mesma unidade, portanto retrato, paisagem e
   quadrado mantêm proporção física em avulsos, duos e trios. */
function layoutScale(o){
  var main = document.getElementById('galMain');
  var inst = window.GoQ3D && GoQ3D.get('scalemain');
  if(!main || !inst || !inst.mount) return;
  var move = inst.mount.querySelector('.move'); if(!move) return;
  var h = main.clientHeight, w = main.clientWidth; if(!h || !w) return;
  var ps = physicalSize(o), floorY = h * .92;
  /* A unidade precisa caber nos dois eixos. Nos tamanhos grandes, limitar apenas
     pela altura fazia duos e trios ultrapassarem a lateral direita do palco. */
  var heightUnit = h * .50 / 170;
  var personWidthCm = 170 * SCALE_PERSON_RATIO;
  var productWidthCm = PIECES * ps.w + Math.max(0, PIECES - 1) * GAP;
  var clusterWidthCm = personWidthCm + SCALE_HUMAN_GAP + productWidthCm;
  var viewportW = document.documentElement.clientWidth || window.innerWidth || w;
  var stageLeft = Math.max(0, main.getBoundingClientRect().left);
  var visibleW = Math.min(w, Math.max(0, viewportW - stageLeft));
  if(!visibleW) visibleW = w;
  var widthUnit = Math.max(0, visibleW - 24) / clusterWidthCm;
  var unit = Math.min(heightUnit, widthUnit);
  var gapPx = GAP * unit;
  var pieces = [].slice.call(move.querySelectorAll('.product-3D'));
  pieces.forEach(function(piece){
    piece.style.width = (ps.w * unit) + 'px';
    piece.style.height = (ps.h * unit) + 'px';
  });
  move.style.gap = gapPx + 'px';
  var totalW = PIECES * ps.w * unit + Math.max(0, PIECES - 1) * gapPx;
  var person = main.querySelector('.scale-person');
  var personH = 170 * unit, personW = personH * SCALE_PERSON_RATIO;
  var humanGapPx = SCALE_HUMAN_GAP * unit;
  var clusterW = personW + humanGapPx + totalW;
  var clusterLeft = Math.max(10, (visibleW - clusterW) / 2);
  var left = clusterLeft + personW + humanGapPx + totalW / 2;
  if(person){ person.style.left = clusterLeft + 'px'; person.style.height = personH + 'px'; }
  var ruler = main.querySelector('.scale-ruler');
  if(ruler){ ruler.style.left = Math.max(5, clusterLeft - SCALE_RULER_GAP * unit) + 'px'; ruler.style.height = (170 * unit) + 'px'; }
  move.style.left = left + 'px';
  move.style.top = (floorY - SCALE_ART_CENTER * unit) + 'px';

  var wall = main.querySelector('.scale-wall-height');
  if(wall) wall.style.height = (SCALE_WALL_HEIGHT * unit) + 'px';

  var baseCm = Math.max(0, SCALE_ART_CENTER - ps.h / 2);
  var measure = document.getElementById('scaleFloorMeasure');
  var measureValue = document.getElementById('scaleFloorValue');
  if(measure){
    var rightEdge = left + totalW / 2;
    var measureX = Math.min(visibleW - 8, rightEdge + 9);
    measure.style.left = measureX + 'px';
    measure.style.height = (baseCm * unit) + 'px';
    measure.classList.toggle('label-left', visibleW - measureX < 82);
  }
  if(measureValue){
    measureValue.textContent = (baseCm >= 100 ? (baseCm / 100).toFixed(2).replace('.', ',') + ' m' : Math.round(baseCm) + ' cm') + ' do piso';
  }
}
function drawScaleThumb(o){
  var box = document.getElementById('scaleThumbArts'); if(!box) return;
  var ps = physicalSize(o), maxW = 52, maxH = 32;
  var naturalW = PIECES * ps.w + Math.max(0, PIECES - 1) * GAP;
  var k = Math.min(maxW / naturalW, maxH / ps.h);
  var html = '';
  for(var i=0;i<PIECES;i++) html += '<i style="width:'+Math.max(3,ps.w*k).toFixed(1)+'px;height:'+Math.max(3,ps.h*k).toFixed(1)+'px"></i>';
  box.innerHTML = html;
}
function drawScale(o){
  drawScaleThumb(o);
  /* Com a galeria 3D, a escala é a da imersiva: a antiga (pessoa de 1,70 m) não aparece nem baixa a arte */
  if(!window.GoQ3D || G3.available) return false;
  syncGalSpecAttrs();
  var kind = orientationKind();
  var orient = kind === 'quadrado' ? 'quadrados' : (kind === 'paisagem' ? 'paisagens' : 'retangulares');
  var orientClass = orient === 'quadrados' ? 'Quadrados' : (orient === 'paisagens' ? 'Paisagem' : '');
  var count = PIECES === 1 ? 'one_image' : (PIECES === 2 ? 'two_images' : (PIECES === 3 ? 'three_images' : 'four_images'));
  var esc = function(v){ return String(v || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
  var html = '';
  for(var i=0;i<PIECES;i++){
    var src = ARTS[i] || ARTS[ARTS.length-1] || '';
    if(!src) continue;
    html += '<div class="product-3D wide semmoldura product-3D__'+(i+1)+' '+count+' '+orientClass+'">'+
      '<img class="product-image product-3D__image '+orientClass+'" src="'+esc(src)+'" alt="Peça '+(i+1)+' em escala" referrerpolicy="no-referrer">'+
      '<img class="product-3D__component" src="" alt="" style="display:none"></div>';
  }
  var inst = GoQ3D.get('scalemain'); if(!inst || !inst.mount) return false;
  var move = inst.mount.querySelector('.move'); if(!move) return false;
  move.className = 'move active '+count;
  move.innerHTML = html;
  inst.attributeName = orient;
  inst.update(false);
  inst.mount.classList.add('is-open');
  inst.mount.setAttribute('aria-hidden','false');
  var carousel = inst.mount.querySelector('.goq3d__carousel'); if(carousel) carousel.classList.add('fit-ready');
  layoutScale(o);
  var ps = physicalSize(o), orientLabel = kind === 'quadrado' ? 'quadrado' : kind;
  var title = document.getElementById('scaleProductSize');
  var detail = document.getElementById('scaleProductDetail');
  if(title) title.textContent = CONJ+' '+o.w+'×'+o.h+' · '+orientLabel;
  var mounted = mountedDimensions(o.k,0);
  if(detail) detail.textContent = (PIECES > 1 ? fmtCm(mounted.w)+' × '+fmtCm(mounted.h)+' montado' : fmtCm(mounted.w)+' × '+fmtCm(mounted.h)+' na parede') + ' · centro a 1,45 m';
  return !!html;
}
/* Cartão 3: foto de produto explicativa, sem tentar representar a arte do kit. */
function drawGalFinish(){
  /* [22/10/2026] o 5d esconde a vista "Acabamento" (#galDetail com pd-hide): sem desenhar, ela não baixa
     a foto grande do acabamento a cada troca */
  var detailThumb = document.getElementById('galDetail');
  if(!detailThumb || detailThumb.classList.contains('pd-hide')) return;
  var f = finObj(S.fin);
  var src = finishPhoto(S.fin,S.color);
  var label = f.nome + (colorOK(S.fin) ? ' · ' + colName(S.color) : '');
  var image = document.getElementById('finishImg');
  var miniImage = document.getElementById('detailMiniImg');
  var name = document.getElementById('finishName');
  var meta = document.getElementById('finishMeta');
  var mini = document.getElementById('detailMiniValue');
  [image, miniImage].forEach(function(el){ if(el){ el.src = src; el.alt = 'Detalhe do acabamento ' + label; } });
  if(name) name.textContent = label;
  if(meta) meta.textContent = FINISH_META[S.fin] || '';
  if(mini) mini.textContent = f.nome;
}
/* ═══════════ GALERIA 3D ═══════════
   Módulo do projeto quadro-3d (assets/gq3d-galeria.js, gerado por `npm run build:galeria -- --theme`):
   a vitrine abre no quadro em 3D (inclina com o mouse; clicar e segurar gira 360°; no celular, o
   arrasto horizontal gira e o vertical rola a página). "Na parede" e "Escala" são as vistas da
   página imersiva: na primeira escolha de tamanho, acabamento ou cor, o quadro é pendurado na
   parede. O módulo começa a baixar com a página (<script type="module"> na seção); enquanto ele
   chega, as artes aparecem emolduradas no mesmo lugar (#gq3gPoster). Sem WebGL 2, a galeria é a de
   antes (Frente, mockups e escala com a pessoa). */
var G3 = {available:false, handle:null, ready:false, hung:false, room:null, roomSel:null};
var G3_SLIDES = {'3d':'frente', ambiente:'parede', escala:'escala'};
function g3Active(){ return G3.available && !!G3_SLIDES[GAL_SLIDE]; }
function g3Arts(){
  /* A textura do 3D baixa a arte num endereço só dela (gq3d=1), separado das imagens do pôster: com
     o currentSrc do srcset do pôster, o Safari do iPhone mostrava a arte ampliada e cortada (15/10;
     suspeita: o tamanho da imagem vem corrigido pela densidade do srcset e a textura fica menor
     que a imagem). No celular basta a de 1000 px. */
  var narrow = window.innerWidth < 768;
  var arts = (DATA.arts3d || []).map(function(url){
    var u = new URL(url, window.location.href);
    if(narrow && u.searchParams.get('width') === '1500') u.searchParams.set('width', '1000');
    u.searchParams.set('gq3d', '1');
    return u.href;
  });
  return arts.slice(0, Math.max(1, PIECES));
}
function g3Config(){
  var o = physicalSize(sizeObj(S.size));
  return {
    finish: fin3D(window.GQ3DGaleria),
    glass: !!(S.glass && glassOK(S.fin)),
    color: S.color,
    width: o.w,
    height: o.h,
    arts: g3Arts(),
    mode: G3_SLIDES[GAL_SLIDE] || 'frente',
    /* o móvel escolhido em "Me ajude a escolher" (sofá ou cama): a parede é a desse ambiente */
    room: G3.roomSel || undefined
  };
}
/* Pôster: a moldura escolhida em volta das artes (a cor e a largura aproximadas), até o 3D aparecer */
function g3Poster(){
  var poster = document.getElementById('gq3gPoster'); if(!poster) return;
  poster.style.setProperty('--fc', colorOK(S.fin) ? colorHex(S.color) : 'transparent');
  poster.setAttribute('data-fin', S.fin);
  var n = Math.max(1, Math.min(PIECES, poster.children.length));
  poster.style.setProperty('--n', n);
  [].slice.call(poster.children).forEach(function(el, i){ el.hidden = i >= n; });
}
/* [22/10/2026] Com fotos (no computador também, desde 23/10/2026): o pôster vem com um <source> de 1 px,
   para as artes não disputarem a banda com a foto principal. Aqui entram as de verdade (data-srcset), na
   1ª interação com a página ou ao abrir o 3D (ensureG3). O data-srcset só sai quando a arte chega: até lá
   o CSS esconde a moldura vazia. */
function g3PosterArts(){
  var poster = document.getElementById('gq3gPoster'); if(!poster) return;
  [].slice.call(poster.querySelectorAll('source[data-srcset]')).forEach(function(source){
    var real = source.getAttribute('data-srcset');
    if(source.getAttribute('srcset') === real) return;
    var img = source.nextElementSibling;
    var done = function(){ source.removeAttribute('data-srcset'); };
    if(img){
      img.addEventListener('load', done, {once:true});
      img.addEventListener('error', done, {once:true});
    } else done();
    source.setAttribute('srcset', real);
  });
}
function initGaleria(){
  var main = document.getElementById('gq3gMain'), host = document.getElementById('gq3gHost');
  if(!main || !host || !DATA.galeria || !(DATA.arts3d || []).length) return;
  try {
    var gl = document.createElement('canvas').getContext('webgl2');
    if(!gl) throw new Error('sem WebGL 2');
    var lose = gl.getExtension('WEBGL_lose_context'); if(lose) lose.loseContext();
  } catch(e) {
    main.hidden = true;
    return;
  }
  G3.available = true;
  document.getElementById('pdp-c').classList.add('has-g3');
  var thumb = document.getElementById('gal3dThumb'); if(thumb) thumb.hidden = false;
  var front = document.getElementById('galSpec'); if(front) front.hidden = true;
  GAL_SLIDE = '3d';
  g3Poster();
  var mount = function(api){
    if(disposed || G3.handle || !api) return;
    var full = {}, small = {}, assets = DATA.galeriaAssets || {};
    var abs = function(map, out){ Object.keys(map || {}).forEach(function(key){ out[key] = new URL(map[key], window.location.href).href; }); };
    abs(assets.full, full); abs(assets.small, small);
    try {
      G3.handle = api.mount(host, g3Config(), {
        assets: {full: full, small: small},
        room: DATA.room || null,
        background: getComputedStyle(main).backgroundColor || '#f4f1ec',
        /* as pílulas cobrem a faixa de cima da vitrine; no celular só há a da vista, no pé (em cima, 14 desde
           22/10/2026: a vitrine ficou mais baixa) */
        insets: window.innerWidth < 750 ? {top: 14, right: 14, bottom: 46, left: 14} : {top: 56, right: 20, bottom: 20, left: 20},
        onReady: function(){ G3.ready = true; main.classList.add('is-ready'); },
        onRoom: function(room){ G3.room = room; if(g3Active()) setGalSlide(GAL_SLIDE); }
      });
      /* Trocar o produto na categoria interativa (GoQPdpD.destroy) desmonta o 3D: sem isso o
         contexto WebGL anterior seguia vivo, fora da tela, a cada troca */
      pdpCleanups.push(function(){ if(G3.handle){ G3.handle.destroy(); G3.handle = null; } });
    } catch(err) {
      if(window.console) console.error('[gq galeria 3d]', err);
    }
  };
  /* [22/10/2026] A vitrine abre nas fotos (no computador também, desde 23/10/2026): o 3D só monta com 3D,
     Na parede ou Escala na tela (o palco escondido mede 0×0). Ao voltar das fotos, o ResizeObserver do
     módulo refaz o tamanho. */
  G3.tryMount = function(){
    /* G3.mounting: o módulo chama onRoom dentro do próprio mount, e o setGalSlide de lá chama o ensureG3 */
    if(G3.handle || G3.mounting || !window.GQ3DGaleria || !g3Active()) return;
    G3.mounting = true;
    try { mount(window.GQ3DGaleria); } finally { G3.mounting = false; }
  };
  if(window.GQ3DGaleria) G3.tryMount();
  else window.addEventListener('gq3d:galeria', G3.tryMount, {once:true});
  /* O módulo (~220 KB) só é pedido depois que a arte da vitrine carrega: no celular ele disputava a
     banda com ela (a imagem que aparece primeiro). Tag <script type="module">: a Shopify troca o
     import() dinâmico dos JS do tema por require(). */
  var requested = false;
  var load = function(){
    if(requested || window.GQ3DGaleria) return;
    requested = true;
    var tag = document.createElement('script');
    tag.type = 'module';
    tag.src = DATA.galeria;
    document.head.appendChild(tag);
  };
  G3.load = load;
  /* Quando baixar (22/10/2026): só depois de uma interação (G3.interacted; ensureG3 respeita).
     - Celular: o 1º toque ou tecla na página pré-baixa; o 3D monta quando "ver ambiente"/"3D" abre.
     - Computador: o 1º movimento do mouse, rolagem, toque ou tecla pré-baixa, para o 3D abrir rápido na
       miniatura "3D" ou na 1ª escolha (a vitrine abre na foto desde 23/10/2026; sem foto, no pôster das
       artes emolduradas). No Chrome sem placa de vídeo dos testes (o do PageSpeed), o WebGL era desenhado
       no processador: 40 s de thread principal no carregamento.
     Sem timer de reserva, de propósito: com timer o 3D voltaria para dentro da medição. */
  var wake = function(){ G3.interacted = true; ensureG3(); };
  if(isPhone()){
    var stage = document.querySelector('#pdp-c .pdp');
    if(stage){
      stage.addEventListener('pointerdown', wake, {once:true, passive:true});
      stage.addEventListener('keydown', wake, {once:true});
    }
  } else {
    ['pointermove','pointerdown','wheel','keydown','touchstart','scroll'].forEach(function(type){
      pdpOn(window, type, wake, {once:true, passive:true});
    });
  }
  /* A foto do ambiente começa a baixar quando a pessoa encosta no painel de escolha */
  var buy = document.querySelector('#pdp-c .col-buy');
  if(buy) buy.addEventListener('pointerdown', function(){ if(G3.handle) G3.handle.prepareRoom(); }, {once:true, passive:true});
}
initGaleria();
function g3Update(){
  g3Poster();
  if(G3.handle) G3.handle.update(g3Config());
}
function g3Label(){
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  var room = G3.room;
  if(GAL_SLIDE === 'ambiente') return 'Na parede' + (room ? ' · ' + room.above : '');
  if(GAL_SLIDE === 'escala') return 'Escala real' + (room ? ' · ' + room.label.toLowerCase() : '');
  return coarse ? '3D · arraste para girar' : '3D · passe o mouse ou arraste para girar';
}

/* ═══════════ QUADRO EM 3D ═══════════
   Visualizador do projeto quadro-3d (assets/gq3d-viewer.js, gerado por
   `npm run build:embed -- --theme`): o quadro montado na configuração escolhida, para girar.
   Só baixa (≈340 KB de código + texturas) quando a pessoa abre o 3D; sem WebGL 2 ou sem as
   artes do produto, a miniatura não aparece. No celular (até 768px) o 3D fica de fora: sem
   "Ver em 3D" e "Por dentro", a galeria é só fotos, medidas e escala. */
var VIEW3D = {available:false, viewer:null, loading:false};
/* Roda de novo quando o personalizado ganha a foto do cliente (GoQPdpD.setArts). */
function init3D(){
  /* Com a galeria 3D, o visualizador antigo fica de fora (a miniatura "3D" é a da galeria) */
  if(VIEW3D.available || G3.available) return;
  var thumb = document.getElementById('gal3dThumb');
  if(!thumb || !DATA.viewer || !(DATA.arts3d || []).length) return;
  try {
    var gl = document.createElement('canvas').getContext('webgl2');
    if(!gl) return;
    var lose = gl.getExtension('WEBGL_lose_context'); if(lose) lose.loseContext();
  } catch(e) { return; }
  VIEW3D.available = true;
  thumb.hidden = false;
  var explodeThumb = document.getElementById('galExplodeThumb');
  if(explodeThumb) explodeThumb.hidden = false;
  var stage = document.getElementById('gal3dMain');
  if(!stage) return;
  stage.addEventListener('pointerdown', function(){ stage.classList.add('touched'); }, {once:true});
  stage.addEventListener('click', function(e){
    var zoom = e.target.closest('[data-3d-zoom]'), reset = e.target.closest('[data-3d-reset]');
    if(e.target.closest('[data-3d-full]')){ setFull3D(!isFull3D()); return; }
    if(!VIEW3D.viewer) return;
    if(zoom) VIEW3D.viewer.zoom(zoom.getAttribute('data-3d-zoom') === 'in' ? 0.8 : 1.25);
    if(reset) VIEW3D.viewer.reset();
  });
}
init3D();
/* [22/10/2026] Abre nas fotos (a foto principal primeiro; no computador também, desde 23/10/2026); o 3D fica
   em "ver ambiente"/"Na parede" e "3D" e só baixa e monta quando uma delas abre (ou na 1ª interação) */
function ensureG3(){
  if(!G3.available) return;
  g3PosterArts();
  /* baixa só depois de uma interação (G3.interacted, ver initGaleria); monta se o módulo já chegou */
  if(G3.interacted && G3.load) G3.load();
  if(G3.tryMount) G3.tryMount();
}
if(fotosOK()) GAL_SLIDE = 'fotos';
/* Tela cheia do 3D: a do navegador quando existe (no iPhone o Safari só a permite em vídeo);
   sem ela, a área do 3D cobre a página (classe is-fullscreen) e a rolagem fica travada. */
function fullscreenNow(){ return document.fullscreenElement || document.webkitFullscreenElement || null; }
function isFull3D(){
  var stage = document.getElementById('gal3dMain');
  return !!stage && (fullscreenNow() === stage || stage.classList.contains('is-fullscreen'));
}
function syncFull3D(){
  var stage = document.getElementById('gal3dMain'); if(!stage) return;
  var on = isFull3D();
  stage.classList.toggle('is-full', on);
  var button = stage.querySelector('[data-3d-full]');
  if(button){
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.setAttribute('aria-label', on ? 'Sair da tela cheia' : 'Ver em tela cheia');
  }
}
function pseudoFull3D(on){
  var stage = document.getElementById('gal3dMain'); if(!stage) return;
  stage.classList.toggle('is-fullscreen', on);
  document.documentElement.classList.toggle('gq3d-lock', on);
  syncFull3D();
}
function setFull3D(on){
  var stage = document.getElementById('gal3dMain'); if(!stage) return;
  if(!on){
    if(fullscreenNow() === stage) (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    pseudoFull3D(false);
    return;
  }
  var request = stage.requestFullscreen || stage.webkitRequestFullscreen;
  if(!request){ pseudoFull3D(true); return; }
  try {
    var result = request.call(stage);
    if(result && result.catch) result.catch(function(){ pseudoFull3D(true); });
  } catch(err) { pseudoFull3D(true); }
}
pdpOn(document, 'fullscreenchange', syncFull3D);
pdpOn(document, 'webkitfullscreenchange', syncFull3D);
pdpOn(document, 'keydown', function(e){
  var stage = document.getElementById('gal3dMain');
  if(e.key === 'Escape' && stage && stage.classList.contains('is-fullscreen')) pseudoFull3D(false);
});

function config3D(){
  var o = physicalSize(sizeObj(S.size));
  return {
    finish: fin3D(window.GQ3DViewer),
    glass: !!(S.glass && glassOK(S.fin)),
    color: S.color,
    width: o.w,
    height: o.h,
    arts: (DATA.arts3d || []).slice(0, Math.max(1, PIECES)),
    exploded: GAL_SLIDE === 'explode'
  };
}
function open3D(){
  if(!VIEW3D.available || VIEW3D.viewer || VIEW3D.loading) return;
  var stage = document.getElementById('gal3dMain'), canvas = document.getElementById('gal3dCanvas');
  if(!stage || !canvas) return;
  VIEW3D.loading = true;
  stage.classList.remove('is-error');
  loadViewer(new URL(DATA.viewer, window.location.href).href).then(function(mod){
    VIEW3D.viewer = mod.mount(canvas, config3D(), {
      textures: Object.keys(DATA.textures3d || {}).reduce(function(all, key){
        all[key] = new URL(DATA.textures3d[key], window.location.href).href; return all;
      }, {}),
      background: '#faf7f2',
      // Toque (celular/tablet): gira só na horizontal; arrastar na vertical rola a página.
      horizontalOnly: window.matchMedia('(pointer: coarse)').matches,
      onReady: function(){ stage.classList.add('is-ready'); }
    });
  }).catch(function(err){
    if(window.console) console.error('[gq 3d]', err);
    stage.classList.add('is-error');
    var loading = document.getElementById('gal3dLoading');
    if(loading) loading.textContent = 'Não foi possível abrir o 3D agora.';
  }).then(function(){ VIEW3D.loading = false; });
}
/* Carrega o módulo do visualizador por uma tag <script type="module">, que se registra em
   window.GQ3DViewer. Não usa import(): a Shopify minifica este arquivo e troca o import()
   dinâmico por require(), que não existe no navegador. */
function loadViewer(url){
  return new Promise(function(resolve, reject){
    if(window.GQ3DViewer) return resolve(window.GQ3DViewer);
    var script = document.createElement('script');
    script.type = 'module';
    script.src = url;
    script.onload = function(){ window.GQ3DViewer ? resolve(window.GQ3DViewer) : reject(new Error('visualizador 3D sem registro')); };
    script.onerror = function(){ reject(new Error('não foi possível baixar o visualizador 3D')); };
    document.head.appendChild(script);
  });
}
function update3D(){
  if(VIEW3D.viewer) VIEW3D.viewer.update(config3D());
}

function setGalSlide(slide){
  /* "fotos" só existe com foto do produto (22/10/2026); sem ela, a vitrine vai para a vista de abertura */
  if(slide === 'fotos' && !fotosOK()) slide = G3.available ? '3d' : 'medidas';
  if(G3.available && (slide === 'medidas' || slide === 'explode')) slide = '3d';
  GAL_SLIDE = slide === 'fotos' ? 'fotos' : (slide === 'medidas' ? 'medidas' : (slide === 'detalhe' ? 'detalhe' : (slide === 'escala' ? 'escala' : ((slide === '3d' && (G3.available || VIEW3D.available)) || (slide === 'explode' && VIEW3D.available) ? slide : 'ambiente'))));
  var inG3 = g3Active();
  var g3main = document.getElementById('gq3gMain');
  if(g3main && G3.available){
    g3main.hidden = !inG3;
    /* depois da partida, trocar de vista (pela pessoa ou por GoQPdpD.showSlide) conta como querer o 3D */
    if(inG3){ if(G3.booted) G3.interacted = true; ensureG3(); g3Update(); }
  }
  var fotoDots = document.getElementById('galDots');
  if(fotoDots) fotoDots.hidden = GAL_SLIDE !== 'fotos' || FOTOS_N < 2;
  var galleryMain = document.getElementById('galMain');
  var main = document.getElementById('galSpecMain');
  var finish = document.getElementById('galFinishMain');
  var scale = document.getElementById('galScaleMain');
  var img = document.getElementById('galImg');
  var ph = document.getElementById('galPh');
  var meta = document.getElementById('galMeta');
  var badge = document.getElementById('galBadge');
  var scene = document.getElementById('galScene');
  var rule = document.getElementById('galRule');
  var collapseValue = document.getElementById('galleryCollapseValue');
  var hasMkp = !!(galleryMain && galleryMain.classList.contains('has-mkp') && img && img.getAttribute('src'));
  if(galleryMain){
    /* o CSS do celular mostra a camada de fotos com data-view="fotos" (já vem assim no HTML) */
    galleryMain.setAttribute('data-view', GAL_SLIDE);
    /* Na galeria 3D a vitrine fica do mesmo tamanho nas três vistas (as classes antigas mudavam a proporção) */
    galleryMain.classList.toggle('showing-scale',GAL_SLIDE === 'escala' && !inG3);
    galleryMain.classList.toggle('showing-ambient',GAL_SLIDE === 'ambiente' && !inG3);
    galleryMain.classList.toggle('showing-3d',(GAL_SLIDE === '3d' || GAL_SLIDE === 'explode') && !inG3);
    galleryMain.classList.toggle('showing-g3',inG3);
    galleryMain.setAttribute('data-g3', inG3 ? G3_SLIDES[GAL_SLIDE] : '');
  }
  // "Ver em 3D" e "Por dentro" usam o mesmo visualizador: trocar entre eles anima as camadas
  var stage3d = document.getElementById('gal3dMain');
  var in3D = !G3.available && (GAL_SLIDE === '3d' || GAL_SLIDE === 'explode');
  if(stage3d){
    stage3d.hidden = !in3D;
    stage3d.classList.toggle('is-exploded', GAL_SLIDE === 'explode');
  }
  if(in3D){ open3D(); update3D(); }
  if(main) main.hidden = GAL_SLIDE !== 'medidas';
  if(finish) finish.hidden = GAL_SLIDE !== 'detalhe';
  if(scale) scale.hidden = GAL_SLIDE !== 'escala' || inG3;
  if(img) img.hidden = GAL_SLIDE !== 'ambiente' || !hasMkp || inG3;
  if(ph) ph.style.display = (GAL_SLIDE !== 'ambiente' || hasMkp || inG3) ? 'none' : '';
  if(meta) meta.hidden = GAL_SLIDE !== 'ambiente';
  if(badge) badge.hidden = GAL_SLIDE !== 'ambiente';
  if(scene) scene.hidden = GAL_SLIDE !== 'ambiente' || !scene.textContent;
  if(rule) rule.hidden = GAL_SLIDE !== 'ambiente';
  [].slice.call(document.querySelectorAll('[data-slide]')).forEach(function(button){
    button.setAttribute('aria-pressed', button.getAttribute('data-slide') === GAL_SLIDE ? 'true' : 'false');
  });
  var viewPill = document.getElementById('pdView');
  if(viewPill && inG3) viewPill.textContent = g3Label();
  else if(viewPill) viewPill.textContent = ({medidas:'Vista de frente', ambiente:'Na parede', escala:'Escala · 1,70 m', '3d':'3D · arraste para girar', explode:'Por dentro', detalhe:'Acabamento em detalhe'})[GAL_SLIDE] || '';
  if(collapseValue){
    var galleryLabels = {fotos:'Foto',ambiente:'Ambiente','3d':'Quadro em 3D',explode:'Por dentro',medidas:'Medidas',detalhe:'Acabamento',escala:'Escala real'};
    var galleryLabel = galleryLabels[GAL_SLIDE] || galleryLabels.ambiente;
    if(GAL_SLIDE==='detalhe') galleryLabel += ' · ' + (S.fin==='canvas' ? 'Flutuante' : finObj(S.fin).nome);
    var galleryCount = document.querySelectorAll('#galStrip > *').length;
    collapseValue.textContent = galleryLabel + ' · ' + galleryCount + ' opções';
  }
  if(GAL_SLIDE === 'medidas' && window.GoQ3D){
    requestAnimationFrame(function(){
      var inst = GoQ3D.get('specmain'); if(inst) inst.fit();
    });
  } else if(GAL_SLIDE === 'escala' && !inG3){
    requestAnimationFrame(function(){ layoutScale(sizeObj(S.size)); });
  }
}
/* Medidas e acabamento voltam para a cena ambientada ao trocar opção. A escala
   humana é a exceção: ela permanece aberta para comparar tamanhos e molduras. */
var mobileStageScrollFrame = 0;
function highlightMockup(){
  /* [5d] A vitrine fica na vista em que está (Frente, Na parede, Escala, 3D) e reage à
     variante. Não rola a página a cada escolha.
     Galeria 3D: na primeira escolha, com a vitrine no 3D, o quadro é pendurado na parede (uma vez;
     depois a vista é a que a pessoa escolher).
     Celular (22/10/2026): na primeira escolha com a vitrine nas fotos, ela vai para "ver ambiente" (o
     quadro na parede com a escolha), também uma vez. */
  if(GAL_SLIDE === 'fotos' && !FOTOS_LEFT && (G3.available || HAS_MKP)){
    FOTOS_LEFT = true;
    G3.hung = true;
    setGalSlide('ambiente');
    return;
  }
  if(G3.available && !G3.hung && GAL_SLIDE === '3d'){
    G3.hung = true;
    setGalSlide('ambiente');
  }
}

/* ═══════════ RENDER GERAL ═══════════ */
function render(){
  var o = sizeObj(S.size), po = physicalSize(o), f = finObj(S.fin);
  if(!colorOK(S.fin)) { document.getElementById('condColor').classList.remove('on'); }
  else { document.getElementById('condColor').classList.add('on'); }
  if(!glassOK(S.fin)) { S.glass = 0; document.getElementById('condGlass').classList.remove('on'); }
  else { document.getElementById('condGlass').classList.add('on'); }
  press(document.getElementById('selGlass'),'data-g',String(S.glass));

  drawSizes(); drawFins(); drawColors(); drawComp();
  var materialSelector = document.getElementById('selMaterial');
  if(materialSelector){
    press(materialSelector,'data-material',S.fin==='canvas' ? 'canvas' : 'paper');
    var canvasMaterial = materialSelector.querySelector('[data-material="canvas"]');
    if(canvasMaterial) canvasMaterial.disabled = !FINS.some(function(option){ return option.k==='canvas'; });
  }

  /* galeria + recebe */
  var mounted = mountedDimensions(S.size, 0), wMont = mounted.w;
  document.getElementById('galW').textContent = fmtCm(wMont) + ' × ' + fmtCm(mounted.h);
  setMkp(o);
  requestAnimationFrame(updateMkpJump);
  drawGalSpec(o);
  drawGalFinish();
  drawScale(o);
  setGalSlide(GAL_SLIDE);
  var rM = document.getElementById('rMont'); if(rM) rM.textContent = fmtCm(wMont) + ' × ' + fmtCm(mounted.h);
  document.getElementById('rPeca').textContent = o.w + ' × ' + o.h + ' cm';
  document.getElementById('rMat').textContent = f.mat;
  var acab = f.nome + (colorOK(S.fin) ? ' · ' + colName(S.color) : '') + (S.glass&&glassOK(S.fin) ? ' · com vidro' : '');
  document.getElementById('rAcab').textContent = acab;
  [].slice.call(document.querySelectorAll('.recebe-grid .pc')).forEach(function(pc){ var m = pc.querySelector('.pcm'); if(m) m.textContent = o.w+'×'+o.h; var im = pc.querySelector('.art img'); if(im) im.style.width = ''; });
  var objW = document.getElementById('objW');
  if(objW) objW.textContent = fmtCm(wMont) + ' × ' + fmtCm(mounted.h);

  /* preço */
  var up = compTotal();
  document.getElementById('pNow').textContent = brl(up);
  /* a linha do Pix (#pParc) é do resumo (drawResumo, no fim do render5d) */
  document.getElementById('fCfg').textContent = shareConfigLabel();
  var mobileCfg = document.getElementById('mobileCfg');
  if(mobileCfg) mobileCfg.textContent = shareConfigLabel();
  var collapseSize = document.getElementById('collapseSize');
  if(collapseSize) collapseSize.textContent = po.w+' × '+po.h+' cm';
  var collapseMaterial = document.getElementById('collapseMaterial');
  if(collapseMaterial) collapseMaterial.textContent = String(f.mat || '').replace(/\s+fosco$/i,'');
  var collapseFrame = document.getElementById('collapseFrame');
  if(collapseFrame){
    var collapseFrameName = S.fin==='mdf' ? 'Sem moldura' : (S.fin==='canvas' ? 'Flutuante' : f.nome);
    collapseFrame.textContent = collapseFrameName;
  }
  var collapseColor = document.getElementById('collapseColor');
  var collapseColorRow = document.getElementById('collapseColorRow');
  if(collapseColor) collapseColor.textContent = colorOK(S.fin) ? colName(S.color) : 'Não se aplica';
  if(collapseColorRow) collapseColorRow.disabled = !colorOK(S.fin);
  var collapseGlass = document.getElementById('collapseGlass');
  var collapseGlassRow = document.getElementById('collapseGlassRow');
  if(collapseGlass) collapseGlass.textContent = glassOK(S.fin) ? (S.glass ? 'Com vidro' : 'Sem vidro') : 'Não se aplica';
  if(collapseGlassRow) collapseGlassRow.disabled = !glassOK(S.fin);
  var wallCurrentPrice = document.getElementById('wallCurrentPrice');
  if(wallCurrentPrice) wallCurrentPrice.textContent = brl(unitPrice());
  var wallCurrentMeta = document.getElementById('wallCurrentMeta');
  if(wallCurrentMeta) wallCurrentMeta.textContent = PIECES+' peça'+(PIECES>1?'s':'')+' · '+o.w+'×'+o.h+' · '+fmtWall(montado(S.size,0))+' de parede';
  var finSpec = document.getElementById('finSpec');
  if(finSpec){ finSpec.textContent = FINISH_LINE[S.fin] || FINISH_META[S.fin] || f.desc || ''; scheduleFit(); }
  var tfh = document.getElementById('tabFinTh');
  if (tfh) { var so2 = sizeObj(S.size); tfh.textContent = 'No ' + so2.w + '\u00d7' + so2.h; }
  [].slice.call(document.querySelectorAll('[data-finprice]')).forEach(function(td){
    var pf = priceFor(td.getAttribute('data-finprice'), S.size);
    td.textContent = pf == null ? '—' : brl(pf);
  });
  document.getElementById('estFlag').classList.remove('on'); // preço do ERP: nada interpolado
  var vd = document.getElementById('vidroDelta');
  if (vd) { var b0 = base(S.fin,S.size), g0 = PRICE_GLASS[S.fin] && PRICE_GLASS[S.fin][S.size];
    vd.textContent = (glassOK(S.fin) && b0!=null && g0!=null) ? '+ ' + brl(g0 - b0) + ' neste tamanho' : 'muda com o tamanho'; }

  var tot = compTotal();
  /* CTA + sticky */
  var cfg = CONJ+' '+o.w+'×'+o.h+' · '+f.nome.toLowerCase()+((PIECES+extraPieces())>1 ? ' · '+(PIECES+extraPieces())+' peças · '+fmtCm(montado(S.size,extraPieces()))+' montado' : '');
  document.getElementById('ctaVal').textContent = brl(tot);
  document.getElementById('ctaSub').textContent = cfg;
  document.getElementById('stkVal').textContent = brl(tot);
  document.getElementById('stkCfg').textContent = cfg;
  var proposedWall = S.comp > 1;
  var ctaAction = document.getElementById('ctaAction');
  /* Na categoria interativa vale o mesmo texto da página de produto: o da PDP D ("Adicionar ao
     carrinho", sem o " · ") colava no preço ("CARRINHOR$ 649,90") */
  if(ctaAction) ctaAction.textContent = proposedWall ? 'Montar pelo WhatsApp · ' : 'Adicionar à sacola · ';
  var stickyButton = document.getElementById('stkBtn');
  /* "à sacola": CSS .pd-stk-more. Desde 27/10/2026 aparece também no computador, onde a barra vem desde a 1ª tela */
  if(stickyButton) stickyButton.innerHTML = proposedWall ? 'Montar' : 'Adicionar<span class="pd-stk-more"> à sacola</span>';
  var sc = document.getElementById('shareCfg');
  if(sc) sc.textContent = shareConfigLabel();
  var fullProductLink = document.getElementById('pdpFullLink');
  if(fullProductLink){
    fullProductLink.href = sharedPdpUrl();
    var reviewsLink = document.getElementById('revCount');
    if(reviewsLink) reviewsLink.href = sharedPdpUrl() + '#pdpc-reviews';
  }
  var ok = !!S.size && !!S.fin;
  document.getElementById('ctaMain').disabled = !ok;
  document.getElementById('stkBtn').disabled = !ok;
  render5d(o);
  // Trocou a peça depois de cotar: o frete volta para o prazo da região (o valor sai num toque).
  requoteIfNeeded();
  update3D();
  RENDER_HOOKS.forEach(function(fn){ try { fn(); } catch(e) { if(window.console) console.error(e); } });
}
var RENDER_HOOKS = [];
function colName(k){ for(var i=0;i<COLORS.length;i++){ if(COLORS[i].k===k) return COLORS[i].nome; } return ''; }

/* ═══════════ SIMULADOR ═══════════ */
function drawLarg(){
  var box = document.getElementById('simLarg');
  if(!S.mov){ box.innerHTML = '<button disabled>escolha o móvel primeiro</button>'; return; }
  press(document.getElementById('simMov'),'data-m',S.mov);
  var h='';
  LARG[S.mov].forEach(function(l){
    h += '<button data-l="'+l.k+'" aria-pressed="'+(S.larg===l.k?'true':'false')+'">'+l.l+'</button>';
  });
  box.innerHTML = h;
  requestAnimationFrame(function(){ updateVariantNav(box); });
  document.getElementById('simUnit').textContent = S.mov==='cama' ? 'tamanho da cama' : 'em cm';
}
function simRun(focusAdvice){
  if(usesMobileControls()) drawSizes(!!focusAdvice);
  var out = document.getElementById('simOut');
  // A galeria acompanha o movel escolhido, nao so o tamanho: trocar Sofa->Cama tem que
  // trocar a foto. O simRun nao passa pelo render(), entao a atualizacao vem daqui.
  // Fica ANTES do return de baixo: escolher so o movel, sem a largura, ja muda a cena.
  setMkp(sizeObj(S.size));
  setGalSlide(GAL_SLIDE);
  if(!S.mov || !S.larg){ out.style.display='none'; return; }
  out.style.display='block';
  var key = S.mov+'|'+S.larg;
  var reco = SIM[key];
  var furn = 0;
  LARG[S.mov].forEach(function(l){ if(l.k===S.larg) furn = l.w; });
  var o = sizeObj(reco);
  var w = montado(reco,0);
  var cov = Math.round(w/furn*100);
  var pr = priceFor(S.fin,reco);
  var mk = isMeasured(S.fin,reco) ? '' : '≈';

  document.getElementById('recoBig').textContent = CONJ + ' ' + o.w + '×' + o.h + ' cm';
  document.getElementById('recoW').textContent = fmtCm(w);
  document.getElementById('recoP').textContent = cov + '%';
  document.getElementById('recoPc').textContent = o.w + '×' + o.h + ' cm';
  document.getElementById('recoPr').textContent = pr==null ? '—' : brl(pr);

  var btn = document.getElementById('recoApply');
  if(S.size === reco){ btn.textContent = '✓ Aplicado no seu pedido'; btn.disabled = true; }
  else { btn.textContent = usesMobileControls() ? 'Usar esse tamanho' : 'Aplicar no meu pedido'; btn.disabled = false; }
  btn.setAttribute('data-apply', reco);

  var warn = document.getElementById('simWarn');
  if(cov > 100){
    warn.classList.add('on');
    warn.innerHTML = 'Essa composição fica <b>'+(Math.round(w-furn))+' cm mais larga que o móvel</b>. Veja uma opção mais discreta abaixo.';
  } else { warn.classList.remove('on'); }

  /* alternativas: um degrau abaixo e um acima */
  var idx = 0; SIZES.forEach(function(s,i){ if(s.k===reco) idx=i; });
  var alts = [];
  if(idx>0) alts.push({s:SIZES[idx-1], rot:'Mais discreto'});
  if(idx<SIZES.length-1) alts.push({s:SIZES[idx+1], rot:'Mais presença'});
  var h='';
  alts.forEach(function(a){
    var aw = montado(a.s.k,0), ac = Math.round(aw/furn*100);
    var ap = priceFor(S.fin,a.s.k);
    var amk = isMeasured(S.fin,a.s.k) ? '' : '≈';
    h += '<button class="alt" data-apply="'+a.s.k+'">'+
         '<span class="b"><b>'+a.rot+' · '+CONJ+' '+a.s.w+'×'+a.s.h+'</b>'+
         '<s>'+fmtCm(aw)+' montado · ocupa '+ac+'% do móvel</s></span>'+
         '<em>'+(ap==null?'—':brl(ap))+'</em></button>';
  });
  document.getElementById('simAlts').innerHTML = h;
}

/* ═══════════ FRETE / PRAZO / RETIRADA ═══════════
   O visual e os textos vêm de components/_frete.php, o mesmo do /cart. Aqui
   mora apenas a cotação da PDP, que usa a combinação ativa do ERP. */
var freteRoot = document.getElementById('goqfrete-pdpc');
var freteBtn = document.getElementById('cepBtn'), freteIn = document.getElementById('cepInput');
var freteShip = document.getElementById('cepShip'), freteErr = document.getElementById('cepErr'), freteRail = document.getElementById('goqfRail');
/* freteLastCep: CEP em uso ('' = nenhum); freteQuoted: variante da última cotação (0 = só o prazo da região) */
var freteLastCep = '', freteQuoted = 0, freteBusy = false, freteRequest = 0;
/* [Shopify] A "combinação" agora é a variante: tamanho × moldura (com ou sem vidro) × cor. */
function shippingCombination(){
  var glass = S.glass && glassOK(S.fin) ? 1 : 0;
  var color = colorOK(S.fin) ? S.color : '';
  return VARIANTS[S.fin+'|'+S.size+'|'+glass+'|'+color] || VARIANT_FALLBACK[S.fin+'|'+S.size+'|'+glass] || 0;
}
var CART_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
function cartJson(path, body){
  return fetch(CART_ROOT + path, body === undefined ? {headers:{Accept:'application/json'}} : {
    method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(body)
  }).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
}
/* A Shopify só cota frete para o carrinho. Para cotar a peça antes da compra: coloca a
   variante no carrinho, pede as tarifas do CEP e devolve o carrinho como estava. As tarifas
   são as cadastradas na loja (ou as do app de frete, quando houver). */
var cartLock = Promise.resolve();
function withCart(task){ var run = cartLock.then(task, task); cartLock = run.catch(function(){}); return run; }
function shopifyRates(variantId, cep, uf){
  return withCart(function(){
    return cartJson('cart.js').then(function(before){
      var had = (before.items || []).filter(function(i){ return i.variant_id === variantId; })[0];
      return cartJson('cart/add.js', {items:[{id:variantId, quantity:1}]}).then(function(added){
        var line = (added.items && added.items[0]) || added;
        var restore = function(){ return cartJson('cart/change.js', {id:line.key, quantity: had ? had.quantity : 0}); };
        var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(cep.slice(0,5)+'-'+cep.slice(5)) + '&shipping_address%5Bcountry%5D=Brazil' + (uf ? '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf) : '');
        return cartJson('cart/shipping_rates.json?' + q).then(function(res){
          return restore().then(function(){ return res.shipping_rates || []; });
        }, function(err){
          return restore().then(function(){ throw err; });
        });
      });
    });
  });
}
function ratesToList(rates){
  return rates.map(function(r){
    var price = Number(r.price) || 0, days = (r.delivery_days || []).filter(function(d){ return d != null; });
    return {id: price === 0 ? 'free' : (r.code || r.name), description: r.name || r.presentment_name || 'Envio',
            value: price.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.'), time: days.length ? Math.max.apply(null, days) : 0,
            timeMin: days.length ? Math.min.apply(null, days) : 0};
  }).sort(function(a,b){ return (a.id === 'free' ? 0 : 1) - (b.id === 'free' ? 0 : 1); });
}
/* ═══════════ CARRINHO ═══════════
   Usa o mesmo endpoint da PDP padrão e a mesma combinação completa usada pelo frete. */
var cartBusy = false;
function cartButtonsBusy(on){
  ['ctaMain','stkBtn'].forEach(function(id){
    var b = document.getElementById(id); if(!b) return;
    if(on){
      if(!b.hasAttribute('data-cart-label')) b.setAttribute('data-cart-label', b.innerHTML);
      b.disabled = true; b.setAttribute('aria-busy','true');
      b.textContent = 'Adicionando…';
    } else {
      b.disabled = false; b.removeAttribute('aria-busy');
      var label = b.getAttribute('data-cart-label'); if(label !== null) b.innerHTML = label;
    }
  });
}
function cartButtonsLabel(text){
  ['ctaMain','stkBtn'].forEach(function(id){ var b = document.getElementById(id); if(b) b.textContent = text; });
}
/* [27/10/2026] Medição do primeiro teste da auditoria (resumo fixo + preço junto do botão). "Seleção completa" é
   quando o cliente escolheu o acabamento e o tamanho, com clique ou pelo "Me ajude a escolher" (a cor já vem
   escolhida). Vai ao dataLayer uma vez por visita, como gq_pdp_selecao_completa; o add_to_cart leva se ela
   aconteceu e de onde veio a adição (gq_origem: "barra" ou "botao"). As tags ficam no GTM. */
var PICKED = {fin:false, size:false}, PICK_SENT = false;
function markPick(kind){
  PICKED[kind] = true;
  if(PICK_SENT || !PICKED.fin || !PICKED.size) return;
  PICK_SENT = true;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:'gq_pdp_selecao_completa', item_id:PRODUCT_TRACK.id, item_name:PRODUCT_TRACK.name,
      configuracao:shareConfigLabel(), valor:cents(compTotal()), pagina:PDP_CATEGORY_EMBED ? 'categoria' : 'produto'
    });
  } catch(e) {}
}
function trackAddToCartAndGo(price, origem){
  var navigated = false;
  // Vai para /cart; só abre a sacola lateral (sections/gq-cart-drawer) com "Depois de adicionar" = lateral.
  var drawer = document.getElementById('cart-drawer');
  var useDrawer = !!(drawer && typeof drawer.refreshAndOpen === 'function' && drawer.getAttribute('data-after-add') === 'drawer');
  function go(){
    if(navigated) return; navigated = true;
    if(useDrawer){
      cartBusy = false; cartButtonsBusy(false);
      drawer.refreshAndOpen();
    } else {
      window.location.href = CART_ROOT + 'cart';
    }
  }
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:'add_to_cart',
      ecommerce:{items:[{
        item_name:PRODUCT_TRACK.name, item_id:PRODUCT_TRACK.id, price:Number(price)||0,
        item_brand:'Go Quadros', item_category:PRODUCT_TRACK.category, index:0, quantity:1
      }]},
      gq_origem:origem || 'botao',
      gq_selecao_completa:PICK_SENT,
      eventCallback:go,
      eventTimeout:1000
    });
  } catch(e) {}
  /* 26/10/2026: sem fbq/pintrk/ttq aqui. O AddToCart do Meta sai do app Facebook & Instagram, com
     eventID para juntar navegador e servidor e com o ID do catálogo da Shopify; o daqui ia sem eventID
     e com o código antigo (codgen), e contava em dobro. Pinterest e TikTok não carregam no tema. */
  setTimeout(go,1200);
}
function addCurrentToCart(e){
  if(cartBusy) return;
  var origem = e && e.currentTarget && e.currentTarget.id === 'stkBtn' ? 'barra' : 'botao';
  if(S.comp > 1){
    var wallText = 'Quero montar esta parede da Go Quadros: '+shareConfigLabel()+'. Valor proposto: '+brl(compTotal())+'.\n\n'+sharedPdpUrl();
    window.open('https://wa.me/'+WHATSAPP+'?text='+encodeURIComponent(wallText),'_blank','noopener');
    return;
  }
  var combination = shippingCombination();
  if(!combination){ alert('Essa combinação não está disponível. Ajuste as opções.'); return; }
  // Personalizado (assets/gq-pdp-custom.js): a foto é só a prévia e é opcional; o item leva o aviso
  // de que a foto vai por e-mail depois da compra
  var custom = window.GoQPdpCustom;
  var withoutFrame = S.fin === 'mdf';
  cartBusy = true; cartButtonsBusy(true);
  withCart(function(){
    if(custom) return custom.add(combination);
    return cartJson('cart/add.js', {items:[{id:combination, quantity:1}]});
  }).then(function(){
    if(withoutFrame){
      alert('Atenção! Esta variação contém apenas a impressão aplicada em uma placa de madeira, sem moldura e sem vidro. Não há estrutura para pendurar.');
    }
    trackAddToCartAndGo(unitPrice(), origem);
  }).catch(function(err){
    cartBusy = false; cartButtonsBusy(false);
    alert((err && (err.description || err.message)) ? (err.description || err.message) : 'Erro ao adicionar no carrinho.');
  });
}
/* Personalizados (assets/gq-pdp-custom.js): a foto do cliente entra no lugar da arte de
   exemplo no "O que chega", nas medidas, na escala e no 3D; o módulo acompanha cada troca
   de opção (tamanho muda a proporção do recorte). */
var ARTS_BASE = ARTS.slice(), ARTS3D_BASE = (DATA.arts3d || []).slice();
window.GoQPdpD.state = function(){
  var po = physicalSize(sizeObj(S.size));
  return {
    size:S.size, w:po.w, h:po.h, fin:S.fin, color:S.color, glass:S.glass && glassOK(S.fin) ? 1 : 0,
    pieces:PIECES, label:shareConfigLabel(),
    sizes:SIZES.map(function(s){ var p = physicalSize(s); return {k:s.k, w:p.w, h:p.h}; })
  };
};
window.GoQPdpD.onRender = function(fn){ RENDER_HOOKS.push(fn); };
window.GoQPdpD.setArts = function(list, list3d){
  ARTS = list && list.length ? list.slice() : ARTS_BASE.slice();
  DATA.arts3d = list3d && list3d.length ? list3d.slice() : ARTS3D_BASE.slice();
  [].slice.call(document.querySelectorAll('.recebe-grid .pc-art img')).forEach(function(img, i){
    var src = ARTS[i] || ARTS[ARTS.length - 1];
    if(src){ img.loading = 'eager'; img.src = src; }
  });
  [].slice.call(document.querySelectorAll('#gal3dThumb img, #galExplodeThumb img')).forEach(function(img){
    if(DATA.arts3d[0]) img.src = DATA.arts3d[0];
  });
  init3D();
  render();
  syncGalBar();
};
window.GoQPdpD.showSlide = function(slide){ setGalSlide(slide); };
var ctaMainCart = document.getElementById('ctaMain');
var stickyCart = document.getElementById('stkBtn');
if(ctaMainCart) ctaMainCart.addEventListener('click', addCurrentToCart);
if(stickyCart) stickyCart.addEventListener('click', addCurrentToCart);
// Voltar da /cart pelo histórico com a página em cache: os botões não podem ficar em "Adicionando…".
window.addEventListener('pageshow', function(e){ if(e.persisted){ cartBusy = false; cartButtonsBusy(false); } });
function freteError(msg){
  if(freteShip){ freteShip.hidden = true; freteShip.innerHTML = ''; }
  if(freteErr){ freteErr.hidden = !msg; freteErr.textContent = msg || ''; }
  /* com erro no CEP, o resumo volta para o prazo de fábrica (não fica a data de um CEP anterior) */
  if(msg) resumoShip(null);
}
/* [23/10/2026] Prazo e frete numa linha só, no cartão do CEP (mentoria/marketing). Antes o cartão dizia
   "Prazo confirmado no checkout" + o nome da tarifa ("Entrega padrão") e, embaixo do preço, outra linha
   repetia frete e CEP com as datas. Com mais de uma tarifa (se um dia houver expressa), seguem os cartões. */
function freteShow(list){
  if(!freteShip) return;
  if(!list || !list.length){ freteError('Sem opção de envio para este CEP.'); return; }
  freteError('');
  freteShip.innerHTML = list.length > 1 ? GoQFrete.resumoHTML(list, {selectable:false}) : shipLine(list[0]);
  freteShip.hidden = false;
  resumoShip(freteLastCep, shipDays(list[0]));
}
/* [5d] Previsão de entrega com o CEP calculado ou lembrado (goq_cep).
   A faixa de datas é a da política de envio: a produção começa hoje (antes do corte, em dia útil) ou
   no próximo dia útil, leva até 48h úteis, e depois vem o prazo da transportadora (dias úteis, da
   tarifa da Shopify ou da política). O cliente lê a data como promessa (Baymard): feriados nacionais e
   os dias sem Correios (Carnaval, Sexta-feira Santa, Corpus Christi) não contam como dia útil. */
var HOLIDAYS = {};
function holidaysOf(year){
  if(HOLIDAYS[year]) return HOLIDAYS[year];
  /* Páscoa (algoritmo de Meeus/Jones/Butcher) para os feriados móveis */
  var a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
  var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  var easter = Date.UTC(year, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1, 12);
  var set = {};
  ['01-01','04-21','05-01','09-07','10-12','11-02','11-15','11-20','12-25'].forEach(function(md){ set[year + '-' + md] = 1; });
  [-48, -47, -2, 60].forEach(function(off){ set[new Date(easter + off * 864e5).toISOString().slice(0, 10)] = 1; });
  return (HOLIDAYS[year] = set);
}
function isWorkday(dt){ var w = dt.getUTCDay(); return w !== 0 && w !== 6 && !holidaysOf(dt.getUTCFullYear())[dt.toISOString().slice(0, 10)]; }
function deliveryRange(minDays, maxDays){
  var c = GoQFrete.corte ? GoQFrete.corte() : {aberto:false};
  var p = {};
  new Intl.DateTimeFormat('en-US', {timeZone:'America/Sao_Paulo', year:'numeric', month:'numeric', day:'numeric'})
    .formatToParts(new Date()).forEach(function(x){ p[x.type] = x.value; });
  var start = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), 12));
  if(!(c.aberto && isWorkday(start))){ do { start.setUTCDate(start.getUTCDate() + 1); } while(!isWorkday(start)); }
  var after = function(n){
    var dt = new Date(start.getTime());
    for(var left = n; left > 0; ){ dt.setUTCDate(dt.getUTCDate() + 1); if(isWorkday(dt)) left--; }
    return dt;
  };
  return {from: after(2 + minDays), to: after(2 + maxDays)};
}
function dayLabel(dt, weekday){
  return dt.toLocaleDateString('pt-BR', weekday ? {timeZone:'UTC', weekday:'short', day:'2-digit', month:'2-digit'} : {timeZone:'UTC', day:'2-digit', month:'2-digit'});
}
/* Sem prazo na tarifa da Shopify (as tarifas manuais não trazem), vale o maior prazo da região na
   política de envio publicada (/policies/shipping-policy): Sul, Sudeste e Centro-Oeste 7 a 12 dias
   úteis; Nordeste 13 a 17; Norte 16 a 25. O estado vem do CEP (ViaCEP, já consultado para a tarifa). */
var SHIP_DAYS_BY_UF = (function(){
  var map = {}, add = function(days, ufs){ ufs.split(' ').forEach(function(uf){ map[uf] = days; }); };
  add([7, 12], 'PR RS SC ES MG RJ SP DF GO MT MS');
  add([13, 17], 'AL BA CE MA PB PE PI RN SE');
  add([16, 25], 'AC AP AM PA RO RR TO');
  return map;
})();
/* "Prazo confirmado no checkout" só sobra quando não há prazo nenhum: tarifa sem prazo e CEP sem estado no ViaCEP */
function whenHTML(minDays, maxDays){
  if(!maxDays) return 'Prazo confirmado no checkout';
  var range = deliveryRange(minDays || maxDays, maxDays);
  return range.from.getTime() === range.to.getTime()
    ? 'Entrega prevista até <b>' + dayLabel(range.to, true) + '</b>'
    : 'Entrega prevista entre <b>' + dayLabel(range.from) + '</b> e <b>' + dayLabel(range.to, true) + '</b>';
}
/* 27/10/2026: a cidade vai na frente da linha (antes ficava numa linha "CEP … · alterar" que saiu com o
   "Remover"): o cliente confere o CEP sem uma linha a mais. */
function placeHTML(cep){
  var info = freteInfo[cep];
  return info && info.city ? GoQFrete.esc(info.city + (info.uf ? '/' + info.uf : '')) + ' · ' : '';
}
/* prazo de uma tarifa em dias úteis [mín, máx]: o da Shopify, ou o da região do CEP */
function shipDays(s){
  var region = SHIP_DAYS_BY_UF[(freteInfo[freteLastCep] || {}).uf] || [0, 0];
  var maxDays = Number(s.time) || region[1], minDays = Number(s.time) ? (Number(s.timeMin) || maxDays) : region[0];
  return [minDays, maxDays];
}
function shipLine(s){
  var free = String(s.id) === 'free', days = shipDays(s);
  var cost = free ? '<b class="pd-frete__free">frete grátis</b>' : 'frete <b>R$ ' + GoQFrete.esc(s.value) + '</b>';
  return '<p class="pd-frete">' + placeHTML(freteLastCep) + whenHTML(days[0], days[1]) + ' · <span class="pd-frete__v">' + cost + '</span></p>';
}
/* CEP lembrado, ou peça trocada depois de cotar: o prazo sai da região, sem tocar no carrinho, e o valor
   fica num toque (cotar conta como AddToCart, ver requoteIfNeeded). */
function regionLine(cep){
  var region = SHIP_DAYS_BY_UF[(freteInfo[cep] || {}).uf] || [0, 0];
  return '<p class="pd-frete">' + placeHTML(cep) + whenHTML(region[0], region[1])
    + ' · <button type="button" class="pd-frete__ver" data-goqf-quote>ver valor do frete</button></p>';
}
function freteUpdateRail(){
  if(!freteRail || !GoQFrete.MIN) return;
  freteRail.innerHTML = GoQFrete.railHTML(unitPrice(), {size:S.size});
  freteRail.hidden = false;
}
/* Uma consulta por CEP: o estado escolhe o prazo e vai para a tarifa; a cidade confirma o CEP.
   30/10/2026: o ViaCEP não tem todo CEP (o 58300-180, de Santa Rita/PB, existe e ele responde "erro"),
   e o cliente ficava sem frete. Quando o ViaCEP diz que não existe, a BrasilAPI (Correios, OpenCEP,
   WideNet) confere: ok:false só quando ela também responde 404. Falha de rede passa (a Shopify ainda cota). */
var freteInfo = {};
function cepInfo(cep){
  if(freteInfo[cep]) return Promise.resolve(freteInfo[cep]);
  var keep = function(info){ return (freteInfo[cep] = info); };
  var pass = function(){ return {ok:true, uf:'', city:''}; };
  return fetch('https://viacep.com.br/ws/'+cep+'/json/').then(function(r){ return r.json(); }).then(function(d){
    if(d && !d.erro) return keep({ok:true, uf:d.uf || '', city:d.localidade || ''});
    return fetch('https://brasilapi.com.br/api/cep/v1/'+cep).then(function(r){
      if(r.status === 404) return keep({ok:false, uf:'', city:''});
      if(!r.ok) return pass();
      return r.json().then(function(b){ return keep({ok:true, uf:b.state || '', city:b.city || ''}); });
    }).catch(pass);
  }, pass);
}
function freteDigits(){ return freteIn ? (freteIn.value || '').replace(/\D/g, '') : ''; }
/* 27/10/2026 (pedido da loja): com o CEP em uso no campo, o botão vira "Remover"; digitar outro CEP
   volta para "Calcular". */
function freteSyncBtn(){
  if(!freteBtn || freteBusy) return;
  var remove = !!freteLastCep && freteDigits() === freteLastCep;
  freteBtn.textContent = remove ? 'Remover' : 'Calcular';
  freteBtn.setAttribute('data-goqf-mode', remove ? 'remove' : 'calc');
  if(remove) freteBtn.setAttribute('aria-label', 'Remover o CEP ' + GoQFrete.formataCep(freteLastCep));
  else freteBtn.removeAttribute('aria-label');
}
function freteShowRegion(cep){
  var request = ++freteRequest;
  freteError('');
  cepInfo(cep).then(function(){
    if(request !== freteRequest || cep !== freteLastCep || !freteShip) return;
    freteShip.innerHTML = regionLine(cep);
    freteShip.hidden = false;
    resumoShip(cep, SHIP_DAYS_BY_UF[(freteInfo[cep] || {}).uf]);
  });
}
function quoteShipping(cep){
  var combination = shippingCombination();
  if(!combination){ freteError('Ajuste as opções para calcular o frete.'); return; }
  var request = ++freteRequest;
  freteQuoted = combination;
  if(freteErr) freteErr.hidden = true;
  if(freteShip){ freteShip.hidden = false; freteShip.innerHTML = GoQFrete.loadingHTML(); }
  cepInfo(cep).then(function(info){
    // Removeu o CEP ou trocou a peça enquanto o ViaCEP respondia: nem chega a mexer no carrinho
    if(request !== freteRequest) return null;
    return shopifyRates(combination, cep, info.uf);
  }).then(function(rates){
    if(request !== freteRequest || !rates) return;
    freteShow(ratesToList(rates)); freteUpdateRail();
  }).catch(function(err){
    if(request !== freteRequest) return;
    var msg = err && (err.zip || err.country || err.province || err.error || err.description);
    freteError(Array.isArray(msg) ? 'CEP ' + msg.join(' ') : (msg ? String(msg) : 'Não foi possível calcular o frete agora.'));
  });
}
/* 26/10/2026: a cotação põe a peça no carrinho e tira (shopifyRates), e a Shopify conta cada vez
   como "produto adicionado": AddToCart no Meta e add_to_cart no GA4, sem o cliente comprar. Por isso
   ela só roda num clique (Calcular ou "ver valor do frete"). 27/10/2026: trocar tamanho, acabamento,
   cor ou vidro depois de cotar volta para o prazo da região, com o CEP e o "Remover" no lugar. */
function requoteIfNeeded(){
  if(!freteLastCep || !freteQuoted || shippingCombination() === freteQuoted) return;
  freteQuoted = 0;
  freteShowRegion(freteLastCep);
  freteUpdateRail();
}
function calculateShipping(){
  if(!freteIn || freteBusy) return;
  var cep = freteDigits();
  if(cep.length !== 8){ freteError('Digite um CEP válido (8 dígitos).'); return; }
  freteBusy = true;
  if(freteBtn){ freteBtn.textContent = '…'; freteBtn.setAttribute('aria-busy', 'true'); }
  cepInfo(cep).then(function(info){
    freteBusy = false;
    if(freteBtn) freteBtn.removeAttribute('aria-busy');
    // CEP que não existe não fica salvo: na /cart ele viraria erro sozinho
    if(!info.ok){ freteSyncBtn(); freteError('CEP não encontrado. Confira os números.'); return; }
    freteLastCep = cep;
    GoQFrete.lembrar(cep);
    freteSyncBtn();
    quoteShipping(cep);
  });
}
function freteClear(focus){
  GoQFrete.esquecer();
  freteLastCep = ''; freteQuoted = 0; freteRequest++;
  freteError('');
  resumoShip(null);
  if(freteRail){ freteRail.hidden = true; freteRail.innerHTML = ''; }
  if(freteIn){ freteIn.value = ''; if(focus) freteIn.focus(); }
  freteSyncBtn();
}
/* O CEP lembrado não cota ao abrir (cada cotação é um AddToCart, ver requoteIfNeeded): mostra o prazo
   da região, o botão "Remover" e o valor num toque. */
function preloadShippingCep(){
  var cep = window.GoQFrete && GoQFrete.lembrado();
  if(!cep || !freteIn) return;
  freteIn.value = GoQFrete.formataCep(cep);
  freteLastCep = cep; freteQuoted = 0;
  freteSyncBtn();
  freteShowRegion(cep);
}
if(freteBtn) freteBtn.addEventListener('click', function(){
  if(freteBusy) return;
  if(freteBtn.getAttribute('data-goqf-mode') === 'remove') freteClear(true);
  else calculateShipping();
});
if(freteIn){
  GoQFrete.maskCep(freteIn);
  freteIn.addEventListener('input', freteSyncBtn);
  // Enter só calcula: com o CEP em uso no campo, não faz nada (nunca remove)
  GoQFrete.bindEnter(freteIn, function(){ if(freteDigits() !== freteLastCep) calculateShipping(); });
}
if(freteShip) freteShip.addEventListener('click', function(e){
  var quote = e.target && e.target.closest ? e.target.closest('[data-goqf-quote]') : null;
  if(quote && freteLastCep) quoteShipping(freteLastCep);
});
/* Voltar da /cart pelo histórico: a página vem do cache com o CEP de antes; vale o que está salvo agora. */
window.addEventListener('pageshow', function(e){
  if(!e.persisted || PDP_CATEGORY_EMBED) return;
  var cep = GoQFrete.lembrado();
  if(cep === freteLastCep) return;
  if(cep) preloadShippingCep(); else freteClear(false);
});
if(freteRoot) freteRoot.querySelectorAll('[data-goqf-tab]').forEach(function(tab){ tab.addEventListener('click', function(){ var pane = tab.getAttribute('data-goqf-tab'); freteRoot.querySelectorAll('[data-goqf-tab]').forEach(function(t){ t.classList.toggle('on', t === tab); }); freteRoot.querySelectorAll('[data-goqf-pane]').forEach(function(p){ p.hidden = p.getAttribute('data-goqf-pane') !== pane; }); }); });

/* ═══════════ REVIEWS ═══════════ */
var reviewFilter = 'all', reviewsExpanded = false;
/* [5d] Avaliações do Google (snippet gq-pdp-reviews): uma seleção das de 4 e 5 estrelas com comentário,
   com as fotos e a resposta da loja, na ordem de data. Como é seleção, o resumo mostra a nota real do
   Google (com todas), diz que a lista é uma seleção e linka todas lá. Filtros: com fotos e ambiente. */
var REVIEWS_META = DATA.reviewsMeta || {};
function reviewMatches(r, f){
  if(f === 'all') return true;
  if(f === 'fotos') return r.imgs && r.imgs.length > 0;
  return !!(r.f && r.f.indexOf(f) >= 0);
}
function drawRevSum(){
  var box = document.getElementById('revSum'); if(!box) return;
  var rating = Number(REVIEWS_META.rating) || 0;
  var updated = String(REVIEWS_META.updated || '').split('-').reverse().join('/');
  var h = '<div class="gq5-revsum__nota"><b>' + rating.toFixed(1).replace('.', ',') + '</b>' +
    '<span class="gq5-stars" style="--v:' + (rating * 20).toFixed(0) + '%" aria-label="' + rating.toFixed(1).replace('.', ',') + ' de 5 estrelas">★★★★★</span>' +
    '<span>' + (REVIEWS_META.total || REVIEWS.length) + ' avaliações no Google</span></div>';
  h += '<p class="gq5-revsum__src">Aqui, uma seleção de ' + REVIEWS.length + ' avaliações de 4 e 5 estrelas com comentário' + (updated ? ', até ' + updated : '') + '. A nota acima é a do Google, com todas.</p>';
  if(REVIEWS_META.ftid) h += '<a class="gq5-revsum__link" href="https://www.google.com/maps?ftid=' + encodeURIComponent(REVIEWS_META.ftid) + '" target="_blank" rel="noopener">Ver todas no Google ↗</a>';
  box.innerHTML = h;
}
function drawRev(f){
  var revBox = document.getElementById('revList'); if(!revBox) return;
  reviewFilter = f || reviewFilter;
  var list = REVIEWS.filter(function(r){ return reviewMatches(r, reviewFilter); });
  var hiddenCount = Math.max(0, list.length - 3);
  var shown = reviewsExpanded ? list : list.slice(0, 3);
  var h = '';
  if(!list.length) h = '<div class="gq5-rev"><p>Nenhuma avaliação com esse filtro.</p></div>';
  shown.forEach(function(r){
    var imgs = '', n = Number(r.s) || 0, stars = '';
    for(var i = 1; i <= 5; i++) stars += i <= n ? '★' : '☆';
    if(r.imgs && r.imgs.length){
      imgs = '<div class="gq5-rev__imgs">';
      r.imgs.slice(0, 4).forEach(function(u){ imgs += '<img src="' + u + '" alt="Foto do cliente" loading="lazy" referrerpolicy="no-referrer">'; });
      imgs += '</div>';
    }
    h += '<div class="gq5-rev"><div class="gq5-rev__top"><span class="gq5-rev__stars" aria-label="' + n + ' de 5 estrelas">' + stars + '</span><strong>' + r.n + '</strong>' +
         '<span class="gq5-rev__pill">Google' + (r.t ? ' · ' + r.t : '') + '</span></div>' +
         '<p>' + r.x + '</p>' + imgs +
         (r.r ? '<div class="gq5-rev__resp"><b>Resposta da Go Quadros</b><p>' + r.r + '</p></div>' : '') + '</div>';
  });
  revBox.innerHTML = '<div class="gq5-rev__list">' + h + '</div>' +
    ((hiddenCount && !reviewsExpanded) ? '<button class="gq5-btn gq5-btn--line gq5-rev__more" type="button" id="revMore">Ver mais ' + hiddenCount + ' avaliações</button>' : '');
}

/* ═══════════ PAINEL ═══════════ */
window.openPanel = function(k){
  var t='', b='';
  if(k==='rev'){
    t = 'Sobre este bloco de prova social';
    b = 'A nota, o volume e os depoimentos exibidos são placeholders declarados. Hoje esta página — e o catálogo '+
        'inteiro da Go Quadros — tem ZERO avaliações publicadas. O cliente informou que o acervo existe, coletado '+
        'por app, Instagram e WhatsApp. Este bloco está desenhado para recebê-lo; publicar prova antes da migração '+
        'seria promessa falsa.';
  }
  document.getElementById('pnTitle').textContent = t;
  document.getElementById('pnBody').textContent = b;
  document.getElementById('panel').classList.add('on');
};
window.closePanel = function(){ document.getElementById('panel').classList.remove('on'); };

/* ═══════════ EVENTOS ═══════════ */
/* Miniaturas (computador) e barrinha (celular) abrem a vista do mesmo jeito. Sem o 3D, "Na parede"/"ver
   ambiente" é o mockup da combinação escolhida, não a foto principal de novo (ela tem a vista "fotos"). */
function openSlide(slide){
  if(slide === 'ambiente' && !G3.available && HAS_MKP && !CONFIG_MKP_ACTIVE){ activateConfigMockups(); setMkp(sizeObj(S.size)); }
  setGalSlide(slide);
}
document.querySelector('.gal-strip').addEventListener('click', function(e){
  var b = e.target.closest('[data-slide]'); if(!b) return;
  openSlide(b.getAttribute('data-slide'));
});
var galStrip = document.getElementById('galStrip');
var galPrev = document.getElementById('galPrev');
var galNext = document.getElementById('galNext');
/* [22/10/2026] No 5d as setas da fileira de miniaturas (.gal-nav) ficam sempre escondidas (gq-pdp5d.css):
   não há o que atualizar. Medir a fileira aqui forçava um cálculo de layout no carregamento (41 ms no
   celular, onde ela nem aparece). */
function galNavState(){}
function galMove(dir){ galStrip.scrollBy({left:dir * Math.max(120, galStrip.clientWidth * .72), behavior:'smooth'}); }
galPrev.addEventListener('click', function(){ galMove(-1); });
galNext.addEventListener('click', function(){ galMove(1); });
var scaleResizeTimer;
pdpOn(window,'resize', function(){
  clearTimeout(scaleResizeTimer);
  scaleResizeTimer = setTimeout(function(){ layoutScale(sizeObj(S.size)); }, 120);
});

/* ═══════════ CELULAR: BARRINHA, FOTOS E ZOOM DA ARTE (22/10/2026) ═══════════
   No lugar das miniaturas, a barrinha #galBar: "quadro" (as fotos do produto), "ver ambiente" (o quadro na
   parede, que segue as escolhas) e "3D", as bolinhas das fotos e a lupa. Tocar numa foto ou na lupa abre
   a arte de impressão ampliada (pedido do atendimento). */
var galBar = document.getElementById('galBar');
function syncGalBar(){
  if(!galBar) return;
  var has = {fotos: FOTOS_N > 0, ambiente: G3.available || HAS_MKP, '3d': G3.available || VIEW3D.available};
  var shown = 0;
  [].slice.call(galBar.querySelectorAll('[data-slide]')).forEach(function(tab){
    var ok = !!has[tab.getAttribute('data-slide')];
    tab.hidden = !ok;
    if(ok) shown++;
  });
  var tabs = galBar.querySelector('.gal-bar__tabs');
  if(tabs) tabs.hidden = shown < 2;
  var zoom = document.getElementById('galZoomArt');
  if(zoom) zoom.hidden = !ARTS.length;
}
if(galBar) galBar.addEventListener('click', function(e){
  var tab = e.target.closest('[data-slide]');
  if(tab){
    openSlide(tab.getAttribute('data-slide'));
    return;
  }
  var zoom = e.target.closest('#galZoomArt');
  if(zoom) openArtZoom(zoom);
});
syncGalBar();

(function initFotos(){
  if(!FOTOS_TRACK) return;
  var dots = document.getElementById('galDots');
  if(dots && FOTOS_N > 1) dots.innerHTML = new Array(FOTOS_N + 1).join('<i></i>');
  var ticking = false;
  function syncDots(){
    ticking = false;
    if(!dots || FOTOS_N < 2) return;
    var at = Math.round(FOTOS_TRACK.scrollLeft / Math.max(1, FOTOS_TRACK.clientWidth));
    [].slice.call(dots.children).forEach(function(dot, i){ dot.classList.toggle('on', i === at); });
  }
  /* [22/10/2026] As fotos depois da 1ª chegam com data-src (Liquid) e só baixam no 1º toque ou deslize
     no trilho: o lazy do navegador baixava todas na hora, por estarem ao lado da 1ª (~280 KB a mais). */
  var restLoaded = false;
  function loadRest(){
    /* fora do celular só a 1ª foto aparece (23/10/2026): as outras ficam sem baixar */
    if(restLoaded || !isPhone()) return;
    restLoaded = true;
    [].slice.call(FOTOS_TRACK.querySelectorAll('img[data-src]')).forEach(function(img){
      img.srcset = img.getAttribute('data-srcset') || '';
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }
  FOTOS_TRACK.addEventListener('pointerdown', loadRest, {once:true, passive:true});
  FOTOS_TRACK.addEventListener('touchstart', loadRest, {once:true, passive:true});
  FOTOS_TRACK.addEventListener('scroll', function(){
    loadRest();
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(syncDots);
  }, {passive:true});
  /* deslizar não dispara clique: só o toque abre a arte */
  FOTOS_TRACK.addEventListener('click', function(e){ if(e.target.closest('img')) openArtZoom(FOTOS_TRACK); });
  /* a 1ª bolinha já começa ligada: medir o trilho na partida era um cálculo de layout a mais */
  if(dots && dots.firstElementChild) dots.firstElementChild.classList.add('on');
})();

/* Zoom da arte: uma lâmina por peça (no personalizado, a foto do cliente). Tocar na arte alterna 2,5× e
   arrastar move a arte ampliada (rolagem nativa); deslizar troca de peça em 1×. Fecha no ×, no Esc e no
   voltar do celular. As artes "arte da peça" costumam ter 378×567 px: a CDN da Shopify não aumenta, então
   pedir 2048 traz o original. */
var artZoom = null;
function artZoomSrc(url){
  var u = String(url || '');
  return /\/cdn\/shop\/|cdn\.shopify\.com/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=2048') : u;
}
function closeArtZoom(fromHistory){
  if(!artZoom) return;
  var z = artZoom;
  artZoom = null;
  z.box.remove();
  document.documentElement.classList.remove('gq-artzoom-lock');
  if(!fromHistory && history.state && history.state.gqArtZoom) history.back();
  if(z.back && z.back.focus) z.back.focus({preventScroll:true});
}
function openArtZoom(trigger){
  if(artZoom) return;
  var list = ARTS.slice(0, Math.max(1, PIECES)).filter(Boolean);
  if(!list.length) return;
  var esc = function(v){ return String(v || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
  var box = document.createElement('div');
  box.className = 'gq-artzoom';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Arte ampliada');
  box.innerHTML =
    '<div class="gq-artzoom__top"><span class="gq-artzoom__count" aria-live="polite"></span>' +
    '<button type="button" class="gq-artzoom__close" aria-label="Fechar">×</button></div>' +
    '<div class="gq-artzoom__track">' + list.map(function(url, i){
      return '<div class="gq-artzoom__slide"><div class="gq-artzoom__pan"><img src="' + esc(artZoomSrc(url)) + '" alt="' +
        esc(list.length > 1 ? 'Arte da peça ' + (i + 1) + ' de ' + list.length : 'Arte do quadro') + '" decoding="async" referrerpolicy="no-referrer"></div></div>';
    }).join('') + '</div>' +
    '<p class="gq-artzoom__hint">Toque na arte para ampliar</p>';
  document.body.appendChild(box);
  document.documentElement.classList.add('gq-artzoom-lock');
  var track = box.querySelector('.gq-artzoom__track'), count = box.querySelector('.gq-artzoom__count'), close = box.querySelector('.gq-artzoom__close');
  function label(){
    var at = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    count.textContent = list.length > 1 ? 'Peça ' + (at + 1) + ' de ' + list.length : 'Arte do quadro';
  }
  track.addEventListener('scroll', label, {passive:true});
  box.addEventListener('click', function(e){
    if(e.target.closest('.gq-artzoom__close')){ closeArtZoom(false); return; }
    var img = e.target.closest('.gq-artzoom__pan img'); if(!img) return;
    var slide = img.closest('.gq-artzoom__slide'), pan = img.parentNode;
    var on = !slide.classList.contains('is-zoomed');
    /* o ponto tocado fica embaixo do dedo depois de ampliar */
    var r = img.getBoundingClientRect();
    var fx = (e.clientX - r.left) / Math.max(1, r.width), fy = (e.clientY - r.top) / Math.max(1, r.height);
    slide.classList.toggle('is-zoomed', on);
    track.classList.toggle('is-locked', on);
    if(on){
      pan.scrollLeft = Math.max(0, fx * img.offsetWidth - pan.clientWidth / 2);
      pan.scrollTop = Math.max(0, fy * img.offsetHeight - pan.clientHeight / 2);
    }
  });
  var back = trigger && trigger.closest ? trigger.closest('button,[tabindex]') : null;
  artZoom = {box:box, close:close, back:back};
  try { history.pushState({gqArtZoom:true}, ''); } catch(err) {}
  label();
  close.focus({preventScroll:true});
}
pdpOn(document, 'keydown', function(e){
  if(!artZoom) return;
  if(e.key === 'Escape'){ e.preventDefault(); closeArtZoom(false); }
  else if(e.key === 'Tab'){ e.preventDefault(); artZoom.close.focus(); } /* o × é o único item com foco */
});
pdpOn(window, 'popstate', function(){ if(artZoom) closeArtZoom(true); });
pdpCleanups.push(function(){ closeArtZoom(true); });

/* [22/10/2026] Uma linha só (pedido do Renan: sem quebra em nenhum aparelho): o nome, a frase de baixo, a
   linha da moldura e o cupom não quebram (CSS white-space: nowrap). Quando o texto não cabe, a letra
   diminui até o mínimo (px); abaixo disso, o CSS termina o texto em "…". Fora do celular, onde eles quebram
   ou cabem, nada muda.
   Desempenho (22/10/2026): tudo num quadro só (scheduleFit), em lote. Primeiro volta todos ao tamanho do CSS,
   depois mede todos e só então escreve: um cálculo de layout, em vez de um por texto. */
function fitLines(){
  var list = [
    [document.querySelector('#pdp-c .h-prod-short'), 14],
    [document.querySelector('#pdp-c .product-heading .h-sub'), 11],
    [document.getElementById('finSpec'), 11],
    [document.querySelector('#pdp-c .pd-coupon__tx'), 11]
  ].filter(function(item){ return item[0]; });
  list.forEach(function(item){ item[0].style.fontSize = ''; });
  var plan = list.map(function(item){
    var el = item[0];
    if(!el.clientWidth || el.scrollWidth <= el.clientWidth + 1) return null;
    var size = parseFloat(getComputedStyle(el).fontSize) || 16;
    return [el, Math.max(item[1], Math.floor(size * el.clientWidth / el.scrollWidth * 2) / 2), item[1]];
  }).filter(Boolean);
  plan.forEach(function(p){ p[0].style.fontSize = p[1] + 'px'; });
  /* arredondamento da largura: meio ponto a menos onde ainda passar (raro) */
  plan.forEach(function(p){
    var fit = p[1];
    while(fit > p[2] && p[0].scrollWidth > p[0].clientWidth + 1){ fit -= .5; p[0].style.fontSize = fit + 'px'; }
  });
}
var fitFrame = 0;
function scheduleFit(){
  if(fitFrame) return;
  fitFrame = requestAnimationFrame(function(){ fitFrame = 0; fitLines(); });
}
var fitTimer = 0;
pdpOn(window, 'resize', function(){ clearTimeout(fitTimer); fitTimer = setTimeout(scheduleFit, 120); }, {passive:true});
/* a Montserrat pode chegar depois do 1º cálculo (font-display: swap) */
if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ if(!disposed) scheduleFit(); });

function press(container, attr, val){
  var bs = container.querySelectorAll('[' + attr + ']');
  for(var i=0;i<bs.length;i++){ bs[i].setAttribute('aria-pressed', bs[i].getAttribute(attr)===val ? 'true':'false'); }
}
/* Na variante compacta, a imagem principal permanece visível e só o trilho de
   miniaturas recolhe. Galeria e configuração compartilham o mesmo espaço vertical:
   abrir uma fecha a outra. */
(function initGalleryCollapse(){
  var shell = document.getElementById('galleryCollapseShell');
  var toggle = document.getElementById('galleryCollapseToggle');
  if(!PDP_COLLAPSE || !shell || !toggle) return;
  var mq = window.matchMedia('(max-width: 768px)');
  var galleryOpen = false;
  function sync(){
    shell.classList.toggle('is-open',!mq.matches || galleryOpen);
    toggle.setAttribute('aria-expanded',mq.matches && galleryOpen ? 'true' : 'false');
    if(!mq.matches || galleryOpen){
      requestAnimationFrame(function(){ requestAnimationFrame(galNavState); });
    }
  }
  toggle.addEventListener('click',function(){
    if(!mq.matches) return;
    galleryOpen = !galleryOpen;
    sync();
    if(galleryOpen) document.dispatchEvent(new CustomEvent('pdpc:gallery-open'));
  });
  pdpOn(document,'pdpc:config-open',function(){
    if(!mq.matches || !galleryOpen) return;
    galleryOpen = false;
    sync();
  });
  function mediaChanged(){ galleryOpen=false; sync(); }
  sync();
  if(mq.addEventListener) pdpOn(mq,'change',mediaChanged); else pdpLegacyMedia(mq,mediaChanged);
})();
/* Variante ?collapse=1: acordeão real. Cada linha controla um único painel e abrir
   uma fecha a anterior; no desktop os controles continuam todos visíveis. */
(function initConfigCollapse(){
  var editor = document.getElementById('configCollapseEditor');
  var summary = document.getElementById('configCollapseSummary');
  if(!PDP_COLLAPSE || !editor || !summary) return;
  var mq = window.matchMedia('(max-width: 768px)');
  var activePanel = '';
  var buttons = [].slice.call(summary.querySelectorAll('[data-config-panel]'));
  function placeEditor(){
    if(mq.matches && activePanel){
      var activeButton = buttons.find(function(button){ return button.getAttribute('data-config-panel')===activePanel; });
      if(activeButton) activeButton.insertAdjacentElement('afterend',editor);
    } else {
      summary.insertAdjacentElement('afterend',editor);
    }
  }
  function sync(){
    placeEditor();
    if(!mq.matches){
      editor.hidden = false;
      editor.removeAttribute('data-collapse-active');
      buttons.forEach(function(button){ button.setAttribute('aria-expanded','false'); });
      return;
    }
    editor.hidden = !activePanel;
    if(activePanel) editor.setAttribute('data-collapse-active',activePanel);
    else editor.removeAttribute('data-collapse-active');
    buttons.forEach(function(button){
      button.setAttribute('aria-expanded',button.getAttribute('data-config-panel')===activePanel ? 'true' : 'false');
    });
  }
  buttons.forEach(function(button){
    button.addEventListener('click', function(){
      var panel = button.getAttribute('data-config-panel');
      activePanel = activePanel===panel ? '' : panel;
      sync();
      if(activePanel) document.dispatchEvent(new CustomEvent('pdpc:config-open'));
      if(activePanel) requestAnimationFrame(function(){ editor.scrollIntoView({behavior:'smooth',block:'nearest'}); });
    });
  });
  pdpOn(document,'pdpc:gallery-open',function(){
    if(!mq.matches || !activePanel) return;
    activePanel='';
    sync();
  });
  sync();
  function mediaChanged(){ if(mq.matches) activePanel=''; sync(); }
  if(mq.addEventListener) pdpOn(mq,'change', mediaChanged); else pdpLegacyMedia(mq,mediaChanged);
})();
document.getElementById('selSize').addEventListener('click', function(e){
  var b = e.target.closest('[data-s]'); if(!b) return;
  activateConfigMockups();
  S.size = b.getAttribute('data-s');
  document.dispatchEvent(new CustomEvent('pdpc:size-change'));
  highlightMockup(); render(); simRun();
  markPick('size');
});
/* ═══════════ ME AJUDE A ESCOLHER ═══════════
   A pessoa diz o móvel que fica embaixo do quadro e a largura dele; o tamanho ideal é o da tabela do
   simulador do site antigo (SIM, pdp-d.php) e fica selecionado. Sem essa medida no produto, a mais
   perto dela. Só entram os móveis que têm foto de ambiente no 3D: a galeria vai para a parede acima
   do escolhido (sofá e cama na largura escolhida); a escolha vale também para a página imersiva na
   mesma visita (gq-room). Rack de TV e mesa de jantar saíram: não há foto deles. */
var HELP_MOV = [
  {k:'sofa', n:'Sofá', a:'um sofá', acima:'do sofá', room:'sala'},
  {k:'cama', n:'Cama', a:'uma cama', acima:'da cama', room:'quarto'},
  {k:'aparador', n:'Aparador', a:'um aparador', acima:'do aparador', room:'hall'},
  {k:'buffet', n:'Buffet', a:'um buffet', acima:'do buffet', room:'jantar'},
  {k:'mesaesc', n:'Escrivaninha', a:'uma escrivaninha', acima:'da escrivaninha', room:'escritorio'}
];
var HELP = {mov:null, larg:null};
function helpMov(k){ for(var i=0;i<HELP_MOV.length;i++){ if(HELP_MOV[i].k===k) return HELP_MOV[i]; } return null; }
function helpLargLabel(item){ return item.w && item.k !== 'casal' && item.k !== 'queen' && item.k !== 'king' ? (item.w/100).toFixed(2).replace('.',',') + ' m' : item.l; }
function helpReco(){
  var want = SIM[HELP.mov + '|' + HELP.larg]; if(!want) return null;
  var m = want.split('x').map(Number), w = Math.min(m[0], m[1]), h = Math.max(m[0], m[1]);
  var list = SIZES_SHOWN.filter(function(sz){ return priceFor(S.fin, sz.k) != null; });
  /* quadrado: o lado mais perto da largura recomendada */
  if(SQUARE_PRODUCT) h = w;
  var hit = nearestSize(w, h, list.length ? list : SIZES_SHOWN);
  return hit ? {size:hit, exact:hit.w === w && hit.h === h} : null;
}
function drawHelp(){
  var movBox = document.getElementById('sizeHelpMov'); if(!movBox) return;
  movBox.innerHTML = HELP_MOV.map(function(m){
    var on = HELP.mov === m.k;
    return '<button type="button" role="radio" aria-checked="'+on+'" data-help-mov="'+m.k+'">'+m.n+'</button>';
  }).join('');
  var largBox = document.getElementById('sizeHelpLarg'), largQ = document.getElementById('sizeHelpLargQ');
  var list = HELP.mov ? (LARG[HELP.mov] || []) : [];
  largBox.hidden = largQ.hidden = !list.length;
  largQ.textContent = HELP.mov === 'cama' ? 'Qual o tamanho da cama?' : 'Qual a largura?';
  largBox.innerHTML = list.map(function(item){
    var on = HELP.larg === item.k;
    return '<button type="button" role="radio" aria-checked="'+on+'" data-help-larg="'+item.k+'">'+helpLargLabel(item)+'</button>';
  }).join('');
  var out = document.getElementById('sizeHelpOut');
  var reco = HELP.mov && HELP.larg ? helpReco() : null;
  out.hidden = !reco;
  if(!reco) return;
  var mov = helpMov(HELP.mov), item = list.filter(function(i){ return i.k === HELP.larg; })[0];
  var dim = reco.size.w + '×' + reco.size.h;
  out.innerHTML = 'Para ' + mov.a + (HELP.mov === 'cama' ? ' ' + item.l.toLowerCase() : ' de ' + helpLargLabel(item)) + ', o ideal é <b>' +
    (PIECES > 1 ? CONJ.toLowerCase() + ' de ' + dim + ' (cada peça)' : dim) + '</b>' +
    (reco.exact ? '' : ', a medida mais perto da recomendada') + '. Já deixamos selecionado' +
    (mov.room && G3.available ? ' e o quadro aparece na parede, acima ' + mov.acima + '.' : '.');
}
function applyHelp(){
  var reco = helpReco(); if(!reco) return;
  S.size = reco.size.k;
  var mov = helpMov(HELP.mov);
  if(G3.available && mov && mov.room){
    G3.roomSel = {key:mov.room, size:HELP.larg};
    G3.hung = true;
    GAL_SLIDE = 'ambiente';
  }
  document.dispatchEvent(new CustomEvent('pdpc:size-change'));
  render();
  drawHelp();
  markPick('size');
}
(function(){
  var btn = document.getElementById('sizeHelpBtn'), panel = document.getElementById('sizeHelp');
  if(!btn || !panel) return;
  btn.addEventListener('click', function(){
    var open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if(open){
      drawHelp();
      /* as fotos dos ambientes começam a baixar enquanto a pessoa escolhe */
      if(G3.handle) (G3.handle.prepareRooms || G3.handle.prepareRoom)();
    }
  });
  panel.addEventListener('click', function(e){
    var mov = e.target.closest('[data-help-mov]'), larg = e.target.closest('[data-help-larg]');
    if(mov){
      HELP.mov = mov.getAttribute('data-help-mov'); HELP.larg = null; drawHelp();
      /* O ambiente troca já na escolha do móvel, com a largura padrão dele; a largura, quando a
         pessoa escolhe, ajusta depois (pedido do usuário em 15/10) */
      var mv = helpMov(HELP.mov);
      if(G3.available && mv && mv.room){
        G3.roomSel = {key:mv.room, size:null};
        G3.hung = true;
        GAL_SLIDE = 'ambiente';
        render();
      }
      return;
    }
    if(larg){ HELP.larg = larg.getAttribute('data-help-larg'); applyHelp(); }
  });
})();
var materialSelectorEl = document.getElementById('selMaterial');
if(materialSelectorEl) materialSelectorEl.addEventListener('click', function(e){
  var b = e.target.closest('[data-material]'); if(!b || b.disabled) return;
  activateConfigMockups();
  var material = b.getAttribute('data-material');
  if(material==='canvas'){
    var canvasOption = FINS.find(function(option){ return option.k==='canvas'; });
    if(!canvasOption) return;
    if(S.fin!=='canvas') lastPaperFin = S.fin;
    S.fin = 'canvas';
  } else if(S.fin==='canvas') {
    var paperOption = FINS.find(function(option){ return option.k===lastPaperFin && option.k!=='canvas'; })
      || FINS.find(function(option){ return option.k==='filete'; })
      || FINS.find(function(option){ return option.k!=='canvas'; });
    if(!paperOption) return;
    S.fin = paperOption.k;
  }
  highlightMockup(); render(); simRun();
});
document.getElementById('selFin').addEventListener('click', function(e){
  var b = e.target.closest('[data-f]'); if(!b) return;
  activateConfigMockups();
  S.fin = b.getAttribute('data-f');
  if(b.hasAttribute('data-g')) S.glass = parseInt(b.getAttribute('data-g'),10) || 0;
  else if(!glassOK(S.fin)) S.glass = 0;
  highlightMockup(); render(); simRun();
  if(S.fin!=='canvas') lastPaperFin = S.fin;
  markPick('fin');
});
document.getElementById('selColor').addEventListener('click', function(e){
  var b = e.target.closest('[data-c]'); if(!b) return;
  activateConfigMockups();
  S.color = b.getAttribute('data-c');
  document.getElementById('labColor').textContent = colName(S.color).toLowerCase();
  highlightMockup(); render();
});
document.getElementById('selGlass').addEventListener('click', function(e){
  var b = e.target.closest('[data-g]'); if(!b) return;
  activateConfigMockups();
  S.glass = parseInt(b.getAttribute('data-g'),10);
  press(document.getElementById('selGlass'),'data-g', String(S.glass));
  highlightMockup(); render(); simRun();
});
var compStepsEl = document.getElementById('compSteps');
if (compStepsEl) compStepsEl.addEventListener('click', function(e){
  var b = e.target.closest('[data-c]'); if(!b) return;
  activateConfigMockups();
  S.comp = parseInt(b.getAttribute('data-c'),10); render();
});
document.getElementById('simBack').addEventListener('click', function(){
  document.querySelector('#pdp-c .sim').setAttribute('data-sim-step','furniture');
  requestAnimationFrame(function(){ updateVariantNav(document.getElementById('simMov')); });
});
document.getElementById('simMov').addEventListener('click', function(e){
  var b = e.target.closest('[data-m]'); if(!b) return;
  activateConfigMockups();
  S.mov = b.getAttribute('data-m'); S.larg = null;
  press(document.getElementById('simMov'),'data-m',S.mov);
  highlightMockup(); drawLarg(); simRun();
  document.querySelector('#pdp-c .sim').setAttribute('data-sim-step','width');
  document.getElementById('simLarg').scrollLeft = 0;
});
document.getElementById('simLarg').addEventListener('click', function(e){
  var b = e.target.closest('[data-l]'); if(!b || b.disabled) return;
  activateConfigMockups();
  S.larg = b.getAttribute('data-l');
  press(document.getElementById('simLarg'),'data-l',S.larg);
  var recommended = SIM[S.mov+'|'+S.larg];
  // Cada escolha de largura reaplica a recomendação, mesmo após um ajuste manual.
  // Não selecionar uma combinação que não exista no catálogo deste produto.
  if(SIZES.some(function(size){ return size.k === recommended; }) && priceFor(S.fin,recommended) != null){
    S.size = recommended;
    document.dispatchEvent(new CustomEvent('pdpc:size-change'));
  }
  highlightMockup(); render(); simRun(true);
});
document.getElementById('simOut').addEventListener('click', function(e){
  var b = e.target.closest('[data-apply]'); if(!b || b.disabled) return;
  activateConfigMockups();
  S.size = b.getAttribute('data-apply');
  document.dispatchEvent(new CustomEvent('pdpc:size-change'));
  highlightMockup(); render(); simRun();
  markPick('size');
  if(!window.matchMedia('(max-width:768px)').matches) document.getElementById('selSize').scrollIntoView({behavior:'smooth', block:'center'});
});
var revFEl = document.getElementById('revFilters');
if (revFEl) revFEl.addEventListener('click', function(e){
  var b = e.target.closest('[data-f]'); if(!b) return;
  press(document.getElementById('revFilters'),'data-f', b.getAttribute('data-f'));
  reviewsExpanded = false;
  drawRev(b.getAttribute('data-f'));
});
var revListEl = document.getElementById('revList');
if (revListEl) revListEl.addEventListener('click', function(e){
  if(!e.target.closest('#revMore')) return;
  reviewsExpanded = true;
  drawRev(reviewFilter);
});
var shareWhatsApp = document.getElementById('shareWhatsApp');
if(shareWhatsApp) shareWhatsApp.addEventListener('click', shareOnWhatsApp);
var saveCompositionButton = document.getElementById('saveComposition');
if(saveCompositionButton) saveCompositionButton.addEventListener('click', saveComposition);
document.getElementById('panel').addEventListener('click', function(e){ if(e.target === this) closePanel(); });

/* (toggles mobile/desktop e notas do protótipo removidos — viraram @media) */
(function(){
  var lb = null;
  function vclose(){ if(lb){ lb.remove(); lb = null; document.removeEventListener('keydown', vesc); } }
  function vesc(e){ if(e.key === 'Escape') vclose(); }
  pdpOn(document,'click', function(e){
    var v = e.target.closest('[data-vsrc],[data-yt]'); if(!v) return;
    if(!v.getAttribute('data-vsrc') && !v.getAttribute('data-yt')) return;
    vclose();
    lb = document.createElement('div');
    lb.className = 'goq-vlb' + (v.getAttribute('data-vert') === '1' ? ' vert' : '');
    var vsrc = v.getAttribute('data-vsrc') || '';
    var media = vsrc
      ? '<video src="' + vsrc + '" controls autoplay playsinline preload="metadata"></video>'
      : '<iframe src="https://www.youtube-nocookie.com/embed/' + v.getAttribute('data-yt') +
        '?autoplay=1&rel=0&playsinline=1" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    lb.innerHTML = '<div class="box"><button class="x" type="button" aria-label="Fechar">×</button>' + media + '</div>';
    lb.addEventListener('click', function(ev){ if (ev.target === lb || ev.target.closest('.x')) vclose(); });
    document.body.appendChild(lb);
    pdpOn(document,'keydown', vesc);
  }, false);
})();

/* No mobile, a D põe título e miniaturas antes da foto principal; a medida final
   fica em uma linha discreta abaixo da foto, junto do contexto do ambiente. O fluxo
   muda no próprio DOM, sem duplicar conteúdo, e os mesmos nós voltam ao lugar
   original no desktop. */
(function arrangeResponsiveHero(){
  /* [5d] Celular e computador na mesma ordem (vitrine, título e opções): nada muda de lugar. */
  var mq = window.matchMedia('(max-width: 768px)');
  function arrange(){
    document.querySelectorAll('#pdp-c details.mobile-collapse, #pdp-c details.mobile-question').forEach(function(detail){
      // O card "O que chega" do personalizado é onde a foto é enviada: fica sempre aberto
      detail.open = detail.classList.contains('sim') || detail.classList.contains('gqc-recebe') || !usesMobileControls();
    });
    if(S.comp!==1){ S.comp=1; render(); }
    else { drawFins(); drawSizes(); }
  }
  arrange();
  if(mq.addEventListener) pdpOn(mq,'change', arrange);
  else pdpLegacyMedia(mq,arrange);
})();

/* [5d] Cupom OFERTA10 (vale para qualquer compra): o botão aplica o código na sacola (cart/update.js { discount }), em
   vez de deixar o cliente copiar e caçar o campo no pagamento (Baymard: 83% das lojas não aplicam e
   muitos perdem o desconto). Com a sacola vazia, a Shopify guarda o cupom ("ainda não vale") e ele
   passa a valer quando o quadro entra; as regras do desconto a Shopify confere no pagamento. */
/* [28/10/2026] Igual ao CEP (pedido do Renan): com o cupom na sacola, o botão vira "Remover" (antes ficava
   travado em "Aplicado") e tira o cupom de lá; sem ele, volta para "Aplicar". */
function couponState(b, cart){
  var code = b.getAttribute('data-apply-coupon'), st = b.querySelector('.pd-coupon__st'), note = document.getElementById('couponNote');
  var entry = (cart.discount_codes || []).filter(function(d){ return String(d.code).toUpperCase() === code; })[0];
  b.disabled = false;
  b.classList.remove('is-copied');
  b.setAttribute('data-mode', entry ? 'remove' : 'apply');
  b.setAttribute('aria-label', (entry ? 'Remover o cupom ' + code + ' da sacola' : 'Aplicar o cupom ' + code + ' na sacola'));
  if(st) st.textContent = entry ? 'Remover' : 'Aplicar';
  if(!entry){ if(note) note.hidden = true; return false; }
  if(note){
    /* o percentual vem do data-coupon-pct do cupom (27/10/2026; a campanha pode trocar) */
    var pct = couponPct() ? String(couponPct()).replace('.', ',') + '%' : 'o desconto';
    note.hidden = false;
    note.textContent = !cart.item_count ? 'Cupom guardado: ' + (couponPct() ? 'os ' + pct + ' entram' : 'o desconto entra') + ' quando o quadro for para a sacola.'
      : (entry.applicable ? (couponPct() ? 'Os ' + pct + ' de desconto já estão na sua sacola.' : 'O desconto já está na sua sacola.') : 'O cupom está na sacola, mas não vale para os itens dela.');
  }
  return true;
}
/* [27/10/2026] Links do resumo: "ver em escala" abre a vista de escala na vitrine (e a traz para a tela);
   "calcular o prazo" leva ao campo do CEP. */
pdpOn(document,'click',function(e){
  var t = e.target && e.target.closest ? e.target : null; if(!t) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  if(t.closest('#pdp-c [data-resumo-escala]')){
    setGalSlide('escala');
    var g = document.getElementById('galMain');
    if(g){
      var r = g.getBoundingClientRect();
      if(r.top < 0 || r.bottom > window.innerHeight) g.scrollIntoView({behavior:motion, block:'center'});
    }
  } else if(t.closest('#pdp-c [data-resumo-cep]')){
    var input = document.getElementById('cepInput');
    if(input){ input.scrollIntoView({behavior:motion, block:'center'}); input.focus({preventScroll:true}); }
  }
});
pdpOn(document,'click',function(e){
  var b = e.target.closest('#pdp-c [data-apply-coupon]'); if(!b || b.disabled) return;
  var code = b.getAttribute('data-apply-coupon'), st = b.querySelector('.pd-coupon__st'), note = document.getElementById('couponNote');
  var removing = b.getAttribute('data-mode') === 'remove';
  b.disabled = true; if(st) st.textContent = removing ? 'Removendo…' : 'Aplicando…';
  withCart(function(){
    return cartJson('cart.js').then(function(cart){
      var codes = (cart.discount_codes || []).map(function(d){ return d.code; });
      var has = codes.some(function(c){ return String(c).toUpperCase() === code; });
      /* "Remover" manda a lista sem este cupom (os outros, se houver, ficam) */
      if(removing) return has ? cartJson('cart/update.js', {discount: codes.filter(function(c){ return String(c).toUpperCase() !== code; }).join(',')}) : cart;
      if(has) return cart;
      return cartJson('cart/update.js', {discount: codes.concat(code).join(',')});
    });
  }).then(function(cart){
    if(couponState(b, cart) === removing) throw new Error('cupom');
  }).catch(function(){
    b.disabled = false; if(st) st.textContent = removing ? 'Remover' : 'Aplicar';
    if(note){
      note.hidden = false;
      note.textContent = removing ? 'Não deu para remover agora. Tente de novo ou tire o cupom na sacola.' : 'Não deu para aplicar agora. Use o código ' + code + ' no pagamento.';
    }
  });
});
/* Volta à página com o cupom já na sacola: o botão abre como "Remover" */
(function(){
  var b = document.querySelector('#pdp-c [data-apply-coupon]'); if(!b) return;
  cartJson('cart.js').then(function(cart){ couponState(b, cart); }).catch(function(){});
})();
/* Linha da tabela de acabamentos lá embaixo: escolhe no painel de compra e leva até ele */
pdpOn(document,'click',function(e){
  var b = e.target.closest('[data-gq5-pick]'); if(!b) return;
  var card = document.querySelector('#selFin [data-f="' + b.getAttribute('data-fin') + '"][data-g="' + b.getAttribute('data-g') + '"]');
  if(!card || card.disabled) return;
  card.click();
  var target = document.getElementById('selFin');
  if(target) target.scrollIntoView({behavior:'smooth', block:'center'});
});

/* boot */
drawLarg(); render(); G3.booted = true; scheduleFit();
if(!PDP_CATEGORY_EMBED){ drawRevSum(); drawRev('all'); preloadShippingCep(); }
pdpRoot.setAttribute('data-pdp-ready','true');
(function(){
  // roda no DOMContentLoaded: este script vive dentro do <main>, e o rodapé do _base
  // só é parseado DEPOIS — no boot, querySelector('footer') ainda devolve null
  function initBar(){
    if(PDP_CATEGORY_EMBED) return;
    var bar = document.querySelector('#pdp-c .sticky'); if(!bar) return;
    // a barra só aparece com a vitrine (galeria + coluna de compra) toda fora da tela, no computador e
    // no celular (pedido do usuário em 15/10; antes bastava o botão principal sair da tela)
    var vitrine = document.querySelector('#pdp-c > .pdp');
    // sentinela próprio: o <footer id=footer> do _base é SUBSTITUÍDO pelo template
    // tp-footer depois do load — observá-lo direto deixava um observer órfão
    var foot = document.getElementById('pdpcEnd');
    // [22/10/2026] no celular a barra aparece desde o início (preço e botão na 1ª tela) e só sai enquanto o
    // botão principal (#ctaMain) ou o fim da página estão na tela.
    // [27/10/2026] no computador vale o mesmo (auditoria: "preço final e CTA não aparecem na primeira dobra"),
    // salvo com "Barra de compra no computador" = só depois da vitrine (data-barra="vitrine"), a regra de antes
    var cta = document.getElementById('ctaMain');
    var early = pdpRoot.getAttribute('data-barra') !== 'vitrine';
    var vitVis = true, footVis = false, ctaVis = false;
    function upd(){
      var show = !footVis && ((isPhone() || early) ? !ctaVis : !vitVis);
      bar.classList.toggle('off', !show);
      document.body.classList.toggle('goq-baron', show);
    }
    if ('IntersectionObserver' in window) {
      if (vitrine) new IntersectionObserver(function(en){ vitVis = en[0].isIntersecting; upd(); }).observe(vitrine);
      if (foot) new IntersectionObserver(function(en){ footVis = en[0].isIntersecting; upd(); }).observe(foot);
      if (cta) new IntersectionObserver(function(en){ ctaVis = en[0].isIntersecting; upd(); }).observe(cta);
    } else { vitVis = false; }
    if(PHONE.addEventListener) pdpOn(PHONE, 'change', upd); else pdpLegacyMedia(PHONE, upd);
    upd();
    /* a barra vem com "off is-boot" do HTML (sem pular no carregamento); daqui em diante, só o off decide */
    bar.classList.remove('is-boot');
  }
  if (document.readyState === 'loading') pdpOn(document,'DOMContentLoaded', initBar);
  else initBar();
})();

/* Mantém o iframe da categoria na altura exata do herói, inclusive depois de
   abrir seletores, trocar variações ou mudar o breakpoint. */
(function initCategoryEmbedHeight(){
  if(!PDP_CATEGORY_EMBED || window.parent === window) return;
  var root = document.getElementById('pdp-c');
  if(!root) return;
  var raf = 0;
  function publish(){
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function(){
      var height = Math.ceil(root.getBoundingClientRect().height);
      // O herói já foi inicializado; não esperar imagens e scripts das áreas ocultas.
      window.parent.postMessage({type:'goq:pdp-d-height',height:height,ready:true,url:window.location.href}, '*');
    });
  }
  pdpOn(window,'load', publish);
  pdpOn(window,'resize', publish, {passive:true});
  pdpOn(window,'message', function(event){
    if(event.data && event.data.type === 'goq:pdp-d-measure') publish();
  });
  if('ResizeObserver' in window) new ResizeObserver(publish).observe(root);
  publish();
})();
})();

